export default [
  //////////////////////////////////////////////////////////////////
  ///////////////////   SREDNJE SOLE   /////////////////////////////
  //////////////////////////////////////////////////////////////////

  {
    ZAVSIF: 10749,
    PRSMSS: 5088739001,
    NAZIV: 'Biotehniški center Naklo, Srednja šola',
    NASLOV: 'Strahinj 99',
    'POŠTNA ŠTEVILKA': 4202,
    POŠTA: 'Naklo',
    EMAIL: 'info@bc-naklo.si',
    URL: 'http://www.bc-naklo.si'
  },
  {
    ZAVSIF: 1256,
    PRSMSS: 5921724000,
    NAZIV: 'Ekonomska gimnazija in srednja šola Radovljica',
    NASLOV: 'Gorenjska cesta 13',
    'POŠTNA ŠTEVILKA': 4240,
    POŠTA: 'Radovljica',
    EMAIL: 'egss.radovljica@guest.arnes.si',
    URL: 'http://www.egss.si'
  },
  {
    ZAVSIF: 20157,
    PRSMSS: 6286186000,
    NAZIV: 'Gimnazija Franceta Prešerna',
    NASLOV: 'Kidričeva cesta 65',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'tajnistvo@gfp.si',
    URL: 'http://www.gfp.si'
  },
  {
    ZAVSIF: 1055,
    PRSMSS: 5854091000,
    NAZIV: 'Gimnazija Jesenice',
    NASLOV: 'Trg Toneta Čufarja 1',
    'POŠTNA ŠTEVILKA': 4270,
    POŠTA: 'Jesenice',
    EMAIL: 'info@gimjes.si',
    URL: 'http://www.gimjes.si'
  },
  {
    ZAVSIF: 17,
    PRSMSS: 5083923000,
    NAZIV: 'Gimnazija Kranj',
    NASLOV: 'Koroška cesta 13',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'gimnazija.kranj@guest.arnes.si',
    URL: 'http://www.gimkr.si'
  },
  {
    ZAVSIF: 65,
    PRSMSS: 5087864000,
    NAZIV: 'Gimnazija Škofja Loka',
    NASLOV: 'Podlubnik 1 B',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: 'info@gimnazija-skofjaloka.si',
    URL: 'http://www.gimnazija-skofjaloka.si'
  },
  {
    ZAVSIF: 1255,
    PRSMSS: 5921678000,
    NAZIV: 'Srednja gostinska in turistična šola Radovljica',
    NASLOV: 'Kranjska cesta 24',
    'POŠTNA ŠTEVILKA': 4240,
    POŠTA: 'Radovljica',
    EMAIL: 'info@sgtsr.si',
    URL: 'http://www.sgtsr.si'
  },
  {
    ZAVSIF: 1054,
    PRSMSS: 5854105000,
    NAZIV: 'Srednja šola Jesenice',
    NASLOV: 'Ulica bratov Rupar 2',
    'POŠTNA ŠTEVILKA': 4270,
    POŠTA: 'Jesenice',
    EMAIL: 'info@ssj-jesenice.si',
    URL: 'http://ssj-jesenice.si'
  },
  {
    ZAVSIF: 20134,
    PRSMSS: 6286259005,
    NAZIV:
      'Šolski center Kranj, Srednja ekonomska, storitvena in gradbena šola',
    NASLOV: 'Cesta Staneta Žagarja 33',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'info.sesgs@sckr.si',
    URL: 'http://www.sckr.si'
  },
  {
    ZAVSIF: 20163,
    PRSMSS: 6286259004,
    NAZIV: 'Šolski center Kranj, Srednja tehniška šola',
    NASLOV: 'Kidričeva cesta 55',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'info@sckr.si',
    URL: 'http://www.sckr.si'
  },
  {
    ZAVSIF: 20160,
    PRSMSS: 6286259003,
    NAZIV: 'Šolski center Kranj, Strokovna gimnazija',
    NASLOV: 'Kidričeva cesta 55',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'info@sckr.si',
    URL: 'http://www.sckr.si'
  },
  {
    ZAVSIF: 64,
    PRSMSS: 5087872004,
    NAZIV: 'Šolski center Škofja Loka, Srednja šola za lesarstvo',
    NASLOV: 'Kidričeva cesta 59',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: 'ssl@scsl.si',
    URL: 'http://www.scsl.si'
  },
  {
    ZAVSIF: 9886,
    PRSMSS: 5087872001,
    NAZIV: 'Šolski center Škofja Loka, Srednja šola za strojništvo',
    NASLOV: 'Podlubnik 1 B',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: 'maja.tolar@scsl.si',
    URL: 'http://www.s-sssl.kr.edus.si'
  },
  {
    ZAVSIF: 49,
    PRSMSS: 5085969000,
    NAZIV: 'Gimnazija Jurija Vege Idrija',
    NASLOV: 'Študentovska ulica 16',
    'POŠTNA ŠTEVILKA': 5280,
    POŠTA: 'Idrija',
    EMAIL: 'tajnistvo@gimidrija.si',
    URL: 'http://www.gim-idrija.si/'
  },
  {
    ZAVSIF: 98,
    PRSMSS: 5221161000,
    NAZIV: 'Gimnazija Nova Gorica',
    NASLOV: 'Delpinova ulica 9',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'tajnistvo@gimng.si',
    URL: 'http://www.gimng.si'
  },
  {
    ZAVSIF: 3320,
    PRSMSS: 5272661000,
    NAZIV: 'Gimnazija Tolmin',
    NASLOV: 'Dijaška ulica 12 B',
    'POŠTNA ŠTEVILKA': 5220,
    POŠTA: 'Tolmin',
    EMAIL: 'gimnazija.tolmin@gimtol.si',
    URL: 'http://www.gimnazija-tolmin.si'
  },
  {
    ZAVSIF: 37,
    PRSMSS: 5084997000,
    NAZIV: 'Srednja šola Veno Pilon Ajdovščina',
    NASLOV: 'Cesta 5. maja 12',
    'POŠTNA ŠTEVILKA': 5270,
    POŠTA: 'Ajdovščina',
    EMAIL: 'tajnistvo@ss-venopilon.si',
    URL: 'http://www.ss-venopilon.si'
  },
  {
    ZAVSIF: 639,
    PRSMSS: 5221749000,
    NAZIV: 'Škofijska gimnazija Vipava',
    NASLOV: 'Goriška cesta 29',
    'POŠTNA ŠTEVILKA': 5271,
    POŠTA: 'Vipava',
    EMAIL: 'sgv@siol.net',
    URL: 'http://www2.arnes.si/~gngskof1'
  },
  {
    ZAVSIF: 3734,
    PRSMSS: 5089085006,
    NAZIV: 'Šolski center Nova Gorica, Biotehniška šola',
    NASLOV: 'Ulica padlih borcev 26',
    'POŠTNA ŠTEVILKA': 5290,
    POŠTA: 'Šempeter pri Gorici',
    EMAIL: 'barbara.miklavcic@scng.si',
    URL: 'http://www.scng.si'
  },
  {
    ZAVSIF: 3844,
    PRSMSS: 5089085002,
    NAZIV: 'Šolski center Nova Gorica, Elektrotehniška in računalniška šola',
    NASLOV: 'Cankarjeva ulica 10',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'robert.persic@scng.si',
    URL: 'http://www.scng.si'
  },
  {
    ZAVSIF: 1301,
    PRSMSS: 5089085008,
    NAZIV: 'Šolski center Nova Gorica, Gimnazija in zdravstvena šola',
    NASLOV: 'Erjavčeva ulica 4 A',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'tatjana.mocnik@scng.si',
    URL: 'http://www.scng.si'
  },
  {
    ZAVSIF: 53,
    PRSMSS: 5089085010,
    NAZIV: 'Šolski center Nova Gorica, Srednja ekonomska in trgovska šola',
    NASLOV: 'Erjavčeva ulica 8',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'mateja.marc@scng.si',
    URL: 'http://www.setsng.si'
  },
  {
    ZAVSIF: 10789,
    PRSMSS: 5089085007,
    NAZIV: 'Šolski center Nova Gorica, Strojna, prometna in lesarska šola',
    NASLOV: 'Erjavčeva ulica 4 A',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'martina.sever@scng.si',
    URL: 'http://www.scng.si'
  },
  {
    ZAVSIF: 80,
    PRSMSS: 5089115000,
    NAZIV: 'Ekonomska šola Novo mesto',
    NASLOV: 'Ulica talcev 3 A',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'informacije@esnm.si',
    URL: 'http://www.esnm.si'
  },
  {
    ZAVSIF: 14775,
    PRSMSS: 5089115004,
    NAZIV: 'Ekonomska šola Novo mesto, Srednja šola in gimnazija',
    NASLOV: 'Ulica talcev 3 A',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'esnm@esnm.si',
    URL: 'http://www.esnm.si'
  },
  {
    ZAVSIF: 19672,
    PRSMSS: 6214312000,
    NAZIV: 'Gimnazija in srednja šola Kočevje',
    NASLOV: 'Ljubljanska cesta 12',
    'POŠTNA ŠTEVILKA': 1330,
    POŠTA: 'Kočevje',
    EMAIL: 'ss-giko.lj@guest.arnes.si',
    URL: 'http://www.gimnazija-kocevje.si'
  },
  {
    ZAVSIF: 81,
    PRSMSS: 5089131000,
    NAZIV: 'Gimnazija Novo mesto',
    NASLOV: 'Seidlova cesta 9',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'info@gimnm.org',
    URL: 'http://www.gimnm.org'
  },
  {
    ZAVSIF: 79,
    PRSMSS: 5089107000,
    NAZIV: 'Grm Novo mesto - center biotehnike in turizma',
    NASLOV: 'Sevno 13',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 's-sksgrm.nm@guest.arnes.si',
    URL: 'http://www.grm-nm.si/'
  },
  {
    ZAVSIF: 10769,
    PRSMSS: 5089107005,
    NAZIV:
      'Grm Novo mesto - center biotehnike in turizma, Kmetijska šola Grm in biotehniška gimnazija',
    NASLOV: 'Sevno 13',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 's-sksgrm.nm@guest.arnes.si',
    URL: 'http://www.grm-nm.si/'
  },
  {
    ZAVSIF: 82,
    PRSMSS: 5089107004,
    NAZIV:
      'Grm Novo mesto - center biotehnike in turizma, Srednja šola za gostinstvo in turizem',
    NASLOV: 'Ulica talcev 3',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 's-sksgrm.nm@guest.arnes.si',
    URL: 'http://www.grm-nm.si/'
  },
  {
    ZAVSIF: 48,
    PRSMSS: 5085934000,
    NAZIV: 'Srednja šola Črnomelj',
    NASLOV: 'Kidričeva ulica 18 A',
    'POŠTNA ŠTEVILKA': 8340,
    POŠTA: 'Črnomelj',
    EMAIL: 'ss.crnomelj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ssnmcr9'
  },
  {
    ZAVSIF: 1262,
    PRSMSS: 5258782000,
    NAZIV: 'Šolski center Novo mesto',
    NASLOV: 'Šegova ulica 112',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'info@sc-nm.si',
    URL: 'http://www.sc-nm.com'
  },
  {
    ZAVSIF: 1287,
    PRSMSS: 5258782001,
    NAZIV:
      'Šolski center Novo mesto, Srednja elektro šola in tehniška gimnazija',
    NASLOV: 'Šegova ulica 112',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'mateja.pavse@sc-nm.si',
    URL: 'http://www.sc-nm.com'
  },
  {
    ZAVSIF: 3722,
    PRSMSS: 5258782003,
    NAZIV:
      'Šolski center Novo mesto, Srednja gradbena, lesarska in vzgojiteljska šola',
    NASLOV: 'Šegova ulica 112',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'damjana.gruden@guest.arnes.si',
    URL: 'http://www.sc-nm.com'
  },
  {
    ZAVSIF: 1288,
    PRSMSS: 5258782002,
    NAZIV: 'Šolski center Novo mesto, Srednja strojna šola',
    NASLOV: 'Šegova ulica 112',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'sebastijan.breznjak@sc-nm.si',
    URL: 'http://www.sc-nm.com'
  },
  {
    ZAVSIF: 3723,
    PRSMSS: 5258782004,
    NAZIV: 'Šolski center Novo mesto, Srednja zdravstvena in kemijska šola',
    NASLOV: 'Šegova ulica 112',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'damjana.papez@guest.arnes.si',
    URL:
      'http://www.sc-nm.com/scnm/portal/zdravstvenokemijska/3338/sl-SI/DesktopDefault.aspx'
  },
  {
    ZAVSIF: 109,
    PRSMSS: 2345188000,
    NAZIV: 'Šolski center Ravne na Koroškem',
    NASLOV: 'Na gradu 4',
    'POŠTNA ŠTEVILKA': 2390,
    POŠTA: 'Ravne na Koroškem',
    EMAIL: 'scravne.gim@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 108,
    PRSMSS: 2345188001,
    NAZIV: 'Šolski center Ravne na Koroškem, Gimnazija',
    NASLOV: 'Na gradu 4',
    'POŠTNA ŠTEVILKA': 2390,
    POŠTA: 'Ravne na Koroškem',
    EMAIL: 'scravne.gim@guest.arnes.si',
    URL: 'http://www.gimnazija-ravne.si'
  },
  {
    ZAVSIF: 10809,
    PRSMSS: 2345188002,
    NAZIV: 'Šolski center Ravne na Koroškem, Srednja šola',
    NASLOV: 'Koroška cesta 10',
    'POŠTNA ŠTEVILKA': 2390,
    POŠTA: 'Ravne na Koroškem',
    EMAIL: 'ivanka.stopar@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 84,
    PRSMSS: 5089417000,
    NAZIV: 'Šolski center Slovenj Gradec',
    NASLOV: 'Koroška ulica 11',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'tajnistvo@sc-sg.si',
    URL: 'http://www.sc-sg.net/'
  },
  {
    ZAVSIF: 1298,
    PRSMSS: 5089417001,
    NAZIV: 'Šolski center Slovenj Gradec, Gimnazija',
    NASLOV: 'Gosposvetska cesta 2',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'gimnazija@sc-sg.si',
    URL: 'http://www.sc-sg.net/gimnazija'
  },
  {
    ZAVSIF: 19671,
    PRSMSS: 5089417007,
    NAZIV: 'Šolski center Slovenj Gradec, Srednja šola Slovenj Gradec in Muta',
    NASLOV: 'Koroška ulica 11',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'srednja.solasgmuta@sc-sg.si',
    URL: 'http://www.sc-sg.net/'
  },
  {
    ZAVSIF: 1299,
    PRSMSS: 5089417002,
    NAZIV: 'Šolski center Slovenj Gradec, Srednja zdravstvena šola',
    NASLOV: 'Gosposvetska cesta 2',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'zdravstvena@sc-sg.si',
    URL: 'http://www.sc-sg.net/zdravstvena'
  },
  {
    ZAVSIF: 61,
    PRSMSS: 5086892000,
    NAZIV: 'Gimnazija Antonio Sema Piran',
    NASLOV: 'Med vrtovi 8',
    'POŠTNA ŠTEVILKA': 6320,
    POŠTA: 'Portorož - Portorose',
    EMAIL: 'info@ginnasiosema.net',
    URL: 'http://www2.arnes.si/~gkpasp1s/index.html'
  },
  {
    ZAVSIF: 20111,
    PRSMSS: 6286127000,
    NAZIV: 'Gimnazija, elektro in pomorska šola Piran',
    NASLOV: 'Bolniška ulica 11',
    'POŠTNA ŠTEVILKA': 6330,
    POŠTA: 'Piran - Pirano',
    EMAIL: 'ravnatelj@geps.si',
    URL: 'http://www.geps.si'
  },
  {
    ZAVSIF: 14,
    PRSMSS: 5083885000,
    NAZIV: 'Gimnazija Gian Rinaldo Carli Koper',
    NASLOV: 'Gimnazijski trg 7',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'ginnasio.carli@guest.arnes.si',
    URL: 'http://www.ginnasio-carli.si'
  },
  {
    ZAVSIF: 13,
    PRSMSS: 5083869000,
    NAZIV: 'Gimnazija Koper',
    NASLOV: 'Cankarjeva ulica 2',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'info@gimnazija-koper.si',
    URL: 'http://www.gimnazija-koper.si'
  },
  {
    ZAVSIF: 71,
    PRSMSS: 5088712000,
    NAZIV: 'Srednja ekonomsko - poslovna šola Koper',
    NASLOV: 'Martinčev trg 3',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'info@seps.si',
    URL: 'http://www.seps.si'
  },
  {
    ZAVSIF: 20112,
    PRSMSS: 6285996000,
    NAZIV: 'Srednja šola Izola',
    NASLOV: 'Ulica Prekomorskih brigad 7',
    'POŠTNA ŠTEVILKA': 6310,
    POŠTA: 'Izola - Isola',
    EMAIL: 'sola@srednjasolaizola.si',
    URL: ''
  },
  {
    ZAVSIF: 15,
    PRSMSS: 5083893000,
    NAZIV: 'Srednja šola Pietro Coppo Izola',
    NASLOV: 'Zustovičeva ulica 6',
    'POŠTNA ŠTEVILKA': 6310,
    POŠTA: 'Izola - Isola',
    EMAIL: 'info@pietrocoppo.net',
    URL: ''
  },
  {
    ZAVSIF: 7,
    PRSMSS: 5083176000,
    NAZIV: 'Srednja tehniška šola Koper',
    NASLOV: 'Šmarska cesta 4 E',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'info@sts.si',
    URL: 'http://www.sts.si'
  },
  {
    ZAVSIF: 1,
    PRSMSS: 5009189000,
    NAZIV: 'Šolski center Srečka Kosovela Sežana',
    NASLOV: 'Stjenkova ulica 3',
    'POŠTNA ŠTEVILKA': 6210,
    POŠTA: 'Sežana',
    EMAIL: 'ss.srecko-kosovel@guest.arnes.si',
    URL: 'http://www.ss-sezana.si/'
  },
  {
    ZAVSIF: 14751,
    PRSMSS: 5009189004,
    NAZIV: 'Šolski center Srečka Kosovela Sežana, Gimnazija in ekonomska šola',
    NASLOV: 'Stjenkova ulica 3',
    'POŠTNA ŠTEVILKA': 6210,
    POŠTA: 'Sežana',
    EMAIL: 'ss.srecko-kosovel@guest.arnes.si',
    URL: 'http://www.ss-sezana.si/sss/'
  },
  {
    ZAVSIF: 26,
    PRSMSS: 5084571000,
    NAZIV: 'Biotehniški izobraževalni center Ljubljana',
    NASLOV: 'Ižanska cesta 10',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'bic@bic-lj.si',
    URL: 'http://www.bic-lj.si/'
  },
  {
    ZAVSIF: 1376,
    PRSMSS: 5084571001,
    NAZIV:
      'Biotehniški izobraževalni center Ljubljana, Gimnazija in veterinarska šola',
    NASLOV: 'Cesta v Mestni log 47',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'gvs@bic-lj.si',
    URL: 'http://www.bic-lj.si/'
  },
  {
    ZAVSIF: 3778,
    PRSMSS: 5084571002,
    NAZIV: 'Biotehniški izobraževalni center Ljubljana, Živilska šola',
    NASLOV: 'Ižanska cesta 10',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'zs@bic-lj.si',
    URL: 'http://www.bic-lj.si/zs'
  },
  {
    ZAVSIF: 9594,
    PRSMSS: 5049768002,
    NAZIV:
      'Center za izobraževanje, rehabilitacijo in usposabljanje Kamnik, Srednja šola',
    NASLOV: 'Novi trg 43 A',
    'POŠTNA ŠTEVILKA': 1241,
    POŠTA: 'Kamnik',
    EMAIL: 'tajnistvo@cirius-kamnik.si',
    URL: 'http://www.osp-zuim.lj.edus.si'
  },
  {
    ZAVSIF: 1359,
    PRSMSS: 1318861000,
    NAZIV: 'Ekonomska šola Ljubljana',
    NASLOV: 'Prešernova cesta 6',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@presernova.si',
    URL: 'http://www.presernova.si'
  },
  {
    ZAVSIF: 21,
    PRSMSS: 5084172000,
    NAZIV: 'Elektrotehniško-računalniška strokovna šola in gimnazija Ljubljana',
    NASLOV: 'Vegova ulica 4',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'uprava@vegova.si',
    URL: 'http://www.vegova.si'
  },
  {
    ZAVSIF: 11,
    PRSMSS: 5083451000,
    NAZIV: 'Gimnazija Bežigrad',
    NASLOV: 'Peričeva ulica 4',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@gimb.org',
    URL: 'http://www.gimb.org'
  },
  {
    ZAVSIF: 10829,
    PRSMSS: 5083451001,
    NAZIV: 'Gimnazija Bežigrad, Gimnazija',
    NASLOV: 'Peričeva ulica 4',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@gimb.org',
    URL: 'http://www.gimb.org'
  },
  {
    ZAVSIF: 10830,
    PRSMSS: 5083451002,
    NAZIV: 'Gimnazija Bežigrad, Mednarodna šola',
    NASLOV: 'Peričeva ulica 4',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@gimb.org',
    URL: 'http://www.gimb.org'
  },
  {
    ZAVSIF: 94,
    PRSMSS: 5178924000,
    NAZIV: 'Gimnazija in srednja šola Rudolfa Maistra Kamnik',
    NASLOV: 'Novi trg 41 A',
    'POŠTNA ŠTEVILKA': 1241,
    POŠTA: 'Kamnik',
    EMAIL: 'info@gssrm.si',
    URL: ''
  },
  {
    ZAVSIF: 1304,
    PRSMSS: 1214144000,
    NAZIV: 'Gimnazija Jožeta Plečnika Ljubljana',
    NASLOV: 'Šubičeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@gjp.si',
    URL: 'http://www.gjp.si'
  },
  {
    ZAVSIF: 23,
    PRSMSS: 5084202000,
    NAZIV: 'Gimnazija Ledina',
    NASLOV: 'Resljeva cesta 12',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@ledina.si',
    URL: 'http://www.ledina.si'
  },
  {
    ZAVSIF: 24,
    PRSMSS: 5084318000,
    NAZIV: 'Gimnazija Moste',
    NASLOV: 'Zaloška cesta 49',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'gimnazija.moste@guest.arnes.si',
    URL: 'http://www.gimoste.si'
  },
  {
    ZAVSIF: 102,
    PRSMSS: 5249619000,
    NAZIV: 'Gimnazija Poljane',
    NASLOV: 'Strossmayerjeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@gimnazija-poljane.com',
    URL: 'http://www.gimnazija-poljane.com'
  },
  {
    ZAVSIF: 36,
    PRSMSS: 5084962000,
    NAZIV: 'Gimnazija Šentvid',
    NASLOV: 'Prušnikova ulica 98',
    'POŠTNA ŠTEVILKA': 1210,
    POŠTA: 'Ljubljana - Šentvid',
    EMAIL: 'gimnazija@sentvid.org',
    URL: 'http://www.sentvid.org'
  },
  {
    ZAVSIF: 970,
    PRSMSS: 5671159000,
    NAZIV: 'Gimnazija Šiška',
    NASLOV: 'Aljaževa ulica 32',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'gimnazija.siska@guest.arnes.si',
    URL: 'http://www.s-gls.lj.edus.si'
  },
  {
    ZAVSIF: 25,
    PRSMSS: 5084563000,
    NAZIV: 'Gimnazija Vič',
    NASLOV: 'Tržaška cesta 72',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@gimvic.org',
    URL: 'http://www.gimvic.org'
  },
  {
    ZAVSIF: 16630,
    PRSMSS: 5088763000,
    NAZIV: 'Konservatorij za glasbo in balet Ljubljana',
    NASLOV: 'Ižanska cesta 12',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@kgbl.si',
    URL: 'http://www.kgbl.si'
  },
  {
    ZAVSIF: 73,
    PRSMSS: 5088763002,
    NAZIV:
      'Konservatorij za glasbo in balet Ljubljana, Srednja glasbena in baletna šola',
    NASLOV: 'Ižanska cesta 12',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@kgbl.si',
    URL: 'http://www.kgbl.si'
  },
  {
    ZAVSIF: 22,
    PRSMSS: 5084199000,
    NAZIV: 'Srednja ekonomska šola Ljubljana',
    NASLOV: 'Roška cesta 2',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@seslj.si',
    URL: 'http://www.seslj.si'
  },
  {
    ZAVSIF: 641,
    PRSMSS: 5653347000,
    NAZIV: 'Srednja frizerska šola Ljubljana',
    NASLOV: 'Litostrojska cesta 53',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'srednja-frizerska-sola@guest.arnes.si',
    URL: 'http://www.frizerska.si'
  },
  {
    ZAVSIF: 20,
    PRSMSS: 5084130000,
    NAZIV: 'Srednja gradbena, geodetska in okoljevarstvena šola Ljubljana',
    NASLOV: 'Dunajska cesta 102',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@sggos.si',
    URL: 'http://www.sggos.si'
  },
  {
    ZAVSIF: 55,
    PRSMSS: 5086671000,
    NAZIV: 'Srednja medijska in grafična šola Ljubljana',
    NASLOV: 'Pokopališka ulica 33',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@smgs.si',
    URL: 'http://arhiv.smgs.si/v2/'
  },
  {
    ZAVSIF: 88,
    PRSMSS: 5089883000,
    NAZIV: 'Srednja poklicna in strokovna šola Bežigrad-Ljubljana',
    NASLOV: 'Ptujska ulica 6',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@spssb.si',
    URL: 'http://www.spssb.si'
  },
  {
    ZAVSIF: 14749,
    PRSMSS: 5089883001,
    NAZIV:
      'Srednja poklicna in strokovna šola Bežigrad-Ljubljana, Srednja poklicna in strokovna šola Bežigrad',
    NASLOV: 'Ptujska ulica 6',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@spssb.si',
    URL: ''
  },
  {
    ZAVSIF: 30,
    PRSMSS: 5084750000,
    NAZIV: 'Srednja šola Domžale',
    NASLOV: 'Cesta talcev 12',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'tajnistvo.ssdomzale@guest.arnes.si',
    URL: 'http://www.ssdomzale.si/news.php'
  },
  {
    ZAVSIF: 9849,
    PRSMSS: 5084750005,
    NAZIV: 'Srednja šola Domžale, Gimnazija',
    NASLOV: 'Cesta talcev 12',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'gimnazija@ssdomzale.si',
    URL: 'http://www.ssdomzale.si/news.php'
  },
  {
    ZAVSIF: 9848,
    PRSMSS: 5084750004,
    NAZIV: 'Srednja šola Domžale, Poklicna in strokovna šola',
    NASLOV: 'Cesta talcev 12',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'strokovna@ssdomzale.si',
    URL: 'http://www.ssdomzale.si/news.php'
  },
  {
    ZAVSIF: 1289,
    PRSMSS: 5623685000,
    NAZIV: 'Srednja šola Josipa Jurčiča Ivančna Gorica',
    NASLOV: 'Cesta občine Hirschaid 3',
    'POŠTNA ŠTEVILKA': 1295,
    POŠTA: 'Ivančna Gorica',
    EMAIL: 'ravnatelj@ssjj.si',
    URL: 'http://www.ssjj.si'
  },
  {
    ZAVSIF: 1031,
    PRSMSS: 5631564000,
    NAZIV: 'Srednja šola tehniških strok Šiška',
    NASLOV: 'Litostrojska cesta 51',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@ssts.si',
    URL: 'http://www.ssts.si'
  },
  {
    ZAVSIF: 35,
    PRSMSS: 5084911000,
    NAZIV: 'Srednja šola za farmacijo, kozmetiko in zdravstvo',
    NASLOV: 'Zdravstvena pot 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'ssfkz@guest.arnes.si',
    URL: 'http://www.ssfkz.si'
  },
  {
    ZAVSIF: 33,
    PRSMSS: 5084890000,
    NAZIV: 'Srednja šola za gostinstvo in turizem v Ljubljani',
    NASLOV: 'Preglov trg 9',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@ssgtlj.si',
    URL: 'http://www.s-ssgt.lj.edus.si'
  },
  {
    ZAVSIF: 51,
    PRSMSS: 5086108000,
    NAZIV: 'Srednja šola za oblikovanje in fotografijo Ljubljana',
    NASLOV: 'Gosposka ulica 18',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.ssof@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ssof/index.htm'
  },
  {
    ZAVSIF: 54,
    PRSMSS: 5086647000,
    NAZIV: 'Srednja trgovska šola Ljubljana',
    NASLOV: 'Poljanska cesta 28 A',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@sts-ljubljana.si',
    URL: 'http://www.sts-ljubljana.si'
  },
  {
    ZAVSIF: 50,
    PRSMSS: 5086094000,
    NAZIV: 'Srednja upravno administrativna šola Ljubljana',
    NASLOV: 'Zdravstvena pot 10',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@suaslj.com',
    URL: 'http://www.suaslj.com'
  },
  {
    ZAVSIF: 34,
    PRSMSS: 5084903000,
    NAZIV: 'Srednja vzgojiteljska šola in gimnazija Ljubljana',
    NASLOV: 'Kardeljeva ploščad 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'ravnatelj@svsgl.si',
    URL: 'http://www.svsgl.si'
  },
  {
    ZAVSIF: 99,
    PRSMSS: 5242045000,
    NAZIV: 'Srednja zdravstvena šola Ljubljana',
    NASLOV: 'Poljanska cesta 61',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'szslj@guest.arnes.si',
    URL: 'http://www.srednjazdravstvenaljubljana.si'
  },
  {
    ZAVSIF: 3827,
    PRSMSS: 1430971000,
    NAZIV: 'Šolski center Ljubljana',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'solski-center.lj@guest.arnes.si',
    URL: 'http://www.sclj.si/'
  },
  {
    ZAVSIF: 23516,
    PRSMSS: 1430971007,
    NAZIV: 'Šolski center Ljubljana, Evropska šola Ljubljana',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: '',
    URL: ''
  },
  {
    ZAVSIF: 23515,
    PRSMSS: 1430971007,
    NAZIV: 'Šolski center Ljubljana, Evropska šola Ljubljana',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: '',
    URL: ''
  },
  {
    ZAVSIF: 3835,
    PRSMSS: 1430971001,
    NAZIV: 'Šolski center Ljubljana, Gimnazija Antona Aškerca',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'askercevagim@guest.arnes.si',
    URL: 'http://gimnazija.sclj.si/'
  },
  {
    ZAVSIF: 3837,
    PRSMSS: 1430971003,
    NAZIV: 'Šolski center Ljubljana, Srednja lesarska šola',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'spletna-stran.ssljles@guest.arnes.si',
    URL: 'http://www.lesarska.sclj.si/'
  },
  {
    ZAVSIF: 3838,
    PRSMSS: 1430971004,
    NAZIV: 'Šolski center Ljubljana, Srednja strojna in kemijska šola',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'projekt6.ssljstr@guest.arnes.si',
    URL: 'http://www.strojna.sclj.si/'
  },
  {
    ZAVSIF: 9,
    PRSMSS: 5083435000,
    NAZIV: 'Šolski center za pošto, ekonomijo in telekomunikacije Ljubljana',
    NASLOV: 'Celjska ulica 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'scpet@scpet.net',
    URL: 'http://www.scpet.net'
  },
  {
    ZAVSIF: 3816,
    PRSMSS: 5083435001,
    NAZIV:
      'Šolski center za pošto, ekonomijo in telekomunikacije Ljubljana, Srednja tehniška in strokovna šola',
    NASLOV: 'Celjska ulica 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'scpet@scpet.net',
    URL: 'http://www.scpet.net'
  },
  {
    ZAVSIF: 633,
    PRSMSS: 5502098000,
    NAZIV: 'Zavod sv. Frančiška Saleškega Gimnazija Želimlje',
    NASLOV: 'Želimlje 46',
    'POŠTNA ŠTEVILKA': 1291,
    POŠTA: 'Škofljica',
    EMAIL: 'zelimlje@zelimlje.si',
    URL: 'http://www.zelimlje.si/'
  },
  {
    ZAVSIF: 11009,
    PRSMSS: 5699827000,
    NAZIV: 'Zavod sv. Stanislava',
    NASLOV: 'Štula 23',
    'POŠTNA ŠTEVILKA': 1210,
    POŠTA: 'Ljubljana - Šentvid',
    EMAIL: 'info@stanislav.si',
    URL: 'http://www.stanislav.si'
  },
  {
    ZAVSIF: 1016,
    PRSMSS: 5699827001,
    NAZIV: 'Zavod sv. Stanislava, Škofijska klasična gimnazija',
    NASLOV: 'Štula 23',
    'POŠTNA ŠTEVILKA': 1210,
    POŠTA: 'Ljubljana - Šentvid',
    EMAIL: 'skg@stanislav.si',
    URL: 'http://skg.stanislav.si'
  },
  {
    ZAVSIF: 42,
    PRSMSS: 5085454000,
    NAZIV: 'Biotehniška šola Maribor',
    NASLOV: 'Vrbanska cesta 30',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@bts.si',
    URL: 'http://www.bts.si/'
  },
  {
    ZAVSIF: 21675,
    PRSMSS: 5365708001,
    NAZIV: 'DOBA EPIS, d.o.o., Srednja šola',
    NASLOV: 'Prešernova ulica 1',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'srednja@doba.si',
    URL: ''
  },
  {
    ZAVSIF: 3395,
    PRSMSS: 5085861000,
    NAZIV: 'Gimnazija in srednja kemijska šola Ruše',
    NASLOV: 'Šolska ulica 16',
    'POŠTNA ŠTEVILKA': 2342,
    POŠTA: 'Ruše',
    EMAIL: 'info@gimnazija-ruse.org',
    URL: 'http://www.gimnazija-ruse.org'
  },
  {
    ZAVSIF: 1360,
    PRSMSS: 1323318000,
    NAZIV: 'Gimnazija Ormož',
    NASLOV: 'Hardek 5 A',
    'POŠTNA ŠTEVILKA': 2270,
    POŠTA: 'Ormož',
    EMAIL: 'gimnazija.ormoz@guest.arnes.si',
    URL: 'http://www.s-gimorm.mb.edus.si'
  },
  {
    ZAVSIF: 1266,
    PRSMSS: 1636855000,
    NAZIV: 'Gimnazija Ptuj',
    NASLOV: 'Volkmerjeva cesta 15',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'info@gimptuj.net',
    URL: 'http://www.gimptuj.si'
  },
  {
    ZAVSIF: 76,
    PRSMSS: 5088917000,
    NAZIV: 'II. gimnazija Maribor',
    NASLOV: 'Trg Miloša Zidanška 1',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@druga.si',
    URL: 'http://www.s-dgm.mb.edus.si'
  },
  {
    ZAVSIF: 3,
    PRSMSS: 5081297000,
    NAZIV: 'III. gimnazija Maribor',
    NASLOV: 'Gosposvetska cesta 4',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tretja-mb@guest.arnes.si',
    URL: 'http://www.tretja.si'
  },
  {
    ZAVSIF: 41,
    PRSMSS: 5085438000,
    NAZIV: 'Izobraževalni center Piramida Maribor',
    NASLOV: 'Park mladih 3',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'ic-piramida.maribor@guest.arnes.si',
    URL: 'http://www.icp-mb.si'
  },
  {
    ZAVSIF: 3777,
    PRSMSS: 5085438001,
    NAZIV:
      'Izobraževalni center Piramida Maribor, Srednja šola za prehrano in živilstvo',
    NASLOV: 'Park mladih 3',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'ic-piramida.maribor@guest.arnes.si',
    URL: 'http://www.icp-mb.si'
  },
  {
    ZAVSIF: 92,
    PRSMSS: 5110246000,
    NAZIV: 'Konservatorij za glasbo in balet Maribor',
    NASLOV: 'Mladinska ulica 12',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@konservatorij-maribor.si',
    URL: 'http://www.sgbs-maribor.si'
  },
  {
    ZAVSIF: 21395,
    PRSMSS: 6669115000,
    NAZIV: 'Lesarska šola Maribor',
    NASLOV: 'Lesarska ulica 2',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@lesarska-sola-maribor.net',
    URL: 'http://www2.arnes.si/~ssmbles1s'
  },
  {
    ZAVSIF: 21397,
    PRSMSS: 6669115001,
    NAZIV: 'Lesarska šola Maribor, Srednja šola',
    NASLOV: 'Lesarska ulica 2',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@lesarska-sola-maribor.net',
    URL: 'http://www2.arnes.si/~ssmbles1s'
  },
  {
    ZAVSIF: 3389,
    PRSMSS: 5183120000,
    NAZIV: 'Prometna šola Maribor',
    NASLOV: 'Preradovičeva ulica 33',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo@prometna.net',
    URL: 'http://www.prometna.net'
  },
  {
    ZAVSIF: 9977,
    PRSMSS: 5183120003,
    NAZIV: 'Prometna šola Maribor, Srednja prometna šola in dijaški dom',
    NASLOV: 'Preradovičeva ulica 33',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo@prometna.net',
    URL: 'http://www.prometna.net'
  },
  {
    ZAVSIF: 44,
    PRSMSS: 5085535000,
    NAZIV: 'Prva gimnazija Maribor',
    NASLOV: 'Trg generala Maistra 1',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo@prva-gimnazija.org',
    URL: 'http://www.prva-gimnazija.org'
  },
  {
    ZAVSIF: 43,
    PRSMSS: 5085527000,
    NAZIV: 'Srednja ekonomska šola Maribor',
    NASLOV: 'Trg Borisa Kidriča 3',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@ses-mb.si',
    URL: 'http://www.ses-mb.si'
  },
  {
    ZAVSIF: 20775,
    PRSMSS: 6430856000,
    NAZIV: 'Srednja elektro-računalniška šola Maribor',
    NASLOV: 'Smetanova ulica 6',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'sers@sers.si',
    URL: 'http://www.sers.si'
  },
  {
    ZAVSIF: 89,
    PRSMSS: 5089930000,
    NAZIV: 'Srednja gradbena šola in gimnazija Maribor',
    NASLOV: 'Smetanova ulica 35',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'srgradbena-mb@guest.arnes.si',
    URL: 'http://www.gradbena.si'
  },
  {
    ZAVSIF: 3773,
    PRSMSS: 1429221000,
    NAZIV: 'Srednja šola Slovenska Bistrica',
    NASLOV: 'Ulica dr. Jožeta Pučnika 21',
    'POŠTNA ŠTEVILKA': 2310,
    POŠTA: 'Slovenska Bistrica',
    EMAIL: 'info@sssb.si',
    URL: 'http://www.ges-sb.si'
  },
  {
    ZAVSIF: 58,
    PRSMSS: 5086752000,
    NAZIV: 'Srednja šola za gostinstvo in turizem Maribor',
    NASLOV: 'Mladinska ulica 14 A',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'ss.gtmb@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ssmbgt3s'
  },
  {
    ZAVSIF: 56,
    PRSMSS: 5086736000,
    NAZIV: 'Srednja šola za oblikovanje Maribor',
    NASLOV: 'Park mladih 8',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'ss.oblikovanje@ssom.si',
    URL: 'http://www2.arnes.si/~ssplbele'
  },
  {
    ZAVSIF: 57,
    PRSMSS: 5086744000,
    NAZIV: 'Srednja trgovska šola Maribor',
    NASLOV: 'Mladinska ulica 14',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'trgovskasola@gmail.com',
    URL: 'http://www.trgovska.si'
  },
  {
    ZAVSIF: 74,
    PRSMSS: 5088895000,
    NAZIV: 'Srednja zdravstvena in kozmetična šola Maribor',
    NASLOV: 'Trg Miloša Zidanška 3',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo@szs.si',
    URL: 'http://www.szs.si'
  },
  {
    ZAVSIF: 104,
    PRSMSS: 5064678000,
    NAZIV: 'Šolski center Ptuj',
    NASLOV: 'Volkmerjeva cesta 19',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'oton.mlakar@scptuj.si',
    URL: 'http://www.scptuj.si'
  },
  {
    ZAVSIF: 1268,
    PRSMSS: 5064678003,
    NAZIV: 'Šolski center Ptuj, Biotehniška šola',
    NASLOV: 'Volkmerjeva cesta 19',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'marjan.horvat@guest.arnes.si',
    URL: 'http://www.scptuj.si'
  },
  {
    ZAVSIF: 1267,
    PRSMSS: 5064678002,
    NAZIV: 'Šolski center Ptuj, Ekonomska šola',
    NASLOV: 'Volkmerjeva cesta 19',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'darja.harb@scptuj.si',
    URL: 'http://www.scptuj.si'
  },
  {
    ZAVSIF: 1269,
    PRSMSS: 5064678004,
    NAZIV: 'Šolski center Ptuj, Elektro in računalniška šola',
    NASLOV: 'Volkmerjeva cesta 19',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'rajko.fajt@scptuj.si',
    URL: 'http://www.scptuj.si'
  },
  {
    ZAVSIF: 1270,
    PRSMSS: 5064678005,
    NAZIV: 'Šolski center Ptuj, Strojna šola',
    NASLOV: 'Volkmerjeva cesta 19',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'bojan.lampret@scptuj.si',
    URL: 'http://www.scptuj.si'
  },
  {
    ZAVSIF: 21396,
    PRSMSS: 6669107000,
    NAZIV: 'Tehniški šolski center Maribor',
    NASLOV: 'Zolajeva ulica 12',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@tscmb.si',
    URL: 'http://www.tscmb.si'
  },
  {
    ZAVSIF: 21398,
    PRSMSS: 6669107001,
    NAZIV: 'Tehniški šolski center Maribor, Srednja strojna šola',
    NASLOV: 'Zolajeva ulica 12',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@tscmb.si',
    URL: 'http://www.tscmb.si'
  },
  {
    ZAVSIF: 12989,
    PRSMSS: 5921449000,
    NAZIV: 'Zavod Antona Martina Slomška',
    NASLOV: 'Vrbanska cesta 30',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'zavod@slomskov-zavod.si',
    URL: ''
  },
  {
    ZAVSIF: 1303,
    PRSMSS: 5921449001,
    NAZIV:
      'Zavod Antona Martina Slomška, Škofijska gimnazija Antona Martina Slomška',
    NASLOV: 'Vrbanska cesta 30',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@skofijska.si',
    URL: 'http://www.slomskov-zavod.si'
  },
  {
    ZAVSIF: 85,
    PRSMSS: 5089794000,
    NAZIV: 'Biotehniška šola Rakičan',
    NASLOV: 'Lendavska ulica 3',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'bsrakican@guest.arnes.si',
    URL: 'http://www.solarakican.si'
  },
  {
    ZAVSIF: 19,
    PRSMSS: 5084067000,
    NAZIV: 'Dvojezična srednja šola Lendava',
    NASLOV: 'Kolodvorska ulica 2 E',
    'POŠTNA ŠTEVILKA': 9220,
    POŠTA: 'Lendava - Lendva',
    EMAIL: 'tajnistvo-dss.lendava@guest.arnes.si',
    URL: 'http://www.dssl.si/'
  },
  {
    ZAVSIF: 97,
    PRSMSS: 5216214000,
    NAZIV: 'Ekonomska šola Murska Sobota',
    NASLOV: 'Noršinska ulica 13',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'ekonomska.sola@s-es.ms.edus.si',
    URL: 'http://www.ekonomska-ms.si'
  },
  {
    ZAVSIF: 14769,
    PRSMSS: 5216214004,
    NAZIV: 'Ekonomska šola Murska Sobota, Srednja šola in gimnazija',
    NASLOV: 'Noršinska ulica 13',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'ekonomska.sola@s-es.ms.edus.si',
    URL: ''
  },
  {
    ZAVSIF: 27,
    PRSMSS: 5084652000,
    NAZIV: 'Gimnazija Franca Miklošiča Ljutomer',
    NASLOV: 'Prešernova ulica 34',
    'POŠTNA ŠTEVILKA': 9240,
    POŠTA: 'Ljutomer',
    EMAIL: 'info@gfml.si',
    URL: 'http://www.gfm-ljutomer.si'
  },
  {
    ZAVSIF: 106,
    PRSMSS: 5508541000,
    NAZIV: 'Gimnazija Murska Sobota',
    NASLOV: 'Šolsko naselje 12',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'tajnistvo.gim-ms@guest.arnes.si',
    URL: 'http://www.s-gms.ms.edus.si'
  },
  {
    ZAVSIF: 107,
    PRSMSS: 5508550000,
    NAZIV: 'Srednja poklicna in tehniška šola Murska Sobota',
    NASLOV: 'Šolsko naselje 12',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'ludvik.sukic@guest.arnes.si',
    URL: 'http://www.s-ssts.ms.edus.si'
  },
  {
    ZAVSIF: 31,
    PRSMSS: 5084784000,
    NAZIV: 'Srednja šola za gostinstvo in turizem Radenci',
    NASLOV: 'Mladinska ulica 5',
    'POŠTNA ŠTEVILKA': 9252,
    POŠTA: 'Radenci',
    EMAIL: 'sola@s-ssgtr.ms.edus.si',
    URL: 'http://www.s-ssgtr.ms.edus.si'
  },
  {
    ZAVSIF: 45,
    PRSMSS: 5085748000,
    NAZIV: 'Srednja zdravstvena šola Murska Sobota',
    NASLOV: 'Ulica dr. Vrbnjaka 2',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'ravnatelj@s-szs.ms.mss.edus.si',
    URL: 'http://www.szs-ms.si'
  },
  {
    ZAVSIF: 3780,
    PRSMSS: 1458558000,
    NAZIV: 'Ekonomska in trgovska šola Brežice',
    NASLOV: 'Bizeljska cesta 45',
    'POŠTNA ŠTEVILKA': 8250,
    POŠTA: 'Brežice',
    EMAIL: 'ss.trg-ekon-brezice@guest.arnes.si',
    URL: 'http://www.etrs.si/'
  },
  {
    ZAVSIF: 3812,
    PRSMSS: 1458558001,
    NAZIV: 'Ekonomska in trgovska šola Brežice, Poklicna in strokovna šola',
    NASLOV: 'Bizeljska cesta 45',
    'POŠTNA ŠTEVILKA': 8250,
    POŠTA: 'Brežice',
    EMAIL: 'ss.trg-ekon-brezice@guest.arnes.si',
    URL: 'http://www.etrs.si/'
  },
  {
    ZAVSIF: 3779,
    PRSMSS: 1458540000,
    NAZIV: 'Gimnazija Brežice',
    NASLOV: 'Trg izgnancev 14',
    'POŠTNA ŠTEVILKA': 8250,
    POŠTA: 'Brežice',
    EMAIL: 'gimnazija.brezice@guest.arnes.si',
    URL: 'http://www2.arnes.si/~sskkssb2s'
  },
  {
    ZAVSIF: 18,
    PRSMSS: 5083982000,
    NAZIV: 'Šolski center Krško - Sevnica',
    NASLOV: 'Cesta krških žrtev 131',
    'POŠTNA ŠTEVILKA': 8270,
    POŠTA: 'Krško',
    EMAIL: 'tajnistvo@sc-krsko.si',
    URL: 'http://www.sc-krsko.si/'
  },
  {
    ZAVSIF: 10127,
    PRSMSS: 5083982003,
    NAZIV: 'Šolski center Krško - Sevnica, Gimnazija Krško',
    NASLOV: 'Cesta krških žrtev 131',
    'POŠTNA ŠTEVILKA': 8270,
    POŠTA: 'Krško',
    EMAIL: 'erna.zupan@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 10107,
    PRSMSS: 5083982002,
    NAZIV:
      'Šolski center Krško - Sevnica, Srednja poklicna in strokovna šola Krško',
    NASLOV: 'Cesta krških žrtev 131',
    'POŠTNA ŠTEVILKA': 8270,
    POŠTA: 'Krško',
    EMAIL: 'joze.pavlovic@gmail.com',
    URL: ''
  },
  {
    ZAVSIF: 63,
    PRSMSS: 5083982001,
    NAZIV: 'Šolski center Krško - Sevnica, Srednja šola Sevnica',
    NASLOV: 'Savska cesta 2',
    'POŠTNA ŠTEVILKA': 8290,
    POŠTA: 'Sevnica',
    EMAIL: 'ss.sevnica@guest.arnes.si',
    URL: 'http://www.sc-krsko.si/index.php/sevnica'
  },
  {
    ZAVSIF: 86,
    PRSMSS: 5089808000,
    NAZIV: 'Srednja gozdarska in lesarska šola Postojna',
    NASLOV: 'Tržaška cesta 36',
    'POŠTNA ŠTEVILKA': 6230,
    POŠTA: 'Postojna',
    EMAIL: 'sgls.postojna@guest.arnes.si',
    URL: 'http://www.s-sgls.po.edus.si'
  },
  {
    ZAVSIF: 10309,
    PRSMSS: 5086957002,
    NAZIV: 'Šolski center Postojna, Gimnazija Ilirska Bistrica',
    NASLOV: 'Ulica IV. armije 1',
    'POŠTNA ŠTEVILKA': 6250,
    POŠTA: 'Ilirska Bistrica',
    EMAIL: 'gim.ilb@scpo.si',
    URL: 'http://www.ilb.scpo.si'
  },
  {
    ZAVSIF: 9858,
    PRSMSS: 5086957001,
    NAZIV: 'Šolski center Postojna, Srednja šola',
    NASLOV: 'Cesta v Staro vas 2',
    'POŠTNA ŠTEVILKA': 6230,
    POŠTA: 'Postojna',
    EMAIL: 'infoscpost@gmail.com',
    URL: 'http://www.scpo.si'
  },
  {
    ZAVSIF: 20113,
    PRSMSS: 6280684000,
    NAZIV: 'Ekonomska šola Celje',
    NASLOV: 'Kosovelova ulica 4',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@escelje.si',
    URL: 'http://www.escelje.si'
  },
  {
    ZAVSIF: 20132,
    PRSMSS: 6280684001,
    NAZIV: 'Ekonomska šola Celje, Gimnazija in srednja šola',
    NASLOV: 'Kosovelova ulica 4',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@escelje.si',
    URL: 'http://www.escelje.si'
  },
  {
    ZAVSIF: 4,
    PRSMSS: 5082625000,
    NAZIV: 'Gimnazija Celje - Center',
    NASLOV: 'Kosovelova ulica 1',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'info@gcc.si',
    URL: 'http://www.gcc.si/'
  },
  {
    ZAVSIF: 29,
    PRSMSS: 5084717000,
    NAZIV: 'I. gimnazija v Celju',
    NASLOV: 'Kajuhova ulica 2',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'info@prvagim.si',
    URL: 'http://www.s-prvgim.ce.edus.si'
  },
  {
    ZAVSIF: 23075,
    PRSMSS: 5365759020,
    NAZIV:
      'PRAH, Izobraževalni center, izobraževanje in usposabljanje d.o.o., Srednja strokovna in poklicna šola Rogaška Slatina-zasebna šola',
    NASLOV: 'Kidričeva ulica 28',
    'POŠTNA ŠTEVILKA': 3250,
    POŠTA: 'Rogaška Slatina',
    EMAIL: '',
    URL: ''
  },
  {
    ZAVSIF: 46,
    PRSMSS: 5085900000,
    NAZIV: 'Srednja šola za gostinstvo in turizem Celje',
    NASLOV: 'Kosovelova ulica 2',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'info@ssgt.si',
    URL: ''
  },
  {
    ZAVSIF: 12,
    PRSMSS: 5083621000,
    NAZIV: 'Srednja zdravstvena šola Celje',
    NASLOV: 'Ipavčeva ulica 10',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'info@szsce.si',
    URL: 'http://www.szsce.si'
  },
  {
    ZAVSIF: 1305,
    PRSMSS: 1201794000,
    NAZIV: 'Šola za hortikulturo in vizualne umetnosti Celje',
    NASLOV: 'Ljubljanska cesta 97',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@hvu.si',
    URL: 'http://www.hvu.si/'
  },
  {
    ZAVSIF: 9890,
    PRSMSS: 1201794001,
    NAZIV:
      'Šola za hortikulturo in vizualne umetnosti Celje, Srednja poklicna in strokovna šola',
    NASLOV: 'Ljubljanska cesta 97',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@hvu.si',
    URL: 'http://www.hvu.si/'
  },
  {
    ZAVSIF: 3731,
    PRSMSS: 5082692001,
    NAZIV: 'Šolski center Celje, Gimnazija Lava',
    NASLOV: 'Pot na Lavo 22',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'gl@sc-celje.si',
    URL: 'http://www.s-sc.ce.edus.si'
  },
  {
    ZAVSIF: 1297,
    PRSMSS: 5082692004,
    NAZIV:
      'Šolski center Celje, Srednja šola za gradbeništvo in varovanje okolja',
    NASLOV: 'Pot na Lavo 22',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'gr@sc-celje.si',
    URL: 'http://www.sc-celje.si/gr'
  },
  {
    ZAVSIF: 1296,
    PRSMSS: 5082692003,
    NAZIV:
      'Šolski center Celje, Srednja šola za kemijo, elektrotehniko in računalništvo',
    NASLOV: 'Pot na Lavo 22',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'ek@sc-celje.si',
    URL: 'http://www.s-sc.ce.edus.si'
  },
  {
    ZAVSIF: 68,
    PRSMSS: 5082692008,
    NAZIV:
      'Šolski center Celje, Srednja šola za storitvene dejavnosti in logistiko',
    NASLOV: 'Ljubljanska cesta 17',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'sdl@sc-celje.si',
    URL: 'http://www.sc-celje/si'
  },
  {
    ZAVSIF: 1295,
    PRSMSS: 5082692002,
    NAZIV:
      'Šolski center Celje, Srednja šola za strojništvo, mehatroniko in medije',
    NASLOV: 'Pot na Lavo 22',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'sm@sc-celje.si',
    URL: 'http://www.s-sc.ce.edus.si'
  },
  {
    ZAVSIF: 67,
    PRSMSS: 5087996000,
    NAZIV: 'Šolski center Rogaška Slatina',
    NASLOV: 'Steklarska ulica 1',
    'POŠTNA ŠTEVILKA': 3250,
    POŠTA: 'Rogaška Slatina',
    EMAIL: 'tajnistvo@scrs.si',
    URL: 'http://www.scrs.si'
  },
  {
    ZAVSIF: 9972,
    PRSMSS: 5052343001,
    NAZIV:
      'Šolski center Slovenske Konjice - Zreče, Gimnazija Slovenske Konjice',
    NASLOV: 'Tattenbachova ulica 2 A',
    'POŠTNA ŠTEVILKA': 3210,
    POŠTA: 'Slovenske Konjice',
    EMAIL: 'info-konjice-zrece@guest.arnes.si',
    URL: 'http://www.sc-konjice-zrece.si'
  },
  {
    ZAVSIF: 9973,
    PRSMSS: 5052343002,
    NAZIV:
      'Šolski center Slovenske Konjice - Zreče, Srednja poklicna in strokovna šola Zreče',
    NASLOV: 'Dravinjska cesta 1',
    'POŠTNA ŠTEVILKA': 3214,
    POŠTA: 'Zreče',
    EMAIL: 'info-konjice-zrece@guest.arnes.si',
    URL: 'http://www.sc-konjice-zrece.si'
  },
  {
    ZAVSIF: 1306,
    PRSMSS: 1214438000,
    NAZIV: 'Šolski center Šentjur',
    NASLOV: 'Cesta na kmetijsko šolo 9',
    'POŠTNA ŠTEVILKA': 3230,
    POŠTA: 'Šentjur',
    EMAIL: 'solski.center-sentjur@guest.arnes.si',
    URL: 'http://www.sc-c.si'
  },
  {
    ZAVSIF: 9850,
    PRSMSS: 1214438002,
    NAZIV: 'Šolski center Šentjur, Srednja poklicna in strokovna šola',
    NASLOV: 'Cesta na kmetijsko šolo 9',
    'POŠTNA ŠTEVILKA': 3230,
    POŠTA: 'Šentjur',
    EMAIL: 'solski.center-sentjur@guest.arnes.si',
    URL: 'http://www.sc-s.si'
  },
  {
    ZAVSIF: 3730,
    PRSMSS: 5243050005,
    NAZIV: 'Šolski center Velenje, Elektro in računalniška šola',
    NASLOV: 'Trg mladosti 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'ers@scv.si',
    URL: 'http://www.s-scv.ce.edus.si'
  },
  {
    ZAVSIF: 1291,
    PRSMSS: 5243050001,
    NAZIV: 'Šolski center Velenje, Gimnazija',
    NASLOV: 'Trg mladosti 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'gimnazija@scv.si',
    URL: 'http://www.s-scv.ce.edus.si'
  },
  {
    ZAVSIF: 1293,
    PRSMSS: 5243050003,
    NAZIV: 'Šolski center Velenje, Strojna šola',
    NASLOV: 'Trg mladosti 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'strojna@scv.si',
    URL: 'http://www.s-scv.ce.edus.si'
  },
  {
    ZAVSIF: 1292,
    PRSMSS: 5243050002,
    NAZIV: 'Šolski center Velenje, Šola za rudarstvo in varstvo okolja',
    NASLOV: 'Trg mladosti 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'rudarska@scv.si',
    URL: 'http://www.s-scv.ce.edus.si'
  },
  {
    ZAVSIF: 1294,
    PRSMSS: 5243050004,
    NAZIV: 'Šolski center Velenje, Šola za storitvene dejavnosti',
    NASLOV: 'Trg mladosti 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'storitvena@scv.si',
    URL: 'http://www.s-scv.ce.edus.si'
  },
  {
    ZAVSIF: 91,
    PRSMSS: 5090202000,
    NAZIV: 'Gimnazija in ekonomska srednja šola Trbovlje',
    NASLOV: 'Gimnazijska cesta 10',
    'POŠTNA ŠTEVILKA': 1420,
    POŠTA: 'Trbovlje',
    EMAIL: 'tajnistvo@gess.si',
    URL: 'http://www.gess.si'
  },
  {
    ZAVSIF: 1286,
    PRSMSS: 1201379000,
    NAZIV: 'Gimnazija Litija',
    NASLOV: 'Bevkova ulica 1 C',
    'POŠTNA ŠTEVILKA': 1270,
    POŠTA: 'Litija',
    EMAIL: 'tajnistvo@gimnazija-litija.si',
    URL: 'http://www2.arnes.si/~ssljgiml'
  },
  {
    ZAVSIF: 3299,
    PRSMSS: 5263603000,
    NAZIV: 'Srednja šola Zagorje',
    NASLOV: 'Cesta zmage 5',
    'POŠTNA ŠTEVILKA': 1410,
    POŠTA: 'Zagorje ob Savi',
    EMAIL: 'ss.zagorje@guest.arnes.si',
    URL: 'http://www.sszagorje.si'
  },
  {
    ZAVSIF: 100,
    PRSMSS: 5243297000,
    NAZIV: 'Srednja tehniška in poklicna šola Trbovlje',
    NASLOV: 'Šuštarjeva kolonija 7 A',
    'POŠTNA ŠTEVILKA': 1420,
    POŠTA: 'Trbovlje',
    EMAIL: 'tajnistvo@stps-trbovlje.si',
    URL: 'http://www.s-stps.tb.edus.si/'
  },

  //////////////////////////////////////////////////////////////////
  ///////////////////   OSNOVNE SOLE   /////////////////////////////
  //////////////////////////////////////////////////////////////////

  {
    ZAVSIF: 121,
    PRSMSS: 5082544000,
    NAZIV: 'Osnovna šola Col',
    NASLOV: 'Col 35',
    'POŠTNA ŠTEVILKA': 5273,
    POŠTA: 'Col',
    EMAIL: 'info@os-col.si',
    URL: 'http://www.os-col.si'
  },
  {
    ZAVSIF: 118,
    PRSMSS: 5082528000,
    NAZIV: 'Osnovna šola Danila Lokarja Ajdovščina',
    NASLOV: 'Cesta 5. maja 15',
    'POŠTNA ŠTEVILKA': 5270,
    POŠTA: 'Ajdovščina',
    EMAIL: 'os.dl-ajdovscina@guest.arnes.si',
    URL: 'http://www.os-ajdovscina.si/'
  },
  {
    ZAVSIF: 115,
    PRSMSS: 5085888000,
    NAZIV: 'Osnovna šola Dobravlje',
    NASLOV: 'Dobravlje 1',
    'POŠTNA ŠTEVILKA': 5263,
    POŠTA: 'Dobravlje',
    EMAIL: 'o-dobravlje.ng@guest.arnes.si',
    URL: 'http://www.os-dobravlje.si'
  },
  {
    ZAVSIF: 117,
    PRSMSS: 5082536000,
    NAZIV: 'Osnovna šola Otlica',
    NASLOV: 'Otlica 48',
    'POŠTNA ŠTEVILKA': 5270,
    POŠTA: 'Ajdovščina',
    EMAIL: 'o-otlica.ng@guest.arnes.si',
    URL: 'http://www.os-otlica.si/'
  },
  {
    ZAVSIF: 10609,
    PRSMSS: 2294460000,
    NAZIV: 'Osnovna šola Šturje, Ajdovščina',
    NASLOV: 'Bevkova ulica 22',
    'POŠTNA ŠTEVILKA': 5270,
    POŠTA: 'Ajdovščina',
    EMAIL: 'tajnistvo@os-sturje.si',
    URL: 'http://www.os-sturje.si/'
  },
  {
    ZAVSIF: 22415,
    PRSMSS: 7085761000,
    NAZIV: 'Osnovna šola in vrtec Ankaran',
    NASLOV: 'Regentova ulica 4',
    'POŠTNA ŠTEVILKA': 6280,
    POŠTA: 'Ankaran - Ancarano',
    EMAIL: 'info@osv-ankaran.si',
    URL: 'http://www.osv-ankaran.si'
  },
  {
    ZAVSIF: 177,
    PRSMSS: 5084768000,
    NAZIV: 'Osnovna šola in vrtec Apače',
    NASLOV: 'Apače 38',
    'POŠTNA ŠTEVILKA': 9253,
    POŠTA: 'Apače',
    EMAIL: 'o-apace.ms@guest.arnes.si',
    URL: 'http://www.os-apace.si'
  },
  {
    ZAVSIF: 351,
    PRSMSS: 5085560000,
    NAZIV: 'Osnovna šola Beltinci',
    NASLOV: 'Panonska ulica 35 B',
    'POŠTNA ŠTEVILKA': 9231,
    POŠTA: 'Beltinci',
    EMAIL: 'o-beltinci.ms@guest.arnes.si',
    URL: 'http://www.o-beltinci.ms.edus.si'
  },
  {
    ZAVSIF: 249,
    PRSMSS: 5084032000,
    NAZIV: 'Osnovna šola Benedikt',
    NASLOV: 'Šolska ulica 2',
    'POŠTNA ŠTEVILKA': 2234,
    POŠTA: 'Benedikt',
    EMAIL: 'info@os-benedikt.si',
    URL: 'http://www.os-benedikt.si'
  },
  {
    ZAVSIF: 502,
    PRSMSS: 5087902000,
    NAZIV: 'Osnovna šola Bistrica ob Sotli',
    NASLOV: 'Bistrica ob Sotli 63 A',
    'POŠTNA ŠTEVILKA': 3256,
    POŠTA: 'Bistrica ob Sotli',
    EMAIL: 'o-bos.ce@guest.arnes.si',
    URL: 'http://www.osbistricaobsotli.si'
  },
  {
    ZAVSIF: 436,
    PRSMSS: 5087295000,
    NAZIV: 'Osnovna šola prof. dr. Josipa Plemlja Bled',
    NASLOV: 'Seliška cesta 3',
    'POŠTNA ŠTEVILKA': 4260,
    POŠTA: 'Bled',
    EMAIL: 'os-bled@guest.arnes.si',
    URL: 'http://www.os-bled.si/default.aspx'
  },
  {
    ZAVSIF: 146,
    PRSMSS: 5082749000,
    NAZIV: 'Osnovna šola Toneta Šraja Aljoše',
    NASLOV: 'Nova vas 4 B',
    'POŠTNA ŠTEVILKA': 1385,
    POŠTA: 'Nova Vas',
    EMAIL: 'milena.misic@guest.arnes.si',
    URL: 'http://242.gvs.arnes.si/'
  },
  {
    ZAVSIF: 437,
    PRSMSS: 5087309000,
    NAZIV: 'Osnovna šola dr. Janeza Mencingerja Bohinjska Bistrica',
    NASLOV: 'Savska cesta 10',
    'POŠTNA ŠTEVILKA': 4264,
    POŠTA: 'Bohinjska Bistrica',
    EMAIL: 'os-bohinj@guest.arnes.si',
    URL: 'http://www.osnovna-sola-bohinj.si'
  },
  {
    ZAVSIF: 535,
    PRSMSS: 5088321000,
    NAZIV: 'Osnovna šola dr. Ivana Korošca Borovnica',
    NASLOV: 'Paplerjeva ulica 15',
    'POŠTNA ŠTEVILKA': 1353,
    POŠTA: 'Borovnica',
    EMAIL: 'os-borovnica@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljikbo1s/sola.html'
  },
  {
    ZAVSIF: 510,
    PRSMSS: 5090091000,
    NAZIV: 'Osnovna šola Bovec',
    NASLOV: 'Trg golobarskih žrtev 17',
    'POŠTNA ŠTEVILKA': 5230,
    POŠTA: 'Bovec',
    EMAIL: 'os.bovec@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osngbo1s/'
  },
  {
    ZAVSIF: 552,
    PRSMSS: 5088496000,
    NAZIV: 'Osnovna šola Braslovče',
    NASLOV: 'Rakovlje 15 B',
    'POŠTNA ŠTEVILKA': 3314,
    POŠTA: 'Braslovče',
    EMAIL: 'sola_braslovce@osbraslovce.si',
    URL: 'http://www.osbraslovce.si'
  },
  {
    ZAVSIF: 362,
    PRSMSS: 5089000000,
    NAZIV: 'Osnovna šola Alojza Gradnika Dobrovo',
    NASLOV: 'Trg 25. maja 9',
    'POŠTNA ŠTEVILKA': 5212,
    POŠTA: 'Dobrovo v Brdih',
    EMAIL: 'os.dobrovo@guest.arnes.si',
    URL: 'http://www.os-dobrovo.si'
  },
  {
    ZAVSIF: 322,
    PRSMSS: 5089646000,
    NAZIV: 'Osnovna šola Brezovica pri Ljubljani',
    NASLOV: 'Šolska ulica 15',
    'POŠTNA ŠTEVILKA': 1351,
    POŠTA: 'Brezovica pri Ljubljani',
    EMAIL: 'info@osbrezovica.si',
    URL: 'http://www.osbrezovica.si/'
  },
  {
    ZAVSIF: 323,
    PRSMSS: 5084474000,
    NAZIV: 'Osnovna šola Preserje',
    NASLOV: 'Preserje 60',
    'POŠTNA ŠTEVILKA': 1352,
    POŠTA: 'Preserje',
    EMAIL: 'os.preserje@guest.arnes.si',
    URL: 'http://www.ospreserje.si/'
  },
  {
    ZAVSIF: 124,
    PRSMSS: 5083559000,
    NAZIV: 'Osnovna šola Artiče',
    NASLOV: 'Artiče 39',
    'POŠTNA ŠTEVILKA': 8253,
    POŠTA: 'Artiče',
    EMAIL: 'o-artice.nm@guest.arnes.si',
    URL: 'http://www.osartice.si'
  },
  {
    ZAVSIF: 601,
    PRSMSS: 5088607000,
    NAZIV: 'Osnovna šola Bizeljsko',
    NASLOV: 'Bizeljska cesta 78',
    'POŠTNA ŠTEVILKA': 8259,
    POŠTA: 'Bizeljsko',
    EMAIL: 'os-bizeljsko@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskkbiz2/'
  },
  {
    ZAVSIF: 122,
    PRSMSS: 5085896000,
    NAZIV: 'Osnovna šola Brežice',
    NASLOV: 'Levstikova ulica 18',
    'POŠTNA ŠTEVILKA': 8250,
    POŠTA: 'Brežice',
    EMAIL: 'o-brezice.nm@guest.arnes.si',
    URL: 'http://www.osbrezice.si'
  },
  {
    ZAVSIF: 129,
    PRSMSS: 5083575000,
    NAZIV: 'Osnovna šola Cerklje ob Krki',
    NASLOV: 'Cerklje ob Krki 3',
    'POŠTNA ŠTEVILKA': 8263,
    POŠTA: 'Cerklje ob Krki',
    EMAIL: 'sola@cerkljeobkrki.si',
    URL: 'http://sola.cerkljeobkrki.si'
  },
  {
    ZAVSIF: 127,
    PRSMSS: 5082579000,
    NAZIV: 'Osnovna šola dr. Jožeta Toporišiča Dobova',
    NASLOV: 'Kapelska cesta 25',
    'POŠTNA ŠTEVILKA': 8257,
    POŠTA: 'Dobova',
    EMAIL: 'oskkdo2s@guest.arnes.si',
    URL: 'http://www.osdobova.si'
  },
  {
    ZAVSIF: 125,
    PRSMSS: 5082587000,
    NAZIV: 'Osnovna šola Globoko',
    NASLOV: 'Globoko 9',
    'POŠTNA ŠTEVILKA': 8254,
    POŠTA: 'Globoko',
    EMAIL: 'os.globoko@guest.arnes.si',
    URL: 'http://www.os-globoko.si'
  },
  {
    ZAVSIF: 126,
    PRSMSS: 5082595000,
    NAZIV: 'Osnovna šola Maksa Pleteršnika Pišece',
    NASLOV: 'Pišece 34',
    'POŠTNA ŠTEVILKA': 8255,
    POŠTA: 'Pišece',
    EMAIL: 'o-pisece.nm@guest.arnes.si',
    URL: 'http://ospisece.si'
  },
  {
    ZAVSIF: 128,
    PRSMSS: 5083583000,
    NAZIV: 'Osnovna šola Velika Dolina',
    NASLOV: 'Velika Dolina 30',
    'POŠTNA ŠTEVILKA': 8261,
    POŠTA: 'Jesenice na Dolenjskem',
    EMAIL: 'florijan.bergant@guest.arnes.si',
    URL: 'http://www.osvelikadolina.si'
  },
  {
    ZAVSIF: 353,
    PRSMSS: 5085608000,
    NAZIV: 'Osnovna šola Cankova',
    NASLOV: 'Cankova 27',
    'POŠTNA ŠTEVILKA': 9261,
    POŠTA: 'Cankova',
    EMAIL: 'zbornica-oscankova@guest.arnes.si',
    URL: 'http://www.oscankova.si/'
  },
  {
    ZAVSIF: 134,
    PRSMSS: 5082609000,
    NAZIV: 'I. osnovna šola Celje',
    NASLOV: 'Vrunčeva ulica 13',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@iosce.si',
    URL: 'http://www.iosce.si/'
  },
  {
    ZAVSIF: 135,
    PRSMSS: 5082617000,
    NAZIV: 'II. osnovna šola Celje',
    NASLOV: 'Ljubljanska cesta 46',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'tajnistvo@slander.si',
    URL: 'http://www.slander.si'
  },
  {
    ZAVSIF: 136,
    PRSMSS: 5083613000,
    NAZIV: 'III. osnovna šola Celje',
    NASLOV: 'Vodnikova ulica 4',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'info@3os-celje.si',
    URL: 'http://www.3os-celje.si'
  },
  {
    ZAVSIF: 133,
    PRSMSS: 5082633000,
    NAZIV: 'IV. osnovna šola Celje',
    NASLOV: 'Dečkova cesta 60',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'o-4os.ce@guest.arnes.si',
    URL: 'http://www.o-4os.ce.edus.si/page1.htm'
  },
  {
    ZAVSIF: 132,
    PRSMSS: 5082641000,
    NAZIV: 'Osnovna šola Frana Kranjca',
    NASLOV: 'Hrašovčeva ulica 1',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'group1.oscefk@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oscefk1s/fk.htm'
  },
  {
    ZAVSIF: 137,
    PRSMSS: 5186650000,
    NAZIV: 'Osnovna šola Frana Roša Celje',
    NASLOV: 'Cesta na Dobrovo 114',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'projekt2.oscefr@guest.arnes.si',
    URL: 'http://www.os-frana-rosa.si/'
  },
  {
    ZAVSIF: 130,
    PRSMSS: 5082650000,
    NAZIV: 'Osnovna šola Hudinja',
    NASLOV: 'Mariborska cesta 125',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'o-hudinja.ce@guest.arnes.si',
    URL: 'http://www.hudinja.si/'
  },
  {
    ZAVSIF: 131,
    PRSMSS: 5062799000,
    NAZIV: 'Osnovna šola Lava Celje',
    NASLOV: 'Pucova ulica 7',
    'POŠTNA ŠTEVILKA': 3000,
    POŠTA: 'Celje',
    EMAIL: 'o-lava.ce@guest.arnes.si',
    URL: 'http://www.oslava.si'
  },
  {
    ZAVSIF: 1341,
    PRSMSS: 1262823000,
    NAZIV: 'Osnovna šola Ljubečna',
    NASLOV: 'Kocbekova cesta 40 A',
    'POŠTNA ŠTEVILKA': 3202,
    POŠTA: 'Ljubečna',
    EMAIL: 'tajnistvo@os-ljubecna.si',
    URL: 'http://www.os-ljubecna.si'
  },
  {
    ZAVSIF: 232,
    PRSMSS: 5086027000,
    NAZIV: 'Osnovna šola Davorina Jenka Cerklje na Gorenjskem',
    NASLOV: 'Krvavška cesta 4',
    'POŠTNA ŠTEVILKA': 4207,
    POŠTA: 'Cerklje na Gorenjskem',
    EMAIL: 'group1.oskrjenko@guest.arnes.si',
    URL: 'http://www.osdj-cerklje.si'
  },
  {
    ZAVSIF: 145,
    PRSMSS: 5082757000,
    NAZIV: 'Osnovna šola Jožeta Krajca Rakek',
    NASLOV: 'Partizanska cesta 28',
    'POŠTNA ŠTEVILKA': 1381,
    POŠTA: 'Rakek',
    EMAIL: 'os.rakek@guest.arnes.si',
    URL: 'http://www.osrakek.si/'
  },
  {
    ZAVSIF: 144,
    PRSMSS: 5082722000,
    NAZIV: 'Osnovna šola Notranjski odred Cerknica',
    NASLOV: 'Cesta 4. maja 92',
    'POŠTNA ŠTEVILKA': 1380,
    POŠTA: 'Cerknica',
    EMAIL: 'OS.NO-Cerknica@guest.arnes.si',
    URL: 'http://www.os-cerknica.si'
  },
  {
    ZAVSIF: 189,
    PRSMSS: 5082960000,
    NAZIV: 'Osnovna šola Cerkno',
    NASLOV: 'Bevkova ulica 26',
    'POŠTNA ŠTEVILKA': 5282,
    POŠTA: 'Cerkno',
    EMAIL: 'ifo@os-cerkno.si',
    URL: 'http://www.os-cerkno.si/'
  },
  {
    ZAVSIF: 251,
    PRSMSS: 5084016000,
    NAZIV: 'Osnovna šola Cerkvenjak - Vitomarci',
    NASLOV: 'Cerkvenjak 34',
    'POŠTNA ŠTEVILKA': 2236,
    POŠTA: 'Cerkvenjak',
    EMAIL: 'os.cerkvenjak@siol.net',
    URL: 'http://www.o-cerkvenjak.mb.edus.si/'
  },
  {
    ZAVSIF: 418,
    PRSMSS: 5089247000,
    NAZIV: 'Osnovna šola Cirkulane - Zavrč',
    NASLOV: 'Cirkulane 57',
    'POŠTNA ŠTEVILKA': 2282,
    POŠTA: 'Cirkulane',
    EMAIL: 'mboscir2s@guest.arnes.si',
    URL: 'http://www.cirkulane-zavrc.si'
  },
  {
    ZAVSIF: 260,
    PRSMSS: 5089697000,
    NAZIV: 'Osnovna šola Franceta Prešerna Črenšovci',
    NASLOV: 'Ulica Juša Kramarja 10',
    'POŠTNA ŠTEVILKA': 9232,
    POŠTA: 'Črenšovci',
    EMAIL: 'o-fpcrensovci.ms@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 1351,
    PRSMSS: 5089751000,
    NAZIV: 'Osnovna šola Prežihovega Voranca Bistrica',
    NASLOV: 'Srednja Bistrica 49 B',
    'POŠTNA ŠTEVILKA': 9232,
    POŠTA: 'Črenšovci',
    EMAIL: 'opvbistricams@guest.arnes.si',
    URL: 'http://www2.arnes.si/~opvbistricams/'
  },
  {
    ZAVSIF: 444,
    PRSMSS: 5087368000,
    NAZIV: 'Osnovna šola Črna na Koroškem',
    NASLOV: 'Center 142',
    'POŠTNA ŠTEVILKA': 2393,
    POŠTA: 'Črna na Koroškem',
    EMAIL: 'o-crna.mb@guest.arnes.si',
    URL: 'http://www.os-crna.si'
  },
  {
    ZAVSIF: 155,
    PRSMSS: 5082773000,
    NAZIV: 'Osnovna šola Komandanta Staneta Dragatuš',
    NASLOV: 'Dragatuš 48',
    'POŠTNA ŠTEVILKA': 8343,
    POŠTA: 'Dragatuš',
    EMAIL: 'tajnistvo@os-dragatus.si',
    URL: 'http://www.os-dragatus.si/'
  },
  {
    ZAVSIF: 151,
    PRSMSS: 5289211000,
    NAZIV: 'Osnovna šola Loka Črnomelj',
    NASLOV: 'Kidričeva ulica 18',
    'POŠTNA ŠTEVILKA': 8340,
    POŠTA: 'Črnomelj',
    EMAIL: 'info@os-loka-crnomelj.si',
    URL: 'http://www.os-loka-crnomelj.si/'
  },
  {
    ZAVSIF: 150,
    PRSMSS: 5082765000,
    NAZIV: 'Osnovna šola Mirana Jarca Črnomelj',
    NASLOV: 'Ulica Otona Župančiča 8',
    'POŠTNA ŠTEVILKA': 8340,
    POŠTA: 'Črnomelj',
    EMAIL: 'os-mjarc.crnomelj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osnmmj1s/'
  },
  {
    ZAVSIF: 154,
    PRSMSS: 5086477000,
    NAZIV: 'Osnovna šola Stari trg ob Kolpi',
    NASLOV: 'Stari trg ob Kolpi 7',
    'POŠTNA ŠTEVILKA': 8342,
    POŠTA: 'Stari trg ob Kolpi',
    EMAIL: 'o-staritrg.nm@guest.arnes.si',
    URL: 'http://os-stari-trg-ok.si/'
  },
  {
    ZAVSIF: 156,
    PRSMSS: 5082781000,
    NAZIV: 'Osnovna šola Vinica',
    NASLOV: 'Vinica 50',
    'POŠTNA ŠTEVILKA': 8344,
    POŠTA: 'Vinica',
    EMAIL: 'o-vinica.nm@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 414,
    PRSMSS: 5086990000,
    NAZIV: 'Osnovna šola Destrnik - Trnovska vas',
    NASLOV: 'Janežovski Vrh 45',
    'POŠTNA ŠTEVILKA': 2253,
    POŠTA: 'Destrnik',
    EMAIL: 'os.destrnik@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmbde6s/'
  },
  {
    ZAVSIF: 458,
    PRSMSS: 5089336000,
    NAZIV: 'Osnovna šola dr. Bogomirja Magajne Divača',
    NASLOV: 'Ulica dr. Bogomira Magajne 4',
    'POŠTNA ŠTEVILKA': 6215,
    POŠTA: 'Divača',
    EMAIL: 'o-bmdivaca.po@guest.arnes.si',
    URL: 'http://www.os-divaca.si/'
  },
  {
    ZAVSIF: 598,
    PRSMSS: 5582911000,
    NAZIV: 'Osnovna šola Dobje',
    NASLOV: 'Dobje pri Planini 20 A',
    'POŠTNA ŠTEVILKA': 3224,
    POŠTA: 'Dobje pri Planini',
    EMAIL: 'os.dobje@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 180,
    PRSMSS: 5089956000,
    NAZIV: 'Osnovna šola Dobrepolje',
    NASLOV: 'Videm 80',
    'POŠTNA ŠTEVILKA': 1312,
    POŠTA: 'Videm - Dobrepolje',
    EMAIL: 'o-dobrepolje.lj@guest.arnes.si',
    URL: 'http://www.o-dobrepolje.lj.edus.si/'
  },
  {
    ZAVSIF: 140,
    PRSMSS: 5082668000,
    NAZIV: 'Osnovna šola Dobrna',
    NASLOV: 'Dobrna 1',
    'POŠTNA ŠTEVILKA': 3204,
    POŠTA: 'Dobrna',
    EMAIL: 'os.dobrna@guest.arnes.si',
    URL: 'http://www.o-dobrna.ce.edus.si/'
  },
  {
    ZAVSIF: 326,
    PRSMSS: 5084415000,
    NAZIV: 'Osnovna šola Dobrova',
    NASLOV: 'Cesta 7. maja 20',
    'POŠTNA ŠTEVILKA': 1356,
    POŠTA: 'Dobrova',
    EMAIL: 'o-dobrova.lj@guest.arnes.si',
    URL: 'http://www.osdobrova.si'
  },
  {
    ZAVSIF: 325,
    PRSMSS: 5084466000,
    NAZIV: 'Osnovna šola Polhov Gradec',
    NASLOV: 'Polhov Gradec 95',
    'POŠTNA ŠTEVILKA': 1355,
    POŠTA: 'Polhov Gradec',
    EMAIL: 'os.polhgr@guest.arnes.si',
    URL: 'http://www.ospg.si'
  },
  {
    ZAVSIF: 257,
    PRSMSS: 5086078000,
    NAZIV: 'Dvojezična osnovna šola Dobrovnik',
    NASLOV: 'Dobrovnik 266 J',
    'POŠTNA ŠTEVILKA': 9223,
    POŠTA: 'Dobrovnik - Dobronak',
    EMAIL: 'o-dobrovnik.ms@guest.arnes.si',
    URL: 'http://www.dosdobrovnik.si'
  },
  {
    ZAVSIF: 273,
    PRSMSS: 5083354000,
    NAZIV: 'Osnovna šola Janka Modra Dol pri Ljubljani',
    NASLOV: 'Videm 17',
    'POŠTNA ŠTEVILKA': 1262,
    POŠTA: 'Dol pri Ljubljani',
    EMAIL: 'osjm.dol@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljdol24'
  },
  {
    ZAVSIF: 385,
    PRSMSS: 5086370000,
    NAZIV: 'Osnovna šola Dolenjske Toplice',
    NASLOV: 'Pionirska cesta 35',
    'POŠTNA ŠTEVILKA': 8350,
    POŠTA: 'Dolenjske Toplice',
    EMAIL: 'os.dolenjske-toplice@guest.arnes.si',
    URL: 'http://www.os-dt.si'
  },
  {
    ZAVSIF: 163,
    PRSMSS: 5084733000,
    NAZIV: 'Osnovna šola Dob',
    NASLOV: 'Šolska ulica 7',
    'POŠTNA ŠTEVILKA': 1233,
    POŠTA: 'Dob',
    EMAIL: 'o-dob.lj@guest.arnes.si',
    URL: 'http://www.os-dob.si'
  },
  {
    ZAVSIF: 158,
    PRSMSS: 5082803000,
    NAZIV: 'Osnovna šola Domžale',
    NASLOV: 'Bistriška cesta 19',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'os-domzale@guest.arnes.si',
    URL: 'http://www.os-domzale.si/'
  },
  {
    ZAVSIF: 10549,
    PRSMSS: 2197197000,
    NAZIV: 'Osnovna šola Dragomelj',
    NASLOV: 'Dragomelj 180',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'tajnistvo@osdragomelj.si',
    URL: ''
  },
  {
    ZAVSIF: 166,
    PRSMSS: 5084741000,
    NAZIV: 'Osnovna šola Preserje pri Radomljah',
    NASLOV: 'Pelechova cesta 83',
    'POŠTNA ŠTEVILKA': 1235,
    POŠTA: 'Radomlje',
    EMAIL: 'o-preradomlje.lj@guest.arnes.si',
    URL: 'http://www.os-preserje.si'
  },
  {
    ZAVSIF: 159,
    PRSMSS: 5083737000,
    NAZIV: 'Osnovna šola Rodica',
    NASLOV: 'Kettejeva ulica 13',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'os-rodica@guest.arnes.si',
    URL: 'http://www.sola-rodica.si'
  },
  {
    ZAVSIF: 160,
    PRSMSS: 5082811000,
    NAZIV: 'Osnovna šola Venclja Perka',
    NASLOV: 'Ljubljanska cesta 58 A',
    'POŠTNA ŠTEVILKA': 1230,
    POŠTA: 'Domžale',
    EMAIL: 'os.vp-domzale@guest.arnes.si',
    URL: 'http://www.os-vperka.si/'
  },
  {
    ZAVSIF: 413,
    PRSMSS: 5087015000,
    NAZIV: 'Osnovna šola dr. Franja Žgeča Dornava',
    NASLOV: 'Dornava 136 A',
    'POŠTNA ŠTEVILKA': 2252,
    POŠTA: 'Dornava',
    EMAIL: 'o-fzdornava.mb@guest.arnes.si',
    URL: 'http://www.os-dornava.si/'
  },
  {
    ZAVSIF: 168,
    PRSMSS: 5082889000,
    NAZIV: 'Osnovna šola Neznanih talcev Dravograd',
    NASLOV: 'Trg 4. julija 64',
    'POŠTNA ŠTEVILKA': 2370,
    POŠTA: 'Dravograd',
    EMAIL: 'os.dravograd@guest.arnes.si',
    URL: 'http://www.os-dravograd.si'
  },
  {
    ZAVSIF: 1236,
    PRSMSS: 5914183000,
    NAZIV: 'Osnovna šola Šentjanž pri Dravogradu',
    NASLOV: 'Šentjanž pri Dravogradu 88',
    'POŠTNA ŠTEVILKA': 2373,
    POŠTA: 'Šentjanž pri Dravogradu',
    EMAIL: 'os-sentjanz@guest.arnes.si',
    URL: 'http://www.os-sentjanz.si/'
  },
  {
    ZAVSIF: 573,
    PRSMSS: 5085233000,
    NAZIV: 'Osnovna šola Duplek',
    NASLOV: 'Korenska cesta 31',
    'POŠTNA ŠTEVILKA': 2241,
    POŠTA: 'Spodnji Duplek',
    EMAIL: 'tajnistvo@o-duplek.mb.mss.edus.si',
    URL: 'http://www.o-duplek.mb.edus.si/sola/'
  },
  {
    ZAVSIF: 574,
    PRSMSS: 5088887000,
    NAZIV: 'Osnovna šola Korena',
    NASLOV: 'Zgornja Korena 32',
    'POŠTNA ŠTEVILKA': 2242,
    POŠTA: 'Zgornja Korena',
    EMAIL: 'os.korena@guest.arnes.si',
    URL: 'http://www.o-korena.mb.edus.si/'
  },
  {
    ZAVSIF: 488,
    PRSMSS: 5087813000,
    NAZIV: 'Osnovna šola Ivana Tavčarja Gorenja vas',
    NASLOV: 'Trata 40',
    'POŠTNA ŠTEVILKA': 4224,
    POŠTA: 'Gorenja vas',
    EMAIL: 'info@os-ivantavcar.si',
    URL: 'http://www2.arnes.si/~oskrgv1s/sola/index.html'
  },
  {
    ZAVSIF: 1315,
    PRSMSS: 1199498000,
    NAZIV: 'Osnovna šola Poljane',
    NASLOV: 'Poljane nad Škofjo Loko 100',
    'POŠTNA ŠTEVILKA': 4223,
    POŠTA: 'Poljane nad Škofjo Loko',
    EMAIL: 'group.oskrpo@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskrpo1s/'
  },
  {
    ZAVSIF: 416,
    PRSMSS: 5087023000,
    NAZIV: 'Osnovna šola Gorišnica',
    NASLOV: 'Gorišnica 83',
    'POŠTNA ŠTEVILKA': 2272,
    POŠTA: 'Gorišnica',
    EMAIL: 'projekt1.osmbgo@guest.arnes.si',
    URL: 'http://www.osgorisnica.eu'
  },
  {
    ZAVSIF: 434,
    PRSMSS: 5087317000,
    NAZIV: 'Osnovna šola Gorje',
    NASLOV: 'Zgornje Gorje 44 A',
    'POŠTNA ŠTEVILKA': 4247,
    POŠTA: 'Zgornje Gorje',
    EMAIL: 'o-gorje.kr@guest.arnes.si',
    URL: 'http://www.osgorje.si'
  },
  {
    ZAVSIF: 170,
    PRSMSS: 5082897000,
    NAZIV: 'Osnovna šola dr. Antona Trstenjaka Negova',
    NASLOV: 'Negova 20',
    'POŠTNA ŠTEVILKA': 9245,
    POŠTA: 'Spodnji Ivanjci',
    EMAIL: 'os.negova@guest.arnes.si',
    URL: 'http://www.o-negova.ms.edus.si/'
  },
  {
    ZAVSIF: 171,
    PRSMSS: 5083745000,
    NAZIV: 'Osnovna šola Gornja Radgona',
    NASLOV: 'Prežihova ulica 1',
    'POŠTNA ŠTEVILKA': 9250,
    POŠTA: 'Gornja Radgona',
    EMAIL: 'os.gor-radgona@guest.arnes.si',
    URL: 'http://www.gros-radgona.si/'
  },
  {
    ZAVSIF: 342,
    PRSMSS: 5088933000,
    NAZIV: 'Osnovna šola Frana Kocbeka Gornji Grad',
    NASLOV: 'Kocbekova cesta 21',
    'POŠTNA ŠTEVILKA': 3342,
    POŠTA: 'Gornji Grad',
    EMAIL: 'sola.gornji-grad@guest.arnes.si',
    URL: 'http://www.osgornjigrad.si/'
  },
  {
    ZAVSIF: 346,
    PRSMSS: 5085586000,
    NAZIV: 'Osnovna šola Gornji Petrovci',
    NASLOV: 'Gornji Petrovci 2',
    'POŠTNA ŠTEVILKA': 9203,
    POŠTA: 'Petrovci',
    EMAIL: 'o-gpetrovci@guest.arnes.si',
    URL: 'http://www.os-gpetrovci.si/'
  },
  {
    ZAVSIF: 356,
    PRSMSS: 5085594000,
    NAZIV: 'Osnovna šola Grad',
    NASLOV: 'Grad 172 E',
    'POŠTNA ŠTEVILKA': 9264,
    POŠTA: 'Grad',
    EMAIL: 'tajnistvo@o-grad.ms.mss.edus.si',
    URL: 'http://www.osgrad.si'
  },
  {
    ZAVSIF: 1307,
    PRSMSS: 1193481000,
    NAZIV: 'Osnovna šola Brinje Grosuplje',
    NASLOV: 'Ljubljanska cesta 40 A',
    'POŠTNA ŠTEVILKA': 1290,
    POŠTA: 'Grosuplje',
    EMAIL: 'os.brinje-grosuplje@guest.arnes.si',
    URL: 'http://www.os-brinje.si'
  },
  {
    ZAVSIF: 178,
    PRSMSS: 5085993000,
    NAZIV: 'Osnovna šola Louisa Adamiča Grosuplje',
    NASLOV: 'Tovarniška cesta 14',
    'POŠTNA ŠTEVILKA': 1290,
    POŠTA: 'Grosuplje',
    EMAIL: 'lag.osljlag@guest.arnes.si',
    URL: 'http://www.oslag.si/tovarniska'
  },
  {
    ZAVSIF: 23155,
    PRSMSS: 7272219000,
    NAZIV: 'Osnovna šola Šmarje - Sap',
    NASLOV: 'Ljubljanska cesta 49',
    'POŠTNA ŠTEVILKA': 1293,
    POŠTA: 'Šmarje - Sap',
    EMAIL: 'os.smarje-sap@guest.arnes.si',
    URL: 'http://www.osss.si'
  },
  {
    ZAVSIF: 421,
    PRSMSS: 5087031000,
    NAZIV: 'Osnovna šola Hajdina',
    NASLOV: 'Spodnja Hajdina 24',
    'POŠTNA ŠTEVILKA': 2288,
    POŠTA: 'Hajdina',
    EMAIL: 'o-hajdina.mb@guest.arnes.si',
    URL: 'http://www.os-hajdina.si'
  },
  {
    ZAVSIF: 575,
    PRSMSS: 5085853000,
    NAZIV: 'Osnovna šola Dušana Flisa Hoče',
    NASLOV: 'Šolska ulica 10',
    'POŠTNA ŠTEVILKA': 2311,
    POŠTA: 'Hoče',
    EMAIL: 'os-hoce@guest.arnes.si',
    URL: 'http://www.os-hoce.si/'
  },
  {
    ZAVSIF: 577,
    PRSMSS: 5085306000,
    NAZIV: 'Osnovna šola Franca Lešnika - Vuka Slivnica pri Mariboru',
    NASLOV: 'Mariborska cesta 4',
    'POŠTNA ŠTEVILKA': 2312,
    POŠTA: 'Orehova vas',
    EMAIL: 'o-flvslivnica.mb@guest.arnes.si',
    URL: 'http://www.osflv.si'
  },
  {
    ZAVSIF: 324,
    PRSMSS: 5084423000,
    NAZIV: 'Osnovna šola Horjul',
    NASLOV: 'Šolska ulica 44',
    'POŠTNA ŠTEVILKA': 1354,
    POŠTA: 'Horjul',
    EMAIL: 'o-horjul.lj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ohorjullj/vstop.htm'
  },
  {
    ZAVSIF: 181,
    PRSMSS: 5089905000,
    NAZIV: 'Osnovna šola narodnega heroja Rajka Hrastnik',
    NASLOV: 'Log 19',
    'POŠTNA ŠTEVILKA': 1430,
    POŠTA: 'Hrastnik',
    EMAIL: 'Projekt3.osljhrnhr@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljhrnhr3s/'
  },
  {
    ZAVSIF: 461,
    PRSMSS: 5089379000,
    NAZIV: 'Osnovna šola Dragomirja Benčiča - Brkina Hrpelje',
    NASLOV: 'Reška cesta 30',
    'POŠTNA ŠTEVILKA': 6240,
    POŠTA: 'Kozina',
    EMAIL: 'info@os-hrpelje.si',
    URL: 'http://www.os-hrpelje.si'
  },
  {
    ZAVSIF: 184,
    PRSMSS: 5082978000,
    NAZIV: 'Osnovna šola Črni Vrh',
    NASLOV: 'Črni Vrh 95',
    'POŠTNA ŠTEVILKA': 5274,
    POŠTA: 'Črni vrh nad Idrijo',
    EMAIL: 'o-crni.vrh@guest.arnes.si',
    URL: 'http://www.oscv.si/'
  },
  {
    ZAVSIF: 185,
    PRSMSS: 5082986000,
    NAZIV: 'Osnovna šola Idrija',
    NASLOV: 'Lapajnetova ulica 50',
    'POŠTNA ŠTEVILKA': 5280,
    POŠTA: 'Idrija',
    EMAIL: 'osidrija@guest.arnes.si',
    URL: 'http://www.osnovna-sola-idrija.si/'
  },
  {
    ZAVSIF: 188,
    PRSMSS: 5083788000,
    NAZIV: 'Osnovna šola Spodnja Idrija',
    NASLOV: 'Šolska ulica 9',
    'POŠTNA ŠTEVILKA': 5281,
    POŠTA: 'Spodnja Idrija',
    EMAIL: 'ospidrijang@guest.arnes.si',
    URL: 'http://www.os-spidrija.si/'
  },
  {
    ZAVSIF: 320,
    PRSMSS: 5084431000,
    NAZIV: 'Osnovna šola Ig',
    NASLOV: 'Troštova ulica 24',
    'POŠTNA ŠTEVILKA': 1292,
    POŠTA: 'Ig',
    EMAIL: 'o-ig.lj@guest.arnes.si',
    URL: 'http://www.osig.si'
  },
  {
    ZAVSIF: 599,
    PRSMSS: 5624525000,
    NAZIV: 'Osnovna šola Antona Žnideršiča Ilirska Bistrica',
    NASLOV: 'Rozmanova ulica 25 B',
    'POŠTNA ŠTEVILKA': 6250,
    POŠTA: 'Ilirska Bistrica',
    EMAIL: 'group1.ospoilbaz@guest.arnes.si',
    URL: 'http://www.o-azilb.si/'
  },
  {
    ZAVSIF: 600,
    PRSMSS: 5624533000,
    NAZIV: 'Osnovna šola Dragotina Ketteja Ilirska Bistrica',
    NASLOV: 'Župančičeva ulica 7',
    'POŠTNA ŠTEVILKA': 6250,
    POŠTA: 'Ilirska Bistrica',
    EMAIL: 'nevenka.vicic@guest.arnes.si',
    URL: 'http://www.os-dk.si/'
  },
  {
    ZAVSIF: 195,
    PRSMSS: 5083010000,
    NAZIV: 'Osnovna šola Jelšane',
    NASLOV: 'Jelšane 82',
    'POŠTNA ŠTEVILKA': 6254,
    POŠTA: 'Jelšane',
    EMAIL: 'os.jelsane@guest.arnes.si',
    URL: 'http://www.os-jelsane.si'
  },
  {
    ZAVSIF: 192,
    PRSMSS: 5086019000,
    NAZIV: 'Osnovna šola Podgora Kuteževo',
    NASLOV: 'Kuteževo 2 F',
    'POŠTNA ŠTEVILKA': 6250,
    POŠTA: 'Ilirska Bistrica',
    EMAIL: 'os.podgora@guest.arnes.si',
    URL: 'http://www.os-kutezevo.si'
  },
  {
    ZAVSIF: 190,
    PRSMSS: 5090164000,
    NAZIV: 'Osnovna šola Rudija Mahniča - Brkinca Pregarje',
    NASLOV: 'Pregarje 18',
    'POŠTNA ŠTEVILKA': 6243,
    POŠTA: 'Obrov',
    EMAIL: 'o-rmbrkinc.po@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ormbrkincpo/'
  },
  {
    ZAVSIF: 191,
    PRSMSS: 5083800000,
    NAZIV: 'Osnovna šola Rudolfa Ukoviča Podgrad',
    NASLOV: 'Podgrad 99 B',
    'POŠTNA ŠTEVILKA': 6244,
    POŠTA: 'Podgrad',
    EMAIL: 'projekt1.oskprup@guest.arnes.si',
    URL: 'http://os-podgrad.si/'
  },
  {
    ZAVSIF: 194,
    PRSMSS: 5083796000,
    NAZIV: 'Osnovna šola Toneta Tomšiča Knežak',
    NASLOV: 'Knežak 147 A',
    'POŠTNA ŠTEVILKA': 6253,
    POŠTA: 'Knežak',
    EMAIL: 'o-ttknezak.po@guest.arnes.si',
    URL: 'http://os-knezak.si/'
  },
  {
    ZAVSIF: 179,
    PRSMSS: 5085357000,
    NAZIV: 'Osnovna šola Ferda Vesela Šentvid pri Stični',
    NASLOV: 'Šentvid pri Stični 46',
    'POŠTNA ŠTEVILKA': 1296,
    POŠTA: 'Šentvid pri Stični',
    EMAIL: '',
    URL: 'http://www2.arnes.si/~osljfv2s/'
  },
  {
    ZAVSIF: 602,
    PRSMSS: 5623677000,
    NAZIV: 'Osnovna šola Stična',
    NASLOV: 'Cesta občine Hirschaid 1',
    'POŠTNA ŠTEVILKA': 1295,
    POŠTA: 'Ivančna Gorica',
    EMAIL: 'tajnistvo@os-sticna.si',
    URL: 'http://www.os-sticna.si'
  },
  {
    ZAVSIF: 196,
    PRSMSS: 5089514000,
    NAZIV: 'Osnovna šola Dante Alighieri Izola',
    NASLOV: 'Ulica oktobrske revolucije 10',
    'POŠTNA ŠTEVILKA': 6310,
    POŠTA: 'Izola - Isola',
    EMAIL: 'se.alighieri-is@guest.arnes.si',
    URL: 'http://www.dantealighieri.si'
  },
  {
    ZAVSIF: 1053,
    PRSMSS: 5859921000,
    NAZIV: 'Osnovna šola Livade - Izola',
    NASLOV: 'Livade 7',
    'POŠTNA ŠTEVILKA': 6310,
    POŠTA: 'Izola - Isola',
    EMAIL: 'o-livadeizola.kp@guest.arnes.si',
    URL: 'http://www.livade.si'
  },
  {
    ZAVSIF: 197,
    PRSMSS: 5083028000,
    NAZIV: 'Osnovna šola Vojke Šmuc Izola',
    NASLOV: 'Prešernova cesta 4',
    'POŠTNA ŠTEVILKA': 6310,
    POŠTA: 'Izola - Isola',
    EMAIL: 'tajnistvo.osvsmuc@guest.arnes.si',
    URL: 'http://www.osvsmuc.si'
  },
  {
    ZAVSIF: 1344,
    PRSMSS: 5719046000,
    NAZIV: 'Osnovna šola Koroška Bela Jesenice',
    NASLOV: 'Cesta talcev 2',
    'POŠTNA ŠTEVILKA': 4270,
    POŠTA: 'Jesenice',
    EMAIL: 'o-korbela.kr@guest.arnes.si',
    URL: 'http://www.oskoroskabela.si'
  },
  {
    ZAVSIF: 1206,
    PRSMSS: 5719097000,
    NAZIV: 'Osnovna šola Prežihovega Voranca Jesenice',
    NASLOV: 'Cesta Toneta Tomšiča 5',
    'POŠTNA ŠTEVILKA': 4270,
    POŠTA: 'Jesenice',
    EMAIL: 'os-pv.jesenice@guest.arnes.si',
    URL: 'http://www.prezihovvoranc.si'
  },
  {
    ZAVSIF: 1345,
    PRSMSS: 5719089000,
    NAZIV: 'Osnovna šola Toneta Čufarja Jesenice',
    NASLOV: 'Cesta Cirila Tavčarja 21',
    'POŠTNA ŠTEVILKA': 4270,
    POŠTA: 'Jesenice',
    EMAIL: 'os-tone.cufar@guest.arnes.si',
    URL: 'http://www.tonecufar.si/'
  },
  {
    ZAVSIF: 415,
    PRSMSS: 5087040000,
    NAZIV: 'Osnovna šola Juršinci',
    NASLOV: 'Juršinci 19',
    'POŠTNA ŠTEVILKA': 2256,
    POŠTA: 'Juršinci',
    EMAIL: 'os.jursinci@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmbjur5/'
  },
  {
    ZAVSIF: 200,
    PRSMSS: 5083036000,
    NAZIV: 'Osnovna šola Frana Albrehta Kamnik',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 1241,
    POŠTA: 'Kamnik',
    EMAIL: 'os.frana-albrehta@guest.arnes.si',
    URL: 'http://www.os-fa.si'
  },
  {
    ZAVSIF: 199,
    PRSMSS: 5268931000,
    NAZIV: 'Osnovna šola Marije Vere',
    NASLOV: 'Ljubljanska cesta 16 A',
    'POŠTNA ŠTEVILKA': 1241,
    POŠTA: 'Kamnik',
    EMAIL: 'tajnistvo@os-marijevere.si',
    URL: 'http://www.os-marijevere.si/'
  },
  {
    ZAVSIF: 204,
    PRSMSS: 5083818000,
    NAZIV: 'Osnovna šola Stranje',
    NASLOV: 'Zgornje Stranje 22',
    'POŠTNA ŠTEVILKA': 1242,
    POŠTA: 'Stahovica',
    EMAIL: 'tajnistvo@os-stranje.si',
    URL: 'http://www.os-stranje.si/'
  },
  {
    ZAVSIF: 1259,
    PRSMSS: 5950686000,
    NAZIV: 'Osnovna šola Šmartno v Tuhinju',
    NASLOV: 'Šmartno v Tuhinju 27 A',
    'POŠTNA ŠTEVILKA': 1219,
    POŠTA: 'Laze v Tuhinju',
    EMAIL: 'projekt1.osljsmt@guest.arnes.si',
    URL: 'http://www.ossmartno-tuhinj.si/'
  },
  {
    ZAVSIF: 201,
    PRSMSS: 5083044000,
    NAZIV: 'Osnovna šola Toma Brejca Kamnik',
    NASLOV: 'Šutna 39',
    'POŠTNA ŠTEVILKA': 1241,
    POŠTA: 'Kamnik',
    EMAIL: 'os-tb.kamnik@guest.arnes.si',
    URL: 'http://www.ostb.si'
  },
  {
    ZAVSIF: 361,
    PRSMSS: 5085772000,
    NAZIV: 'Osnovna šola Deskle',
    NASLOV: 'Srebrničeva ulica 10',
    'POŠTNA ŠTEVILKA': 5210,
    POŠTA: 'Deskle',
    EMAIL: 'o-sola.deskle@guest.arnes.si',
    URL: 'http://www.os-deskle.si'
  },
  {
    ZAVSIF: 363,
    PRSMSS: 5089018000,
    NAZIV: 'Osnovna šola Kanal',
    NASLOV: 'Gradnikova ulica 25',
    'POŠTNA ŠTEVILKA': 5213,
    POŠTA: 'Kanal',
    EMAIL: 'o-kanal.ng@guest.arnes.si',
    URL: 'http://www2.arnes.si/~okanalng/'
  },
  {
    ZAVSIF: 424,
    PRSMSS: 5086973000,
    NAZIV: 'Osnovna šola Cirkovce',
    NASLOV: 'Cirkovce 47',
    'POŠTNA ŠTEVILKA': 2326,
    POŠTA: 'Cirkovce',
    EMAIL: 'ravnateljica@os-cirkovce.si',
    URL: 'http://www.os-cirkovce.si'
  },
  {
    ZAVSIF: 423,
    PRSMSS: 5087066000,
    NAZIV: 'Osnovna šola Kidričevo',
    NASLOV: 'Kajuhova ulica 10',
    'POŠTNA ŠTEVILKA': 2325,
    POŠTA: 'Kidričevo',
    EMAIL: 'os.kidricevo@guest.arnes.si',
    URL: 'http://www.os-kidricevo.si'
  },
  {
    ZAVSIF: 509,
    PRSMSS: 5089832000,
    NAZIV: 'Osnovna šola Simona Gregorčiča Kobarid',
    NASLOV: 'Gregorčičeva ulica 18 A',
    'POŠTNA ŠTEVILKA': 5222,
    POŠTA: 'Kobarid',
    EMAIL: 'tajnistvo@os-kobarid.si',
    URL: 'http://www.os-kobarid.si'
  },
  {
    ZAVSIF: 256,
    PRSMSS: 5089719000,
    NAZIV: 'Osnovna šola Kobilje',
    NASLOV: 'Kobilje 33 A',
    'POŠTNA ŠTEVILKA': 9227,
    POŠTA: 'Kobilje',
    EMAIL: 'o-kobilje.ms@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 612,
    PRSMSS: 5621712000,
    NAZIV: 'Osnovna šola Ob Rinži Kočevje',
    NASLOV: 'Cesta v Mestni log 39',
    'POŠTNA ŠTEVILKA': 1330,
    POŠTA: 'Kočevje',
    EMAIL: 'projekt5.osljobrin@guest.arnes.si',
    URL: 'http://www.osobrinzi.si/'
  },
  {
    ZAVSIF: 613,
    PRSMSS: 5621739000,
    NAZIV: 'Osnovna šola Stara Cerkev',
    NASLOV: 'Stara Cerkev 21',
    'POŠTNA ŠTEVILKA': 1332,
    POŠTA: 'Stara Cerkev',
    EMAIL: 'os.stara-cerkev@guest.arnes.si',
    URL: 'http://www.osstaracerkev.si'
  },
  {
    ZAVSIF: 205,
    PRSMSS: 5084857000,
    NAZIV: 'Osnovna šola Zbora odposlancev Kočevje',
    NASLOV: 'Trg zbora odposlancev 28',
    'POŠTNA ŠTEVILKA': 1330,
    POŠTA: 'Kočevje',
    EMAIL: 'os.zbodp@guest.arnes.si',
    URL: 'http://www.oszboraodposlancev.si'
  },
  {
    ZAVSIF: 460,
    PRSMSS: 5087554000,
    NAZIV: 'Osnovna šola Antona Šibelja - Stjenka Komen',
    NASLOV: 'Komen 61 A',
    'POŠTNA ŠTEVILKA': 6223,
    POŠTA: 'Komen',
    EMAIL: 'os.komen@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 198,
    PRSMSS: 5083052000,
    NAZIV: 'Osnovna šola Komenda Moste',
    NASLOV: 'Glavarjeva cesta 37',
    'POŠTNA ŠTEVILKA': 1218,
    POŠTA: 'Komenda',
    EMAIL: 'o-komenda.lj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~okomendalj/'
  },
  {
    ZAVSIF: 209,
    PRSMSS: 5231825000,
    NAZIV: 'Osnovna šola Antona Ukmarja Koper',
    NASLOV: 'Pot v gaj 2',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'tajnistvo@antonukmar.si',
    URL: 'http://www.antonukmar.si/J3/'
  },
  {
    ZAVSIF: 216,
    PRSMSS: 5083834000,
    NAZIV: 'Osnovna šola Dekani',
    NASLOV: 'Dekani 32',
    'POŠTNA ŠTEVILKA': 6271,
    POŠTA: 'Dekani',
    EMAIL: 'info@os-dekani.si',
    URL: 'http://www.os-dekani.si/'
  },
  {
    ZAVSIF: 220,
    PRSMSS: 5088704000,
    NAZIV: 'Osnovna šola dr. Aleš Bebler - Primož Hrvatini',
    NASLOV: 'Hrvatini 137',
    'POŠTNA ŠTEVILKA': 6280,
    POŠTA: 'Ankaran - Ancarano',
    EMAIL: 'os.hrvatini@guest.arnes.si',
    URL: 'http://www.os-hrvatini.si'
  },
  {
    ZAVSIF: 213,
    PRSMSS: 5083141000,
    NAZIV: 'Osnovna šola Dušana Bordona Semedela - Koper',
    NASLOV: 'Rozmanova ulica 21 A',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'os.semedela@guest.arnes.si',
    URL: 'http://www.dusanabordona.si'
  },
  {
    ZAVSIF: 210,
    PRSMSS: 5083168000,
    NAZIV: 'Osnovna šola Elvire Vatovec Prade - Koper',
    NASLOV: 'Pobeška cesta 52',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'o-prade.kp@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 217,
    PRSMSS: 5083133000,
    NAZIV: 'Osnovna šola Istrskega odreda Gračišče',
    NASLOV: 'Gračišče 5',
    'POŠTNA ŠTEVILKA': 6272,
    POŠTA: 'Gračišče',
    EMAIL: 'tajnistvo.oskpio@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskpio1s/'
  },
  {
    ZAVSIF: 218,
    PRSMSS: 5083150000,
    NAZIV: 'Osnovna šola Ivana Babiča - Jagra Marezige',
    NASLOV: 'Marezige 33 A',
    'POŠTNA ŠTEVILKA': 6273,
    POŠTA: 'Marezige',
    EMAIL: 'os.marezige@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 10550,
    PRSMSS: 2229463000,
    NAZIV: 'Osnovna šola Koper',
    NASLOV: 'Cesta Zore Perello-Godina 1',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'tajnistvo.oskoper@guest.arnes.si',
    URL: 'http://www.os-koper.si/'
  },
  {
    ZAVSIF: 221,
    PRSMSS: 5084822000,
    NAZIV: 'Osnovna šola Oskarja Kovačiča Škofije',
    NASLOV: 'Spodnje Škofije 40 D',
    'POŠTNA ŠTEVILKA': 6281,
    POŠTA: 'Škofije',
    EMAIL: 'o-okskofije.kp@guest.arnes.si',
    URL: 'http://www.sola-skofije.si'
  },
  {
    ZAVSIF: 214,
    PRSMSS: 5084849000,
    NAZIV: 'Osnovna šola Pier Paolo Vergerio il Vecchio Koper',
    NASLOV: 'Gimnazijski trg 7',
    'POŠTNA ŠTEVILKA': 6000,
    POŠTA: 'Koper - Capodistria',
    EMAIL: 'os-vergerio@guest.arnes.si',
    URL: 'http://www.vergerio.si'
  },
  {
    ZAVSIF: 219,
    PRSMSS: 5083842000,
    NAZIV: 'Osnovna šola Šmarje pri Kopru',
    NASLOV: 'Šmarje 1',
    'POŠTNA ŠTEVILKA': 6274,
    POŠTA: 'Šmarje',
    EMAIL: 'o-smarje.kp@guest.arnes.si',
    URL: 'http://www.ossmarje.si/default.aspx'
  },
  {
    ZAVSIF: 242,
    PRSMSS: 5083958000,
    NAZIV: 'Osnovna šola Jožeta Gorjupa Kostanjevica na Krki',
    NASLOV: 'Gorjanska cesta 2',
    'POŠTNA ŠTEVILKA': 8311,
    POŠTA: 'Kostanjevica na Krki',
    EMAIL: 'o-kostanjevica.nm@guest.arnes.si',
    URL: 'http://www.o-kostanjevica.kk.edus.si/'
  },
  {
    ZAVSIF: 208,
    PRSMSS: 5083095000,
    NAZIV: 'Osnovna šola Fara',
    NASLOV: 'Fara 3',
    'POŠTNA ŠTEVILKA': 1336,
    POŠTA: 'Kostel',
    EMAIL: 'os.fara@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osfara/index.htm'
  },
  {
    ZAVSIF: 503,
    PRSMSS: 5087929000,
    NAZIV: 'Osnovna šola Kozje',
    NASLOV: 'Kozje 131',
    'POŠTNA ŠTEVILKA': 3260,
    POŠTA: 'Kozje',
    EMAIL: 'o-kozje.ce@guest.arnes.si',
    URL: 'http://www.oskozje.si/'
  },
  {
    ZAVSIF: 504,
    PRSMSS: 5087937000,
    NAZIV: 'Osnovna šola Lesično',
    NASLOV: 'Lesično 5 B',
    'POŠTNA ŠTEVILKA': 3261,
    POŠTA: 'Lesično',
    EMAIL: 'o-lesicno.ce@guest.arnes.si',
    URL: 'http://users.volja.net/oslesicno/'
  },
  {
    ZAVSIF: 222,
    PRSMSS: 5086035000,
    NAZIV: 'Osnovna šola Franceta Prešerna Kranj',
    NASLOV: 'Kidričeva cesta 49',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'info@o-fp.kr.edus.si',
    URL: 'http://www.o-fp.kr.edus.si'
  },
  {
    ZAVSIF: 227,
    PRSMSS: 5204941000,
    NAZIV: 'Osnovna šola Jakoba Aljaža Kranj',
    NASLOV: 'Ulica Tončka Dežmana 1',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'os.jakoba-aljaza@guest.arnes.si',
    URL: 'http://www.o-ja.kr.edus.si'
  },
  {
    ZAVSIF: 223,
    PRSMSS: 5279976000,
    NAZIV: 'Osnovna šola Matije Čopa Kranj',
    NASLOV: 'Ulica Tuga Vidmarja 1',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'o-mc.kr@guest.arnes.si',
    URL: 'http://www.o-mc.kr.edus.si'
  },
  {
    ZAVSIF: 1370,
    PRSMSS: 1319841000,
    NAZIV: 'Osnovna šola Orehek Kranj',
    NASLOV: 'Zasavska cesta 53 A',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'vevericek@osorehek.si',
    URL: 'http://www.osorehek.si/'
  },
  {
    ZAVSIF: 228,
    PRSMSS: 5083222000,
    NAZIV: 'Osnovna šola Predoslje Kranj',
    NASLOV: 'Predoslje 17 A',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'projekt2.oskrpre@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskrpre2s/'
  },
  {
    ZAVSIF: 224,
    PRSMSS: 5083192000,
    NAZIV: 'Osnovna šola Simona Jenka Kranj',
    NASLOV: 'Ulica XXXI. divizije 7 A',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'o-sjkranj.kr@osjenka.si',
    URL: 'http://www.osjenka.si'
  },
  {
    ZAVSIF: 226,
    PRSMSS: 5083206000,
    NAZIV: 'Osnovna šola Staneta Žagarja Kranj',
    NASLOV: 'Cesta 1. maja 10 A',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'os.szagar@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskrsz3s'
  },
  {
    ZAVSIF: 225,
    PRSMSS: 5085365000,
    NAZIV: 'Osnovna šola Stražišče Kranj',
    NASLOV: 'Šolska ulica 2',
    'POŠTNA ŠTEVILKA': 4000,
    POŠTA: 'Kranj',
    EMAIL: 'os.strazisce@guest.arnes.si',
    URL: 'http://www.o-strazisce.kr.edus.si'
  },
  {
    ZAVSIF: 1207,
    PRSMSS: 5719038000,
    NAZIV: 'Osnovna šola Josipa Vandota Kranjska Gora',
    NASLOV: 'Koroška ulica 12',
    'POŠTNA ŠTEVILKA': 4280,
    POŠTA: 'Kranjska Gora',
    EMAIL: 'osjvkg.tajnistvo@siol.net',
    URL: 'http://www.o-kranjskagora.kr.edus.si/'
  },
  {
    ZAVSIF: 1208,
    PRSMSS: 5719054000,
    NAZIV: 'Osnovna šola 16. decembra Mojstrana',
    NASLOV: 'Ulica Alojza Rabiča 7',
    'POŠTNA ŠTEVILKA': 4281,
    POŠTA: 'Mojstrana',
    EMAIL: 'O-16decmojstr.kr@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 332,
    PRSMSS: 5084636000,
    NAZIV: 'Osnovna šola Križevci',
    NASLOV: 'Križevci pri Ljutomeru 16 B',
    'POŠTNA ŠTEVILKA': 9242,
    POŠTA: 'Križevci pri Ljutomeru',
    EMAIL: 'os-krizevci@guest.arnes.si',
    URL: 'http://www.os-krizevci.si/'
  },
  {
    ZAVSIF: 239,
    PRSMSS: 5083940000,
    NAZIV: 'Osnovna šola Adama Bohoriča Brestanica',
    NASLOV: 'Šolska cesta 29',
    'POŠTNA ŠTEVILKA': 8280,
    POŠTA: 'Brestanica',
    EMAIL: 'os.brestanica@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskkab_1/'
  },
  {
    ZAVSIF: 234,
    PRSMSS: 5083974000,
    NAZIV: 'Osnovna šola Jurija Dalmatina Krško',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 8270,
    POŠTA: 'Krško',
    EMAIL: 'o-jdkrsko.nm@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ojdkrskonm'
  },
  {
    ZAVSIF: 241,
    PRSMSS: 5086043000,
    NAZIV: 'Osnovna šola Koprivnica',
    NASLOV: 'Koprivnica 2',
    'POŠTNA ŠTEVILKA': 8282,
    POŠTA: 'Koprivnica',
    EMAIL: 'OS.KOPRIVNICA@GUEST.ARNES.SI',
    URL: 'http://os-koprivnica.si'
  },
  {
    ZAVSIF: 237,
    PRSMSS: 5085047000,
    NAZIV: 'Osnovna šola Leskovec pri Krškem',
    NASLOV: 'Pionirska cesta 4',
    'POŠTNA ŠTEVILKA': 8273,
    POŠTA: 'Leskovec pri Krškem',
    EMAIL: 'repse.jozica@gmail.com',
    URL: 'http://www.os-leskovec.si'
  },
  {
    ZAVSIF: 243,
    PRSMSS: 5086051000,
    NAZIV: 'Osnovna šola Podbočje',
    NASLOV: 'Podbočje 82',
    'POŠTNA ŠTEVILKA': 8312,
    POŠTA: 'Podbočje',
    EMAIL: 'os.podbocje@siol.net',
    URL: 'http://www.os-podbocje.si/'
  },
  {
    ZAVSIF: 238,
    PRSMSS: 5083281000,
    NAZIV: 'Osnovna šola Raka',
    NASLOV: 'Raka 36',
    'POŠTNA ŠTEVILKA': 8274,
    POŠTA: 'Raka',
    EMAIL: 'o-raka.nm@guest.arnes.si',
    URL: 'http://www.os-raka.si/'
  },
  {
    ZAVSIF: 240,
    PRSMSS: 5083966000,
    NAZIV: 'Osnovna šola XIV. divizije Senovo',
    NASLOV: 'Trg XIV. divizije 3',
    'POŠTNA ŠTEVILKA': 8281,
    POŠTA: 'Senovo',
    EMAIL: 'os.senovo@guest.arnes.si',
    URL: 'http://www.ossenovo.net'
  },
  {
    ZAVSIF: 582,
    PRSMSS: 5085152000,
    NAZIV: 'Osnovna šola Kungota',
    NASLOV: 'Plintovec 10 C',
    'POŠTNA ŠTEVILKA': 2201,
    POŠTA: 'Zgornja Kungota',
    EMAIL: 'sola@os-kungota.si',
    URL: 'http://www.os-kungota.si'
  },
  {
    ZAVSIF: 355,
    PRSMSS: 5085632000,
    NAZIV: 'Osnovna šola Kuzma',
    NASLOV: 'Kuzma 20',
    'POŠTNA ŠTEVILKA': 9263,
    POŠTA: 'Kuzma',
    EMAIL: 'os.kuzma@guest.arnes.si',
    URL: 'http://www.oskuzma.si'
  },
  {
    ZAVSIF: 1353,
    PRSMSS: 5924359000,
    NAZIV: 'Osnovna šola Antona Aškerca Rimske Toplice',
    NASLOV: 'Aškerčeva cesta 1',
    'POŠTNA ŠTEVILKA': 3272,
    POŠTA: 'Rimske Toplice',
    EMAIL: 'os-rimsketoplice@guest.arnes.si',
    URL: 'http://www.os-rimsketoplice.si'
  },
  {
    ZAVSIF: 491,
    PRSMSS: 5924332000,
    NAZIV: 'Osnovna šola Primoža Trubarja Laško',
    NASLOV: 'Trubarjeva ulica 20',
    'POŠTNA ŠTEVILKA': 3270,
    POŠTA: 'Laško',
    EMAIL: 'os.pt-lasko@guest.arnes.si',
    URL: 'http://www.o-ptlasko.ce.edus.si/'
  },
  {
    ZAVSIF: 246,
    PRSMSS: 5086639000,
    NAZIV: 'Osnovna šola Lenart',
    NASLOV: 'Ptujska cesta 25',
    'POŠTNA ŠTEVILKA': 2230,
    POŠTA: 'Lenart v Slov. goricah',
    EMAIL: 'oslenart@guest.arnes.si',
    URL: 'http://www.oslenart.si'
  },
  {
    ZAVSIF: 247,
    PRSMSS: 5084008000,
    NAZIV: 'Osnovna šola Voličina',
    NASLOV: 'Spodnja Voličina 82',
    'POŠTNA ŠTEVILKA': 2232,
    POŠTA: 'Voličina',
    EMAIL: 'os.volicina@guest.arnes.si',
    URL: 'http://www.os-volicina.si'
  },
  {
    ZAVSIF: 258,
    PRSMSS: 5089735000,
    NAZIV: 'Dvojezična osnovna šola Genterovci',
    NASLOV: 'Šolska ulica 2',
    'POŠTNA ŠTEVILKA': 9223,
    POŠTA: 'Dobrovnik - Dobronak',
    EMAIL: 'dos.genterovci@guest.arnes.si',
    URL: 'http://www.dosgenterovci.si'
  },
  {
    ZAVSIF: 253,
    PRSMSS: 5089727000,
    NAZIV: 'Dvojezična osnovna šola I Lendava',
    NASLOV: 'Kranjčeva ulica 44',
    'POŠTNA ŠTEVILKA': 9220,
    POŠTA: 'Lendava - Lendva',
    EMAIL: 'dos1.lendava@guest.arnes.si',
    URL: 'http://www.dos1-lendava.si/'
  },
  {
    ZAVSIF: 262,
    PRSMSS: 5084873000,
    NAZIV: 'Osnovna šola Gabrovka - Dole',
    NASLOV: 'Gabrovka 30',
    'POŠTNA ŠTEVILKA': 1274,
    POŠTA: 'Gabrovka',
    EMAIL: 'o-gabrovka.lj@guest.arnes.si',
    URL: 'http://www.os-gabrovka-dole.si/cms/'
  },
  {
    ZAVSIF: 1027,
    PRSMSS: 5689155000,
    NAZIV: 'Osnovna šola Gradec',
    NASLOV: 'Bevkova ulica 3',
    'POŠTNA ŠTEVILKA': 1270,
    POŠTA: 'Litija',
    EMAIL: 'tajnistvo@osgradec.si',
    URL: 'http://www.osgradec.si'
  },
  {
    ZAVSIF: 1346,
    PRSMSS: 5689147000,
    NAZIV: 'Osnovna šola Litija',
    NASLOV: 'Ulica Mire Pregljeve 3',
    'POŠTNA ŠTEVILKA': 1270,
    POŠTA: 'Litija',
    EMAIL: 'os-litija@siol.net',
    URL: 'http://www.o-litija.lj.edus.si/'
  },
  {
    ZAVSIF: 23135,
    PRSMSS: 6037542000,
    NAZIV: 'Inštitut Lila, OE OŠ Lila Ljubljana',
    NASLOV: 'Langusova ulica 8',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'jasna@sola-lila.si',
    URL: ''
  },
  {
    ZAVSIF: 17530,
    PRSMSS: 2234572000,
    NAZIV: 'Montessori inštitut, Zavod za pomoč staršem pri razvoju otrok',
    NASLOV: 'Sojerjeva ulica 9',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@montessori-institut.si',
    URL: ''
  },
  {
    ZAVSIF: 270,
    PRSMSS: 5089913000,
    NAZIV: 'Osnovna šola Bežigrad',
    NASLOV: 'Črtomirova ulica 12',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.osljbe@guest.arnes.si',
    URL: 'http://www.osbezigrad.com/'
  },
  {
    ZAVSIF: 314,
    PRSMSS: 5084512000,
    NAZIV: 'Osnovna šola Bičevje',
    NASLOV: 'Splitska ulica 13',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-bicevje.lj@guest.arnes.si',
    URL: 'http://www.o-bicevje.lj.edus.si/Joomla/index.php'
  },
  {
    ZAVSIF: 605,
    PRSMSS: 5623758000,
    NAZIV: 'Osnovna šola Božidarja Jakca Ljubljana',
    NASLOV: 'Nusdorferjeva ulica 10',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'natasa.krajncan@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 266,
    PRSMSS: 5083389000,
    NAZIV: 'Osnovna šola Danile Kumar',
    NASLOV: 'Gogalova ulica 15',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@os-danilekumar.si',
    URL: 'www.os-danilekumar.si/'
  },
  {
    ZAVSIF: 268,
    PRSMSS: 5083397000,
    NAZIV: 'Osnovna šola dr. Vita Kraigherja Ljubljana',
    NASLOV: 'Trg 9. maja 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'sola@vitakraigherja.si',
    URL: 'http://www.vitakraigherja.si'
  },
  {
    ZAVSIF: 303,
    PRSMSS: 5204950000,
    NAZIV: 'Osnovna šola Dravlje',
    NASLOV: 'Klopčičeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo-os.dravlje@guest.arnes.si',
    URL: 'http://www.osdravlje.si/'
  },
  {
    ZAVSIF: 302,
    PRSMSS: 5086701000,
    NAZIV: 'Osnovna šola Franca Rozmana - Staneta Ljubljana',
    NASLOV: 'Prušnikova ulica 85',
    'POŠTNA ŠTEVILKA': 1210,
    POŠTA: 'Ljubljana - Šentvid',
    EMAIL: 'osljfrs2s@guest.arnes.si',
    URL: 'http://www.osfrslj.si'
  },
  {
    ZAVSIF: 269,
    PRSMSS: 5083419000,
    NAZIV: 'Osnovna šola Franceta Bevka',
    NASLOV: 'Ulica Pohorskega bataljona 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-fb.lj@guest.arnes.si',
    URL: 'http://www.francebevk.si'
  },
  {
    ZAVSIF: 295,
    PRSMSS: 5084369000,
    NAZIV: 'Osnovna šola Hinka Smrekarja Ljubljana',
    NASLOV: 'Gorazdova ulica 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.osljhs@guest.arnes.si',
    URL: 'http://www.o-hsmrekar.lj.edus.si/'
  },
  {
    ZAVSIF: 284,
    PRSMSS: 5084954000,
    NAZIV: 'Osnovna šola Jožeta Moškriča',
    NASLOV: 'Jarška cesta 34',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os-jozemoskric.lj@guest.arnes.si',
    URL: 'http://www.o-jozmos.lj.edus.si/'
  },
  {
    ZAVSIF: 288,
    PRSMSS: 5086655000,
    NAZIV: 'Osnovna šola Karla Destovnika Kajuha Ljubljana',
    NASLOV: 'Jakčeva ulica 42',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'osljkdk@guest.arnes.si',
    URL: 'http://oskdk.mojasola.si'
  },
  {
    ZAVSIF: 17510,
    PRSMSS: 3765229000,
    NAZIV: 'Osnovna šola Kašelj',
    NASLOV: 'Kašeljska cesta 119 A',
    'POŠTNA ŠTEVILKA': 1260,
    POŠTA: 'Ljubljana - Polje',
    EMAIL: 'oskaselj.tajnistvo@guest.arnes.si',
    URL: 'http://www.oskaselj.si'
  },
  {
    ZAVSIF: 289,
    PRSMSS: 5084270000,
    NAZIV: 'Osnovna šola Ketteja in Murna',
    NASLOV: 'Koširjeva ulica 2',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@oskm.si',
    URL: 'http://www.oskm.si'
  },
  {
    ZAVSIF: 316,
    PRSMSS: 5428394000,
    NAZIV: 'Osnovna šola Kolezija',
    NASLOV: 'Cesta v Mestni log 46',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-kolezija.lj@guest.arnes.si',
    URL: 'http://www.o-kolezija.lj.edus.si/'
  },
  {
    ZAVSIF: 298,
    PRSMSS: 5062926000,
    NAZIV: 'Osnovna šola Koseze',
    NASLOV: 'Ledarska ulica 23',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@oskoseze.si',
    URL: 'http://www.oskoseze.si'
  },
  {
    ZAVSIF: 112,
    PRSMSS: 5084148000,
    NAZIV: 'Osnovna šola Ledina',
    NASLOV: 'Komenskega ulica 19',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@o-ledina.si',
    URL: 'http://www.o-ledina.si'
  },
  {
    ZAVSIF: 614,
    PRSMSS: 5375827000,
    NAZIV: 'Osnovna šola Livada',
    NASLOV: 'Ulica Dušana Kraigherja 2',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'group1.osljli@guest.arnes.si',
    URL: 'http://www.oslivada.si'
  },
  {
    ZAVSIF: 275,
    PRSMSS: 5083486000,
    NAZIV: 'Osnovna šola Majde Vrhovnik Ljubljana',
    NASLOV: 'Gregorčičeva ulica 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os.majdevrhovnik@guest.arnes.si',
    URL: 'http://www.os-majdevrhovnik.si'
  },
  {
    ZAVSIF: 285,
    PRSMSS: 5236681000,
    NAZIV: 'Osnovna šola Martina Krpana Ljubljana',
    NASLOV: 'Gašperšičeva ulica 10',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: '',
    URL: 'http://o-mkrpana.lj.edus.si/index.php'
  },
  {
    ZAVSIF: 271,
    PRSMSS: 5204291000,
    NAZIV: 'Osnovna šola Milana Šuštaršiča',
    NASLOV: 'Štembalova ulica 2 A',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'posta.osms-lj@guest.arnes.si',
    URL: 'http://www.osmslj.si/'
  },
  {
    ZAVSIF: 267,
    PRSMSS: 5084105000,
    NAZIV: 'Osnovna šola Mirana Jarca',
    NASLOV: 'Ipavčeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-mj.lj@guest.arnes.si',
    URL: 'http://www.osmj.si/'
  },
  {
    ZAVSIF: 301,
    PRSMSS: 5255279000,
    NAZIV: 'Osnovna šola Miška Kranjca',
    NASLOV: 'Kamnogoriška cesta 35',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'group1.osljmikra@guest.arnes.si',
    URL: 'http://www.osmklj.si'
  },
  {
    ZAVSIF: 272,
    PRSMSS: 5084091000,
    NAZIV: 'Osnovna šola narodnega heroja Maksa Pečarja',
    NASLOV: 'Črnuška cesta 9',
    'POŠTNA ŠTEVILKA': 1231,
    POŠTA: 'Ljubljana - Črnuče',
    EMAIL: 'osmakspecar@guest.arnes.si',
    URL: 'http://www.makspecar.si'
  },
  {
    ZAVSIF: 287,
    PRSMSS: 5280052000,
    NAZIV: 'Osnovna šola Nove Fužine',
    NASLOV: 'Preglov trg 8',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'group1.osljnf@guest.arnes.si',
    URL: 'http://www.os-novefuzine.si/'
  },
  {
    ZAVSIF: 286,
    PRSMSS: 5273935000,
    NAZIV: 'Osnovna šola Nove Jarše',
    NASLOV: 'Clevelandska ulica 11',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os-novejarse@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 315,
    PRSMSS: 5088798000,
    NAZIV: 'Osnovna šola Oskarja Kovačiča',
    NASLOV: 'Ob dolenjski železnici 48',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os-oskar.kovacic@guest.arnes.si',
    URL: 'http://www.ososkar.si'
  },
  {
    ZAVSIF: 279,
    PRSMSS: 5083494000,
    NAZIV: 'Osnovna šola Poljane Ljubljana',
    NASLOV: 'Zemljemerska ulica 7',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-poljane.lj@guest.arnes.si',
    URL: 'http://www.ospoljane.si'
  },
  {
    ZAVSIF: 293,
    PRSMSS: 5084288000,
    NAZIV: 'Osnovna šola Polje',
    NASLOV: 'Polje 358',
    'POŠTNA ŠTEVILKA': 1260,
    POŠTA: 'Ljubljana - Polje',
    EMAIL: 'o-polje.lj@guest.arnes.si',
    URL: 'http://www.ospolje.si/'
  },
  {
    ZAVSIF: 274,
    PRSMSS: 5084156000,
    NAZIV: 'Osnovna šola Prežihovega Voranca',
    NASLOV: 'Prežihova ulica 8',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@o-pv.lj.edus.si',
    URL: 'http://voranc.si/'
  },
  {
    ZAVSIF: 280,
    PRSMSS: 5084164000,
    NAZIV: 'Osnovna šola Prule',
    NASLOV: 'Prule 13',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-prule.lj@guest.arnes.si',
    URL: 'http://www.osprule.si/'
  },
  {
    ZAVSIF: 300,
    PRSMSS: 5086132000,
    NAZIV: 'Osnovna šola Riharda Jakopiča Ljubljana',
    NASLOV: 'Derčeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.osljrj@guest.arnes.si',
    URL: 'http://www.osrihardajakopica.si/'
  },
  {
    ZAVSIF: 265,
    PRSMSS: 5083362000,
    NAZIV: 'Osnovna šola Savsko naselje',
    NASLOV: 'Matjaževa ulica 4',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.ljossn@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ljossn5/'
  },
  {
    ZAVSIF: 294,
    PRSMSS: 5086124000,
    NAZIV: 'Osnovna šola Sostro',
    NASLOV: 'Cesta II. grupe odredov 47',
    'POŠTNA ŠTEVILKA': 1261,
    POŠTA: 'Ljubljana - Dobrunje',
    EMAIL: 'tajnistvo.os.sostro@guest.arnes.si',
    URL: 'http://www.os-sostro.si'
  },
  {
    ZAVSIF: 296,
    PRSMSS: 5084326000,
    NAZIV: 'Osnovna šola Spodnja Šiška',
    NASLOV: 'Gasilska cesta 17',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'o-spsiska.lj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ospsiskalj/'
  },
  {
    ZAVSIF: 305,
    PRSMSS: 5090016000,
    NAZIV: 'Osnovna šola Šentvid',
    NASLOV: 'Prušnikova ulica 98',
    'POŠTNA ŠTEVILKA': 1210,
    POŠTA: 'Ljubljana - Šentvid',
    EMAIL: 'tajnistvo.ossentvid@guest.arnes.si',
    URL: 'http://www.ossentvid.si'
  },
  {
    ZAVSIF: 306,
    PRSMSS: 5133785000,
    NAZIV: 'Osnovna šola Šmartno pod Šmarno goro',
    NASLOV: 'Cesta v Gameljne 7',
    'POŠTNA ŠTEVILKA': 1211,
    POŠTA: 'Ljubljana - Šmartno',
    EMAIL: 'os-smartno.lj@guest.arnes.si',
    URL: 'http://www.os-smartno.si/'
  },
  {
    ZAVSIF: 277,
    PRSMSS: 5088755000,
    NAZIV: 'Osnovna šola Toneta Čufarja',
    NASLOV: 'Čufarjeva ulica 11',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@tonecufar.com',
    URL: 'http://www.tonecufar.com'
  },
  {
    ZAVSIF: 312,
    PRSMSS: 5084440000,
    NAZIV: 'Osnovna šola Trnovo',
    NASLOV: 'Karunova ulica 14 A',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os.trnovo@guest.arnes.si',
    URL: 'http://www.ljudmila.org/ostrnovo'
  },
  {
    ZAVSIF: 299,
    PRSMSS: 5084342000,
    NAZIV: 'Osnovna šola Valentina Vodnika Ljubljana',
    NASLOV: 'Adamičeva ulica 16',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@o-vvodnika.lj.edus.si',
    URL: 'http://www.o-vvodnika.lj.edus.si'
  },
  {
    ZAVSIF: 317,
    PRSMSS: 5084458000,
    NAZIV: 'Osnovna šola Vič',
    NASLOV: 'Abramova ulica 26',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os.vic@guest.arnes.si',
    URL: 'http://www.osvic.si'
  },
  {
    ZAVSIF: 283,
    PRSMSS: 5084300000,
    NAZIV: 'Osnovna šola Vide Pregarc Ljubljana',
    NASLOV: 'Bazoviška ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'os-vp.lj@guest.arnes.si',
    URL: 'http://www.osvp.si/'
  },
  {
    ZAVSIF: 297,
    PRSMSS: 5084407000,
    NAZIV: 'Osnovna šola Vižmarje - Brod',
    NASLOV: 'Na gaju 2',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo-osljbr2@guest.arnes.si',
    URL: 'http://www.osbrod.si'
  },
  {
    ZAVSIF: 278,
    PRSMSS: 5083478000,
    NAZIV: 'Osnovna šola Vodmat',
    NASLOV: 'Potrčeva ulica 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo.osvodmat@guest.arnes.si',
    URL: 'http://www.osvodmat.si/'
  },
  {
    ZAVSIF: 313,
    PRSMSS: 5084989000,
    NAZIV: 'Osnovna šola Vrhovci',
    NASLOV: 'Cesta na Bokalce 1',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'O-vrhovci.lj@guest.arnes.si',
    URL: 'http://www.os-vrhovci.si/'
  },
  {
    ZAVSIF: 291,
    PRSMSS: 5205239000,
    NAZIV: 'Osnovna šola Zadobrova',
    NASLOV: 'Zadobrovška cesta 35',
    'POŠTNA ŠTEVILKA': 1260,
    POŠTA: 'Ljubljana - Polje',
    EMAIL: 'os-zadobrova.lj@guest.arnes.si',
    URL: 'http://www.os-zadobrova.si'
  },
  {
    ZAVSIF: 292,
    PRSMSS: 5084296000,
    NAZIV: 'Osnovna šola Zalog',
    NASLOV: 'Cerutova ulica 7',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'tajnistvo@o-zalog.lj.mss.edus.si',
    URL: 'http://www2.arnes.si/~osljzalog1/'
  },
  {
    ZAVSIF: 3767,
    PRSMSS: 5642574000,
    NAZIV: 'Waldorfska šola Ljubljana',
    NASLOV: 'Streliška ulica 12',
    'POŠTNA ŠTEVILKA': 1000,
    POŠTA: 'Ljubljana',
    EMAIL: 'info@waldorf.si',
    URL: 'http://www.waldorf-si.org'
  },
  {
    ZAVSIF: 340,
    PRSMSS: 5088941000,
    NAZIV: 'Osnovna šola Ljubno ob Savinji',
    NASLOV: 'Cesta v Rastke 10',
    'POŠTNA ŠTEVILKA': 3333,
    POŠTA: 'Ljubno ob Savinji',
    EMAIL: 'samo.kramer@guest.arnes.si',
    URL: 'http://www.o-ljubno.ce.edus.si/www2/glavna.htm'
  },
  {
    ZAVSIF: 330,
    PRSMSS: 5085012000,
    NAZIV: 'Osnovna šola Ivana Cankarja Ljutomer',
    NASLOV: 'Cankarjeva cesta 10',
    'POŠTNA ŠTEVILKA': 9240,
    POŠTA: 'Ljutomer',
    EMAIL: 'o-icljutomer.ms@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmsic13s/'
  },
  {
    ZAVSIF: 329,
    PRSMSS: 5084628000,
    NAZIV: 'Osnovna šola Janka Ribiča Cezanjevci',
    NASLOV: 'Cezanjevci 39',
    'POŠTNA ŠTEVILKA': 9240,
    POŠTA: 'Ljutomer',
    EMAIL: 'o-jrcezanj.ms@guest.arnes.si',
    URL: 'http://www.o-cezanjevci.ms.edus.si/'
  },
  {
    ZAVSIF: 333,
    PRSMSS: 5084610000,
    NAZIV: 'Osnovna šola Mala Nedelja',
    NASLOV: 'Mala Nedelja 37',
    'POŠTNA ŠTEVILKA': 9243,
    POŠTA: 'Mala Nedelja',
    EMAIL: 'o-mnedelja.ms@guest.arnes.si',
    URL: 'http://www2.arnes.si/~omnedeljams/'
  },
  {
    ZAVSIF: 328,
    PRSMSS: 5085004000,
    NAZIV: 'Osnovna šola Stročja vas',
    NASLOV: 'Stročja vas 101',
    'POŠTNA ŠTEVILKA': 9240,
    POŠTA: 'Ljutomer',
    EMAIL: 'o-strocjavas.ms@guest.arnes.si',
    URL: 'http://www.o-strocjavas.si'
  },
  {
    ZAVSIF: 1234,
    PRSMSS: 5912792000,
    NAZIV: 'Osnovna šola Rovte',
    NASLOV: 'Rovte 90 A',
    'POŠTNA ŠTEVILKA': 1373,
    POŠTA: 'Rovte',
    EMAIL: 'group1.osljrov@guest.arnes.si',
    URL: 'http://www.osrovte.si'
  },
  {
    ZAVSIF: 335,
    PRSMSS: 5085071000,
    NAZIV: 'Osnovna šola Tabor Logatec',
    NASLOV: 'Tržaška cesta 150',
    'POŠTNA ŠTEVILKA': 1370,
    POŠTA: 'Logatec',
    EMAIL: 'o-tablog.lj@guest.arnes.si',
    URL: 'http://www.os-tabor.si'
  },
  {
    ZAVSIF: 334,
    PRSMSS: 5084687000,
    NAZIV: 'Osnovna šola 8 talcev Logatec',
    NASLOV: 'Notranjska cesta 3',
    'POŠTNA ŠTEVILKA': 1370,
    POŠTA: 'Logatec',
    EMAIL: 'osnovna.sola@8talcev.si',
    URL: 'http://www.8talcev.si'
  },
  {
    ZAVSIF: 534,
    PRSMSS: 5207045000,
    NAZIV: 'Osnovna šola Log - Dragomer',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 1351,
    POŠTA: 'Brezovica pri Ljubljani',
    EMAIL: 'group1.osljlog@guest.arnes.si',
    URL: 'http://www.osld.si/'
  },
  {
    ZAVSIF: 148,
    PRSMSS: 5089891000,
    NAZIV: 'Osnovna šola heroja Janeza Hribarja Stari trg pri Ložu',
    NASLOV: 'Cesta Notranjskega odreda 32',
    'POŠTNA ŠTEVILKA': 1386,
    POŠTA: 'Stari trg pri Ložu',
    EMAIL: 'os.h-janeza-hribarja@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljjh4/'
  },
  {
    ZAVSIF: 448,
    PRSMSS: 5087422000,
    NAZIV: 'Osnovna šola dr. Antona Debeljaka Loški Potok',
    NASLOV: 'Hrib-Loški Potok 101',
    'POŠTNA ŠTEVILKA': 1318,
    POŠTA: 'Loški Potok',
    EMAIL: 'os-loskipotok@guest.arnes.si',
    URL: 'http://www.os-loskipotok.si'
  },
  {
    ZAVSIF: 1203,
    PRSMSS: 5085179000,
    NAZIV: 'Osnovna šola Lovrenc na Pohorju',
    NASLOV: 'Šolska ulica 6',
    'POŠTNA ŠTEVILKA': 2344,
    POŠTA: 'Lovrenc na Pohorju',
    EMAIL: 'o-lovrenc.mb@guest.arnes.si',
    URL: 'http://www.oslovrenc.si/'
  },
  {
    ZAVSIF: 341,
    PRSMSS: 5085551000,
    NAZIV: 'Osnovna šola Blaža Arniča Luče',
    NASLOV: 'Luče 77',
    'POŠTNA ŠTEVILKA': 3334,
    POŠTA: 'Luče',
    EMAIL: 'os-luce@guest.arnes.si',
    URL: 'http://www.os-luce.si'
  },
  {
    ZAVSIF: 157,
    PRSMSS: 5082790000,
    NAZIV: 'Osnovna šola Janka Kersnika Brdo',
    NASLOV: 'Brdo pri Lukovici 5',
    'POŠTNA ŠTEVILKA': 1225,
    POŠTA: 'Lukovica',
    EMAIL: 'osjkbrdo@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljjk1s/'
  },
  {
    ZAVSIF: 422,
    PRSMSS: 5087074000,
    NAZIV: 'Osnovna šola Majšperk',
    NASLOV: 'Majšperk 32 B',
    'POŠTNA ŠTEVILKA': 2322,
    POŠTA: 'Majšperk',
    EMAIL: 'os.majsperk@guest.arnes.si',
    URL: 'http://www2.arnes.si/~omajsperkmb/'
  },
  {
    ZAVSIF: 476,
    PRSMSS: 5087651000,
    NAZIV: 'Osnovna šola Anice Černejeve Makole',
    NASLOV: 'Makole 24',
    'POŠTNA ŠTEVILKA': 2321,
    POŠTA: 'Makole',
    EMAIL: 'info@os-makole.si',
    URL: 'http://os-makole.si/'
  },
  {
    ZAVSIF: 560,
    PRSMSS: 5085187000,
    NAZIV: 'Osnovna šola Angela Besednjaka Maribor',
    NASLOV: 'Celjska ulica 11',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'group1.osmbab@guest.arnes.si',
    URL: 'http://www.o-abesednjaka.mb.edus.si/'
  },
  {
    ZAVSIF: 557,
    PRSMSS: 5085110000,
    NAZIV: 'Osnovna šola Bojana Ilicha Maribor',
    NASLOV: 'Mladinska ulica 13',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo@osbi.si',
    URL: 'http://www.osbi.si'
  },
  {
    ZAVSIF: 558,
    PRSMSS: 5197449000,
    NAZIV: 'Osnovna šola "Borcev za severno mejo" Maribor',
    NASLOV: 'Borcev za severno mejo 16',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo.osmbbsm@guest.arnes.si',
    URL: 'http://www.os-borcev.si/'
  },
  {
    ZAVSIF: 559,
    PRSMSS: 5085080000,
    NAZIV: 'Osnovna šola bratov Polančičev Maribor',
    NASLOV: 'Prešernova ulica 19',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@osbp.si',
    URL: 'http://www.osbp.si'
  },
  {
    ZAVSIF: 564,
    PRSMSS: 5085250000,
    NAZIV: 'Osnovna šola Draga Kobala Maribor',
    NASLOV: 'Tolstojeva ulica 3',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@os-dragakobala.si',
    URL: 'http://www.os-dragakobala.si/'
  },
  {
    ZAVSIF: 565,
    PRSMSS: 5085837000,
    NAZIV: 'Osnovna šola Franca Rozmana - Staneta Maribor',
    NASLOV: 'Kersnikova ulica 10',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@o-frs.mb.edus.si',
    URL: 'http://www.o-frs.mb.edus.si'
  },
  {
    ZAVSIF: 556,
    PRSMSS: 5085195000,
    NAZIV: 'Osnovna šola Franceta Prešerna Maribor',
    NASLOV: 'Žolgarjeva ulica 2',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'os-f.preserna-mb@guest.arnes.si',
    URL: 'http://www.o-fpreserna.mb.edus.si/'
  },
  {
    ZAVSIF: 561,
    PRSMSS: 5085217000,
    NAZIV: 'Osnovna šola Janka Padežnika Maribor',
    NASLOV: 'Iztokova ulica 6',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'o-jp.mb@guest.arnes.si',
    URL: 'http://www.padeznik-mojasola.si/'
  },
  {
    ZAVSIF: 581,
    PRSMSS: 5086710000,
    NAZIV: 'Osnovna šola Kamnica',
    NASLOV: 'Vrbanska cesta 93',
    'POŠTNA ŠTEVILKA': 2351,
    POŠTA: 'Kamnica',
    EMAIL: 'o-kamnica.mb@guest.arnes.si',
    URL: 'http://www.os-kamnica.si'
  },
  {
    ZAVSIF: 604,
    PRSMSS: 5610494000,
    NAZIV: 'Osnovna šola Leona Štuklja Maribor',
    NASLOV: 'Klinetova ulica 18',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'osleonastuklja@guest.arnes.si',
    URL: 'http://www.os-leon.si'
  },
  {
    ZAVSIF: 568,
    PRSMSS: 5086728000,
    NAZIV: 'Osnovna šola Ludvika Pliberška Maribor',
    NASLOV: 'Lackova cesta 4',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'tajnistvo-ludvika.mb@guest.arnes.si',
    URL: 'http://www.ludvik.si/'
  },
  {
    ZAVSIF: 563,
    PRSMSS: 5085209000,
    NAZIV: 'Osnovna šola Maksa Durjave Maribor',
    NASLOV: 'Ruška cesta 15',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'os-maksa.durjave@guest.arnes.si',
    URL: 'http://www.o-md.mb.edus.si'
  },
  {
    ZAVSIF: 554,
    PRSMSS: 5206634000,
    NAZIV: 'Osnovna šola Malečnik',
    NASLOV: 'Malečnik 61',
    'POŠTNA ŠTEVILKA': 2229,
    POŠTA: 'Malečnik',
    EMAIL: 'marjanca.nekrep@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmbmale2/'
  },
  {
    ZAVSIF: 555,
    PRSMSS: 5085268000,
    NAZIV: 'Osnovna šola Martina Konšaka Maribor',
    NASLOV: 'Prekmurska ulica 67',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@konsak.si',
    URL: 'http://www.konsak.si/'
  },
  {
    ZAVSIF: 553,
    PRSMSS: 5085101000,
    NAZIV: 'Osnovna šola Prežihovega Voranca Maribor',
    NASLOV: 'Gosposvetska cesta 10',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'info@o-pvoranca.edus.si',
    URL: 'http://www.o-pvoranca.mb.edus.si/'
  },
  {
    ZAVSIF: 580,
    PRSMSS: 5085845000,
    NAZIV: 'Osnovna šola Rada Robiča Limbuš',
    NASLOV: 'Limbuška cesta 62',
    'POŠTNA ŠTEVILKA': 2341,
    POŠTA: 'Limbuš',
    EMAIL: 'o-rrlimbus.mb@guest.arnes.si',
    URL: 'http://www.oslimbus.si/'
  },
  {
    ZAVSIF: 567,
    PRSMSS: 5085322000,
    NAZIV: 'Osnovna šola Slave Klavore Maribor',
    NASLOV: 'Štrekljeva ulica 31',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'os.slave-klavore@guest.arnes.si',
    URL: 'http://www.solaklavora.si'
  },
  {
    ZAVSIF: 603,
    PRSMSS: 5610508000,
    NAZIV: 'Osnovna šola Tabor I Maribor',
    NASLOV: 'Ulica Arnolda Tovornika 21',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'projekt1.osmbtabi@guest.arnes.si',
    URL: 'http://www.os-tabor1.si/'
  },
  {
    ZAVSIF: 562,
    PRSMSS: 5085284000,
    NAZIV: 'Osnovna šola Toneta Čufarja Maribor',
    NASLOV: 'Zrkovska cesta 67',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'os-tcufarja.mb@guest.arnes.si',
    URL: 'http://www.cufar.si'
  },
  {
    ZAVSIF: 21915,
    PRSMSS: 6651518000,
    NAZIV: 'Waldorfska šola Maribor',
    NASLOV: 'Valvasorjeva ulica 75',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'waldorf@amis.net',
    URL: ''
  },
  {
    ZAVSIF: 21875,
    PRSMSS: 5921449003,
    NAZIV: 'Zavod Antona Martina Slomška Maribor, Osnovna šola Montessori',
    NASLOV: 'Vrbanska cesta 30',
    'POŠTNA ŠTEVILKA': 2000,
    POŠTA: 'Maribor',
    EMAIL: 'stanka.cremoznik@z-ams.si',
    URL: ''
  },
  {
    ZAVSIF: 417,
    PRSMSS: 5087104000,
    NAZIV: 'Osnovna šola Markovci',
    NASLOV: 'Markovci 33 D',
    'POŠTNA ŠTEVILKA': 2281,
    POŠTA: 'Markovci',
    EMAIL: 'info@os-markovci.net',
    URL: 'http://www.os-markovci.net/'
  },
  {
    ZAVSIF: 307,
    PRSMSS: 5222575000,
    NAZIV: 'Osnovna šola Medvode',
    NASLOV: 'Ostrovrharjeva ulica 4',
    'POŠTNA ŠTEVILKA': 1215,
    POŠTA: 'Medvode',
    EMAIL: 'os.medvode@guest.arnes.si',
    URL: 'http://www.os-medvode.si/'
  },
  {
    ZAVSIF: 309,
    PRSMSS: 5084393000,
    NAZIV: 'Osnovna šola Pirniče',
    NASLOV: 'Zgornje Pirniče 37 B',
    'POŠTNA ŠTEVILKA': 1215,
    POŠTA: 'Medvode',
    EMAIL: 'sola-pirnice.osljpi@guest.arnes.si',
    URL: 'http://www.os-pirnice.si'
  },
  {
    ZAVSIF: 308,
    PRSMSS: 5084334000,
    NAZIV: 'Osnovna šola Preska',
    NASLOV: 'Preška cesta 22',
    'POŠTNA ŠTEVILKA': 1215,
    POŠTA: 'Medvode',
    EMAIL: 'o-preska.lj@guest.arnes.si',
    URL: 'http://www.os-preska.si/'
  },
  {
    ZAVSIF: 310,
    PRSMSS: 5084385000,
    NAZIV: 'Osnovna šola Simona Jenka',
    NASLOV: 'Smlednik 73',
    'POŠTNA ŠTEVILKA': 1216,
    POŠTA: 'Smlednik',
    EMAIL: 'Marko.valencic@guest.arnes.si',
    URL: 'http://www.ossjsmlednik.si'
  },
  {
    ZAVSIF: 164,
    PRSMSS: 5082820000,
    NAZIV: 'Osnovna šola Mengeš',
    NASLOV: 'Šolska ulica 11',
    'POŠTNA ŠTEVILKA': 1234,
    POŠTA: 'Mengeš',
    EMAIL: 'o-menges.lj@guest.arnes.si',
    URL: 'http://www.osmenges.si'
  },
  {
    ZAVSIF: 336,
    PRSMSS: 5088925000,
    NAZIV: 'Osnovna šola Metlika',
    NASLOV: 'Šolska ulica 7',
    'POŠTNA ŠTEVILKA': 8330,
    POŠTA: 'Metlika',
    EMAIL: 'os.metlika1@guest.arnes.si',
    URL: 'http://www.osmetlika.si/'
  },
  {
    ZAVSIF: 338,
    PRSMSS: 5085543000,
    NAZIV: 'Osnovna šola Podzemelj',
    NASLOV: 'Podzemelj 11 A',
    'POŠTNA ŠTEVILKA': 8332,
    POŠTA: 'Gradac',
    EMAIL: 'os.podzemelj@guest.arnes.si',
    URL: 'http://ospodzemelj.si/'
  },
  {
    ZAVSIF: 443,
    PRSMSS: 5087376000,
    NAZIV: 'Osnovna šola Mežica',
    NASLOV: 'Partizanska cesta 16',
    'POŠTNA ŠTEVILKA': 2392,
    POŠTA: 'Mežica',
    EMAIL: 'o-mezica.mb@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 576,
    PRSMSS: 5085276000,
    NAZIV: 'Osnovna šola Miklavž na Dravskem polju',
    NASLOV: 'Cesta v Dobrovce 21',
    'POŠTNA ŠTEVILKA': 2204,
    POŠTA: 'Miklavž na Dravskem polju',
    EMAIL: 'sola-miklavz@guest.arnes.si',
    URL: 'http://www.sola-miklavz.si'
  },
  {
    ZAVSIF: 368,
    PRSMSS: 5085829000,
    NAZIV: 'Osnovna šola Miren',
    NASLOV: 'Miren 140',
    'POŠTNA ŠTEVILKA': 5291,
    POŠTA: 'Miren',
    EMAIL: 'os-miren@os-miren.si',
    URL: 'http://www.os-miren.si/'
  },
  {
    ZAVSIF: 517,
    PRSMSS: 5090083000,
    NAZIV: 'Osnovna šola Mirna',
    NASLOV: 'Cesta na Fužine 1',
    'POŠTNA ŠTEVILKA': 8233,
    POŠTA: 'Mirna',
    EMAIL: 'o-mirna.nm@guest.arnes.si',
    URL: 'http://www.os-mirna.si/'
  },
  {
    ZAVSIF: 380,
    PRSMSS: 5086256000,
    NAZIV: 'Osnovna šola Toneta Pavčka',
    NASLOV: 'Postaja 1',
    'POŠTNA ŠTEVILKA': 8216,
    POŠTA: 'Mirna Peč',
    EMAIL: 'o-mirnapec.nm@guest.arnes.si',
    URL: 'http://www.osmirnapec.si'
  },
  {
    ZAVSIF: 467,
    PRSMSS: 5087589000,
    NAZIV: 'Osnovna šola Mislinja',
    NASLOV: 'Šentilj pod Turjakom 1',
    'POŠTNA ŠTEVILKA': 2382,
    POŠTA: 'Mislinja',
    EMAIL: 'o-mislinja.mb@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 515,
    PRSMSS: 5088062000,
    NAZIV: 'Osnovna šola Mokronog',
    NASLOV: 'Gubčeva cesta 4',
    'POŠTNA ŠTEVILKA': 8230,
    POŠTA: 'Mokronog',
    EMAIL: 'os.mokronog@guest.arnes.si',
    URL: 'http://www.osmokronog.si/'
  },
  {
    ZAVSIF: 167,
    PRSMSS: 5082838000,
    NAZIV: 'Osnovna šola Jurija Vege',
    NASLOV: 'Vegova ulica 38',
    'POŠTNA ŠTEVILKA': 1251,
    POŠTA: 'Moravče',
    EMAIL: 'o-jvmoravce.lj@guest.arnes.si',
    URL: 'http://www.osmoravce.si'
  },
  {
    ZAVSIF: 348,
    PRSMSS: 5243289000,
    NAZIV: 'Dvojezična osnovna šola Prosenjakovci',
    NASLOV: 'Prosenjakovci 97 C',
    'POŠTNA ŠTEVILKA': 9207,
    POŠTA: 'Prosenjakovci - Pártosfalva',
    EMAIL: 'dos-prosenjakovci@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 350,
    PRSMSS: 5088976000,
    NAZIV: 'Osnovna šola Bogojina',
    NASLOV: 'Bogojina 134',
    'POŠTNA ŠTEVILKA': 9222,
    POŠTA: 'Bogojina',
    EMAIL: 'group1.osmsbo@guest.arnes.si',
    URL: 'http://www.osbogojina.si'
  },
  {
    ZAVSIF: 349,
    PRSMSS: 5085624000,
    NAZIV: 'Osnovna šola Fokovci',
    NASLOV: 'Fokovci 32',
    'POŠTNA ŠTEVILKA': 9208,
    POŠTA: 'Fokovci',
    EMAIL: 'osmsfo1s@guest.arnes.si',
    URL: 'http://www.o-fokovci.si'
  },
  {
    ZAVSIF: 339,
    PRSMSS: 5088950000,
    NAZIV: 'Osnovna šola Mozirje',
    NASLOV: 'Šolska ulica 23',
    'POŠTNA ŠTEVILKA': 3330,
    POŠTA: 'Mozirje',
    EMAIL: 'o-mozirje.ce@guest.arnes.si',
    URL: 'http://sola.os-mozirje.si/'
  },
  {
    ZAVSIF: 343,
    PRSMSS: 5088968000,
    NAZIV: 'Osnovna šola Bakovci',
    NASLOV: 'Poljska ulica 2',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'info@osbakovci.si',
    URL: 'http://www.osbakovci.si/'
  },
  {
    ZAVSIF: 634,
    PRSMSS: 5640245000,
    NAZIV: 'Osnovna šola I Murska Sobota',
    NASLOV: 'Ulica Štefana Kovača 32',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'oims@guest.arnes.si',
    URL: 'http://www.osena.si'
  },
  {
    ZAVSIF: 635,
    PRSMSS: 5640270000,
    NAZIV: 'Osnovna šola II Murska Sobota',
    NASLOV: 'Cankarjeva ulica 91',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'os2.ms@guest.arnes.si',
    URL: 'http://www.os2ms.si'
  },
  {
    ZAVSIF: 636,
    PRSMSS: 5640261000,
    NAZIV: 'Osnovna šola III Murska Sobota',
    NASLOV: 'Trstenjakova ulica 73',
    'POŠTNA ŠTEVILKA': 9000,
    POŠTA: 'Murska Sobota',
    EMAIL: 'o-3.ms@guest.arnes.si',
    URL: 'http://os3ms.si/joomla/'
  },
  {
    ZAVSIF: 429,
    PRSMSS: 5087287000,
    NAZIV: 'Osnovna šola Muta',
    NASLOV: 'Šolska ulica 6',
    'POŠTNA ŠTEVILKA': 2366,
    POŠTA: 'Muta',
    EMAIL: 'group1.ossgmu@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ossgmu1s'
  },
  {
    ZAVSIF: 1312,
    PRSMSS: 1193830000,
    NAZIV: 'Osnovna šola Naklo',
    NASLOV: 'Glavna cesta 47',
    'POŠTNA ŠTEVILKA': 4202,
    POŠTA: 'Naklo',
    EMAIL: 'tajnistvo@os-naklo.si',
    URL: 'http://www.os-naklo.si'
  },
  {
    ZAVSIF: 1374,
    PRSMSS: 1253484000,
    NAZIV: 'Osnovna šola Nazarje',
    NASLOV: 'Zadrečka cesta 37',
    'POŠTNA ŠTEVILKA': 3331,
    POŠTA: 'Nazarje',
    EMAIL: 'os.nazarje@guest.arnes.si',
    URL: 'www.os-nazarje.si'
  },
  {
    ZAVSIF: 371,
    PRSMSS: 5085799000,
    NAZIV: 'Osnovna šola Branik',
    NASLOV: 'Branik 31',
    'POŠTNA ŠTEVILKA': 5295,
    POŠTA: 'Branik',
    EMAIL: 'o-branik.ng@guest.arnes.si',
    URL: 'http://os-branik.si'
  },
  {
    ZAVSIF: 364,
    PRSMSS: 5088992000,
    NAZIV: 'Osnovna šola Čepovan',
    NASLOV: 'Čepovan 87',
    'POŠTNA ŠTEVILKA': 5253,
    POŠTA: 'Čepovan',
    EMAIL: 'projekt1.osngcep@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osngcep/index/'
  },
  {
    ZAVSIF: 370,
    PRSMSS: 5085802000,
    NAZIV: 'Osnovna šola Dornberk',
    NASLOV: 'Gregorčičeva ulica 30 A',
    'POŠTNA ŠTEVILKA': 5294,
    POŠTA: 'Dornberk',
    EMAIL: 'os.dornberk@guest.arnes.si',
    URL: 'http://www.os-dornberk.si'
  },
  {
    ZAVSIF: 357,
    PRSMSS: 5221625000,
    NAZIV: 'Osnovna šola Frana Erjavca Nova Gorica',
    NASLOV: 'Kidričeva ulica 36',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'tajnistvo.osngfe@guest.arnes.si',
    URL: 'http://www.os-franaerjavca.si/'
  },
  {
    ZAVSIF: 358,
    PRSMSS: 5089352000,
    NAZIV: 'Osnovna šola Milojke Štrukelj Nova Gorica',
    NASLOV: 'Delpinova ulica 7',
    'POŠTNA ŠTEVILKA': 5000,
    POŠTA: 'Nova Gorica',
    EMAIL: 'o-ms.ng@guest.arnes.si',
    URL: 'http://os-ms.s-tsc.ng.edus.si/'
  },
  {
    ZAVSIF: 359,
    PRSMSS: 5089042000,
    NAZIV: 'Osnovna šola Solkan',
    NASLOV: 'Šolska ulica 25',
    'POŠTNA ŠTEVILKA': 5250,
    POŠTA: 'Solkan',
    EMAIL: 'o-solkan.ng@guest.arnes.si',
    URL: 'http://www.sola-solkan.si'
  },
  {
    ZAVSIF: 365,
    PRSMSS: 5086353000,
    NAZIV: 'Osnovna šola Šempas',
    NASLOV: 'Šempas 76 C',
    'POŠTNA ŠTEVILKA': 5261,
    POŠTA: 'Šempas',
    EMAIL: 'os.sempas@guest.arnes.si',
    URL: 'http://www.ossempas.si/'
  },
  {
    ZAVSIF: 377,
    PRSMSS: 5086868000,
    NAZIV: 'Osnovna šola Bršljin',
    NASLOV: 'Kočevarjeva ulica 40',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'info@brsljin.si',
    URL: 'http://www.brsljin.si'
  },
  {
    ZAVSIF: 383,
    PRSMSS: 5086361000,
    NAZIV: 'Osnovna šola Brusnice',
    NASLOV: 'Velike Brusnice 101',
    'POŠTNA ŠTEVILKA': 8321,
    POŠTA: 'Brusnice',
    EMAIL: 'o-brusnice.nm@guest.arnes.si',
    URL: 'http://www.os-brusnice.si'
  },
  {
    ZAVSIF: 376,
    PRSMSS: 5086825000,
    NAZIV: 'Osnovna šola Center Novo mesto',
    NASLOV: 'Seidlova cesta 7',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'o-center.nm@guest.arnes.si',
    URL: 'http://www.os-center.si/'
  },
  {
    ZAVSIF: 9854,
    PRSMSS: 1574710000,
    NAZIV: 'Osnovna šola Drska',
    NASLOV: 'Ulica Slavka Gruma 63',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'info@os-drska.si',
    URL: 'http://www.os-drska.si'
  },
  {
    ZAVSIF: 374,
    PRSMSS: 5086850000,
    NAZIV: 'Osnovna šola Grm Novo mesto',
    NASLOV: 'Trdinova ulica 7',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'o-grm.nm@guest.arnes.si',
    URL: 'http://www.osgrm.si/'
  },
  {
    ZAVSIF: 372,
    PRSMSS: 5086264000,
    NAZIV: 'Osnovna šola Otočec',
    NASLOV: 'Šolska cesta 20',
    'POŠTNA ŠTEVILKA': 8222,
    POŠTA: 'Otočec',
    EMAIL: 'tajnistvo@os-otocec.si',
    URL: 'http://www.os-otocec.si'
  },
  {
    ZAVSIF: 384,
    PRSMSS: 5086833000,
    NAZIV: 'Osnovna šola Stopiče',
    NASLOV: 'Stopiče 37',
    'POŠTNA ŠTEVILKA': 8322,
    POŠTA: 'Stopiče',
    EMAIL: 'os.stopice@guest.arnes.si',
    URL: 'http://www.osstopice.si'
  },
  {
    ZAVSIF: 375,
    PRSMSS: 5086841000,
    NAZIV: 'Osnovna šola Šmihel',
    NASLOV: 'Šmihel 2',
    'POŠTNA ŠTEVILKA': 8000,
    POŠTA: 'Novo mesto',
    EMAIL: 'ossmihel.novom@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 261,
    PRSMSS: 5089743000,
    NAZIV: 'Osnovna šola Odranci',
    NASLOV: 'Prešernova ulica 1',
    'POŠTNA ŠTEVILKA': 9233,
    POŠTA: 'Odranci',
    EMAIL: 'os.odranci@guest.arnes.si',
    URL: 'http://www.os-odranci.si/'
  },
  {
    ZAVSIF: 472,
    PRSMSS: 5087660000,
    NAZIV: 'Osnovna šola Pohorskega bataljona Oplotnica',
    NASLOV: 'Ulica Pohorskega bataljona 19',
    'POŠTNA ŠTEVILKA': 2317,
    POŠTA: 'Oplotnica',
    EMAIL: 'o-pobaoplot.mb@guest.arnes.si',
    URL: 'http://www.osoplotnica.si/'
  },
  {
    ZAVSIF: 1233,
    PRSMSS: 5900026000,
    NAZIV: 'Osnovna šola Ivanjkovci',
    NASLOV: 'Ivanjkovci 71 A',
    'POŠTNA ŠTEVILKA': 2259,
    POŠTA: 'Ivanjkovci',
    EMAIL: 'o-ivanjkovci.mb@guest.arnes.si',
    URL: 'http://www.os-ivanjkovci.si'
  },
  {
    ZAVSIF: 394,
    PRSMSS: 5089158000,
    NAZIV: 'Osnovna šola Miklavž pri Ormožu',
    NASLOV: 'Miklavž pri Ormožu 29',
    'POŠTNA ŠTEVILKA': 2275,
    POŠTA: 'Miklavž pri Ormožu',
    EMAIL: 'osmbmi1s@guest.arnes.si',
    URL: 'http://www.os-miklavz.si/'
  },
  {
    ZAVSIF: 390,
    PRSMSS: 5089875000,
    NAZIV: 'Osnovna šola Ormož',
    NASLOV: 'Hardek 5',
    'POŠTNA ŠTEVILKA': 2270,
    POŠTA: 'Ormož',
    EMAIL: 'os.ormoz@guest.arnes.si',
    URL: 'http://www.osormoz.si/'
  },
  {
    ZAVSIF: 393,
    PRSMSS: 5090148000,
    NAZIV: 'Osnovna šola Velika Nedelja',
    NASLOV: 'Velika Nedelja 13',
    'POŠTNA ŠTEVILKA': 2274,
    POŠTA: 'Velika Nedelja',
    EMAIL: 'o-vn.mb@guest.arnes.si',
    URL: 'http://www.o-vn.mb.edus.si'
  },
  {
    ZAVSIF: 587,
    PRSMSS: 5088836000,
    NAZIV: 'Osnovna šola Jakobski Dol',
    NASLOV: 'Spodnji Jakobski Dol 4',
    'POŠTNA ŠTEVILKA': 2222,
    POŠTA: 'Jakobski dol',
    EMAIL: 'zdravko.sostaric@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ojakobskidolmb/'
  },
  {
    ZAVSIF: 586,
    PRSMSS: 5088844000,
    NAZIV: 'Osnovna šola Jarenina',
    NASLOV: 'Jareninski Dol 26',
    'POŠTNA ŠTEVILKA': 2221,
    POŠTA: 'Jarenina',
    EMAIL: 'os.mb-jarenina@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmbjare2/'
  },
  {
    ZAVSIF: 583,
    PRSMSS: 5085128000,
    NAZIV: 'Osnovna šola Pesnica',
    NASLOV: 'Pesnica pri Mariboru 44',
    'POŠTNA ŠTEVILKA': 2211,
    POŠTA: 'Pesnica pri Mariboru',
    EMAIL: 'info@ospesnica.si',
    URL: ''
  },
  {
    ZAVSIF: 399,
    PRSMSS: 5090075000,
    NAZIV: 'Osnovna šola Cirila Kosmača Piran',
    NASLOV: 'Oljčna pot 24',
    'POŠTNA ŠTEVILKA': 6330,
    POŠTA: 'Piran - Pirano',
    EMAIL: 'os-ciril.kosmac@guest.arnes.si',
    URL: 'http://www.o-ckpiran.kp.edus.si'
  },
  {
    ZAVSIF: 396,
    PRSMSS: 5089174000,
    NAZIV: 'Osnovna šola Lucija',
    NASLOV: 'Fazan 1',
    'POŠTNA ŠTEVILKA': 6320,
    POŠTA: 'Portorož - Portorose',
    EMAIL: 'info@oslucija.si',
    URL: 'http://www.oslucija.si/'
  },
  {
    ZAVSIF: 400,
    PRSMSS: 5086876000,
    NAZIV: 'Osnovna šola Sečovlje',
    NASLOV: 'Sečovlje 78',
    'POŠTNA ŠTEVILKA': 6333,
    POŠTA: 'Sečovlje - Sicciole',
    EMAIL: 'uprava@os-secovlje.net',
    URL: 'http://www.os-secovlje.net'
  },
  {
    ZAVSIF: 398,
    PRSMSS: 5086442000,
    NAZIV: 'Osnovna šola Vincenzo e Diego de Castro Piran',
    NASLOV: 'Vojkova ulica 1',
    'POŠTNA ŠTEVILKA': 6330,
    POŠTA: 'Piran - Pirano',
    EMAIL: 'decastro@siol.net',
    URL: ''
  },
  {
    ZAVSIF: 404,
    PRSMSS: 5086922000,
    NAZIV: 'Osnovna šola Košana',
    NASLOV: 'Dolnja Košana 61',
    'POŠTNA ŠTEVILKA': 6256,
    POŠTA: 'Košana',
    EMAIL: 'o-kosana.po@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 405,
    PRSMSS: 5089212000,
    NAZIV: 'Osnovna šola Pivka',
    NASLOV: 'Prečna ulica 3',
    'POŠTNA ŠTEVILKA': 6257,
    POŠTA: 'Pivka',
    EMAIL: 'os.pivka@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ospivka'
  },
  {
    ZAVSIF: 501,
    PRSMSS: 5087945000,
    NAZIV: 'Osnovna šola Podčetrtek',
    NASLOV: 'Trška cesta 66',
    'POŠTNA ŠTEVILKA': 3254,
    POŠTA: 'Podčetrtek',
    EMAIL: 'group1.oscepo@guest.arnes.si',
    URL: 'http://www.os-podcetrtek.si/'
  },
  {
    ZAVSIF: 420,
    PRSMSS: 5087112000,
    NAZIV: 'Osnovna šola Podlehnik',
    NASLOV: 'Podlehnik 7 A',
    'POŠTNA ŠTEVILKA': 2286,
    POŠTA: 'Podlehnik',
    EMAIL: 'os-mk.podlehnik@guest.arnes.si',
    URL: 'http://www.sola-podlehnik.si/'
  },
  {
    ZAVSIF: 427,
    PRSMSS: 5089816000,
    NAZIV: 'Osnovna šola Brezno - Podvelka',
    NASLOV: 'Brezno 78',
    'POŠTNA ŠTEVILKA': 2363,
    POŠTA: 'Podvelka',
    EMAIL: 'os.brezno-podvelka@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 475,
    PRSMSS: 5087678000,
    NAZIV: 'Osnovna šola Kajetana Koviča Poljčane',
    NASLOV: 'Dravinjska cesta 26',
    'POŠTNA ŠTEVILKA': 2319,
    POŠTA: 'Poljčane',
    EMAIL: 'o-poljcane.mb@guest.arnes.si',
    URL: 'http://www.ospoljcane.si/'
  },
  {
    ZAVSIF: 551,
    PRSMSS: 5088500000,
    NAZIV: 'Osnovna šola Polzela',
    NASLOV: 'Šolska ulica 3',
    'POŠTNA ŠTEVILKA': 3313,
    POŠTA: 'Polzela',
    EMAIL: 'tajnistvo-os.polzela1@siol.net',
    URL: 'http://www.os-polzela.net/'
  },
  {
    ZAVSIF: 402,
    PRSMSS: 5496829000,
    NAZIV: 'Osnovna šola Antona Globočnika Postojna',
    NASLOV: 'Cesta na Kremenco 2',
    'POŠTNA ŠTEVILKA': 6230,
    POŠTA: 'Postojna',
    EMAIL: 'os.antona-globocnika-po@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ospoag1/'
  },
  {
    ZAVSIF: 401,
    PRSMSS: 5496837000,
    NAZIV: 'Osnovna šola Miroslava Vilharja Postojna',
    NASLOV: 'Trg padlih borcev 1 A',
    'POŠTNA ŠTEVILKA': 6230,
    POŠTA: 'Postojna',
    EMAIL: 'tajnistvo.vilhar@guest.arnes.si',
    URL: 'http://www.miroslav-vilhar.si'
  },
  {
    ZAVSIF: 406,
    PRSMSS: 5086949000,
    NAZIV: 'Osnovna šola Prestranek',
    NASLOV: 'Ulica 25. maja 14 A',
    'POŠTNA ŠTEVILKA': 6258,
    POŠTA: 'Prestranek',
    EMAIL: 'os.prestranek@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ospopr2s/'
  },
  {
    ZAVSIF: 550,
    PRSMSS: 5088518000,
    NAZIV: 'Osnovna šola Prebold',
    NASLOV: 'Graščinska cesta 7',
    'POŠTNA ŠTEVILKA': 3312,
    POŠTA: 'Prebold',
    EMAIL: 'os.prebold@guest.arnes.si',
    URL: 'http://www.prebold.com/sola/'
  },
  {
    ZAVSIF: 231,
    PRSMSS: 5083214000,
    NAZIV: 'Osnovna šola Matije Valjavca Preddvor',
    NASLOV: 'Šolska ulica 9',
    'POŠTNA ŠTEVILKA': 4205,
    POŠTA: 'Preddvor',
    EMAIL: 'group2.oskrmv@guest.arnes.si',
    URL: 'http://www.os-preddvor.si'
  },
  {
    ZAVSIF: 442,
    PRSMSS: 5087384000,
    NAZIV: 'Osnovna šola Franja Goloba Prevalje',
    NASLOV: 'Polje 4',
    'POŠTNA ŠTEVILKA': 2391,
    POŠTA: 'Prevalje',
    EMAIL: 'o-fgprevalje.mb@guest.arnes.si',
    URL: 'http://os-prevalje.mojasola.si/default.aspx'
  },
  {
    ZAVSIF: 409,
    PRSMSS: 5087155000,
    NAZIV: 'Osnovna šola Breg',
    NASLOV: 'Rogaška cesta 6',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'tajnistvo@o-breg.mb.mss.edus.si',
    URL: 'http://www.os-breg.si'
  },
  {
    ZAVSIF: 410,
    PRSMSS: 5087147000,
    NAZIV: 'Osnovna šola Ljudski vrt Ptuj',
    NASLOV: 'Župančičeva ulica 10',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'o-ljvrtptuj.mb@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmblv1s'
  },
  {
    ZAVSIF: 407,
    PRSMSS: 5087163000,
    NAZIV: 'Osnovna šola Mladika Ptuj',
    NASLOV: 'Žnidaričevo nabrežje 1',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'info@mladika.si',
    URL: 'http://www.mladika.si'
  },
  {
    ZAVSIF: 408,
    PRSMSS: 5174309000,
    NAZIV: 'Osnovna šola Olge Meglič',
    NASLOV: 'Prešernova ulica 31',
    'POŠTNA ŠTEVILKA': 2250,
    POŠTA: 'Ptuj',
    EMAIL: 'group1.osmbom@guest.arnes.si',
    URL: 'http://www.olgica.si/'
  },
  {
    ZAVSIF: 345,
    PRSMSS: 5085691000,
    NAZIV: 'Osnovna šola Puconci',
    NASLOV: 'Puconci 178',
    'POŠTNA ŠTEVILKA': 9201,
    POŠTA: 'Puconci',
    EMAIL: 'ospuconci@ospuconci.si',
    URL: ''
  },
  {
    ZAVSIF: 578,
    PRSMSS: 5085241000,
    NAZIV: 'Osnovna šola Fram',
    NASLOV: 'Turnerjeva ulica 120',
    'POŠTNA ŠTEVILKA': 2313,
    POŠTA: 'Fram',
    EMAIL: 'group1.osmbf@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 579,
    PRSMSS: 5085292000,
    NAZIV: 'Osnovna šola Rače',
    NASLOV: 'Grajski trg 1',
    'POŠTNA ŠTEVILKA': 2327,
    POŠTA: 'Rače',
    EMAIL: 'os.race@guest.arnes.si',
    URL: 'http://www.osrace.si'
  },
  {
    ZAVSIF: 1342,
    PRSMSS: 5924502000,
    NAZIV: 'Javni zavod Osnovna šola Marjana Nemca Radeče',
    NASLOV: 'Šolska pot 5',
    'POŠTNA ŠTEVILKA': 1433,
    POŠTA: 'Radeče',
    EMAIL: 'os.radece@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ostrmn1s/'
  },
  {
    ZAVSIF: 175,
    PRSMSS: 5082919000,
    NAZIV: 'Osnovna šola Kajetana Koviča Radenci',
    NASLOV: 'Radgonska cesta 10',
    'POŠTNA ŠTEVILKA': 9252,
    POŠTA: 'Radenci',
    EMAIL: 'pp@os-radenci.si',
    URL: 'http://www.os-radenci.si/'
  },
  {
    ZAVSIF: 174,
    PRSMSS: 5084776000,
    NAZIV: 'Osnovna šola Kapela',
    NASLOV: 'Kapelski Vrh 95',
    'POŠTNA ŠTEVILKA': 9252,
    POŠTA: 'Radenci',
    EMAIL: 'o-kapela.ms@guest.arnes.si',
    URL: 'http://www.os-kapela.si'
  },
  {
    ZAVSIF: 425,
    PRSMSS: 5089271000,
    NAZIV: 'Osnovna šola Radlje ob Dravi',
    NASLOV: 'Koroška cesta 17',
    'POŠTNA ŠTEVILKA': 2360,
    POŠTA: 'Radlje ob Dravi',
    EMAIL: 'info@osradlje.si',
    URL: 'http://www.osradlje.si/'
  },
  {
    ZAVSIF: 431,
    PRSMSS: 5087341000,
    NAZIV: 'Osnovna šola Antona Tomaža Linharta Radovljica',
    NASLOV: 'Kranjska cesta 27',
    'POŠTNA ŠTEVILKA': 4240,
    POŠTA: 'Radovljica',
    EMAIL: 'o-atlr.kr@guest.arnes.si',
    URL: 'http://osatl.si'
  },
  {
    ZAVSIF: 435,
    PRSMSS: 5087325000,
    NAZIV: 'Osnovna šola F. S. Finžgarja Lesce',
    NASLOV: 'Begunjska cesta 7',
    'POŠTNA ŠTEVILKA': 4248,
    POŠTA: 'Lesce',
    EMAIL: 'info@oslesce.si',
    URL: 'http://www.oslesce.si/'
  },
  {
    ZAVSIF: 433,
    PRSMSS: 5087333000,
    NAZIV: 'Osnovna šola Staneta Žagarja Lipnica',
    NASLOV: 'Lipnica 12',
    'POŠTNA ŠTEVILKA': 4245,
    POŠTA: 'Kropa',
    EMAIL: 'tajnistvo@o-lipnica.kr.mss.edus.si',
    URL: 'http://www.os-lipnica.si/'
  },
  {
    ZAVSIF: 439,
    PRSMSS: 5185815000,
    NAZIV: 'Osnovna šola "Koroški jeklarji" Ravne na Koroškem',
    NASLOV: 'Javornik 35',
    'POŠTNA ŠTEVILKA': 2390,
    POŠTA: 'Ravne na Koroškem',
    EMAIL: 'o-kojeravne.mb@guest.arnes.si',
    URL: 'http://koroskijeklarji.mojasola.si'
  },
  {
    ZAVSIF: 438,
    PRSMSS: 5087392000,
    NAZIV: 'Osnovna šola Prežihovega Voranca Ravne na Koroškem',
    NASLOV: 'Gozdarska pot 11',
    'POŠTNA ŠTEVILKA': 2390,
    POŠTA: 'Ravne na Koroškem',
    EMAIL: 'o-pvravne.mb@guest.arnes.si',
    URL: 'http://www.os-prezih.si'
  },
  {
    ZAVSIF: 327,
    PRSMSS: 5089344000,
    NAZIV: 'Osnovna šola Janeza Kuharja Razkrižje',
    NASLOV: 'Šafarsko 24 C',
    'POŠTNA ŠTEVILKA': 9246,
    POŠTA: 'Razkrižje',
    EMAIL: 'ravnatelj@o-razkriz.ms.mss.edus.si',
    URL: 'http://www.o-razkrizje.ms.edus.si/'
  },
  {
    ZAVSIF: 6688,
    PRSMSS: 5171008000,
    NAZIV: 'Osnovna šola Rečica ob Savinji',
    NASLOV: 'Rečica ob Savinji 152',
    'POŠTNA ŠTEVILKA': 3332,
    POŠTA: 'Rečica ob Savinji',
    EMAIL: 'os.recica@guest.arnes.si',
    URL: 'http://www.osrecica.si/'
  },
  {
    ZAVSIF: 369,
    PRSMSS: 5089034000,
    NAZIV: 'Osnovna šola Lucijana Bratkoviča Bratuša Renče',
    NASLOV: 'Trg 31',
    'POŠTNA ŠTEVILKA': 5292,
    POŠTA: 'Renče',
    EMAIL: 'oslbbr@os-rence.si',
    URL: 'http://www.os-rence.si'
  },
  {
    ZAVSIF: 445,
    PRSMSS: 5087449000,
    NAZIV: 'Osnovna šola dr. Franceta Prešerna',
    NASLOV: 'Šolska ulica 2',
    'POŠTNA ŠTEVILKA': 1310,
    POŠTA: 'Ribnica',
    EMAIL: 'osribnica@guest.arnes.si',
    URL: 'http://www.osribnica.si'
  },
  {
    ZAVSIF: 428,
    PRSMSS: 5087252000,
    NAZIV: 'Osnovna šola Ribnica na Pohorju',
    NASLOV: 'Ribnica na Pohorju 29',
    'POŠTNA ŠTEVILKA': 2364,
    POŠTA: 'Ribnica na Pohorju',
    EMAIL: 'o-ribnica.mb@guest.arnes.si',
    URL: 'http://www.osribnicanapohorju.si/'
  },
  {
    ZAVSIF: 497,
    PRSMSS: 5087953000,
    NAZIV: 'JVIZ I. Osnovna šola Rogaška Slatina',
    NASLOV: 'Kidričeva ulica 24',
    'POŠTNA ŠTEVILKA': 3250,
    POŠTA: 'Rogaška Slatina',
    EMAIL: 'os1-rog.slatina@guest.arnes.si',
    URL: 'http://www.o-1osrs.ce.edus.si/'
  },
  {
    ZAVSIF: 498,
    PRSMSS: 5278945000,
    NAZIV: 'VIZ II. OŠ Rogaška Slatina',
    NASLOV: 'Ulica Kozjanskega odreda 4',
    'POŠTNA ŠTEVILKA': 3250,
    POŠTA: 'Rogaška Slatina',
    EMAIL: 'iios.rogaska@guest.arnes.si',
    URL: 'http://www.iios-rogaska.com'
  },
  {
    ZAVSIF: 354,
    PRSMSS: 5085705000,
    NAZIV: 'Osnovna šola Sveti Jurij',
    NASLOV: 'Sveti Jurij 13',
    'POŠTNA ŠTEVILKA': 9262,
    POŠTA: 'Rogašovci',
    EMAIL: 'tajnistvo@ossvj.si',
    URL: 'http://www.o-rogasovci.ms.edus.si/'
  },
  {
    ZAVSIF: 500,
    PRSMSS: 5087970000,
    NAZIV: 'VIZ Osnovna šola Rogatec',
    NASLOV: 'Ptujska cesta 30',
    'POŠTNA ŠTEVILKA': 3252,
    POŠTA: 'Rogatec',
    EMAIL: 'os.rogatec@guest.arnes.si',
    URL: 'http://www.osrogatec.si'
  },
  {
    ZAVSIF: 588,
    PRSMSS: 5088852000,
    NAZIV: 'Osnovna šola Janka Glazerja Ruše',
    NASLOV: 'Lesjakova ulica 4',
    'POŠTNA ŠTEVILKA': 2342,
    POŠTA: 'Ruše',
    EMAIL: 'os-j.glazerja-ruse@guest.arnes.si',
    URL: 'http://www.glazer.si'
  },
  {
    ZAVSIF: 590,
    PRSMSS: 5085136000,
    NAZIV: 'Osnovna šola Selnica ob Dravi',
    NASLOV: 'Mariborska cesta 30',
    'POŠTNA ŠTEVILKA': 2352,
    POŠTA: 'Selnica ob Dravi',
    EMAIL: 'os.selnica@guest.arnes.si',
    URL: 'http://www.os-selnica.si'
  },
  {
    ZAVSIF: 149,
    PRSMSS: 5085349000,
    NAZIV: 'Osnovna šola Belokranjskega odreda Semič',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 8333,
    POŠTA: 'Semič',
    EMAIL: 'projekt1.osnmbo@guest.arnes.si',
    URL: 'http://www.osbos.si/'
  },
  {
    ZAVSIF: 450,
    PRSMSS: 5087473000,
    NAZIV: 'Osnovna šola Blanca',
    NASLOV: 'Blanca 13',
    'POŠTNA ŠTEVILKA': 8283,
    POŠTA: 'Blanca',
    EMAIL: 'os.blanca@guest.arnes.si',
    URL: 'http://www.osblanca.si/'
  },
  {
    ZAVSIF: 449,
    PRSMSS: 5087481000,
    NAZIV: 'Osnovna šola Boštanj',
    NASLOV: 'Boštanj 54 A',
    'POŠTNA ŠTEVILKA': 8294,
    POŠTA: 'Boštanj',
    EMAIL: 'projekt.oskrbo@guest.arnes.si',
    URL: 'http://www.os-bostanj.si'
  },
  {
    ZAVSIF: 454,
    PRSMSS: 5087520000,
    NAZIV: 'Osnovna šola Krmelj',
    NASLOV: 'Krmelj 104',
    'POŠTNA ŠTEVILKA': 8296,
    POŠTA: 'Krmelj',
    EMAIL: 'os.krmelj@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskkkr3s/'
  },
  {
    ZAVSIF: 455,
    PRSMSS: 5089328000,
    NAZIV: 'Osnovna šola Milan Majcen Šentjanž',
    NASLOV: 'Šentjanž 58 A',
    'POŠTNA ŠTEVILKA': 8297,
    POŠTA: 'Šentjanž',
    EMAIL: 'os.mm-sentjanz@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oskkmm1s/home.html'
  },
  {
    ZAVSIF: 451,
    PRSMSS: 5087490000,
    NAZIV: 'Osnovna šola Sava Kladnika Sevnica',
    NASLOV: 'Trg svobode 42',
    'POŠTNA ŠTEVILKA': 8290,
    POŠTA: 'Sevnica',
    EMAIL: 'ossevnica@ossevnica.si',
    URL: 'http://www.ossevnica.si'
  },
  {
    ZAVSIF: 453,
    PRSMSS: 5087503000,
    NAZIV: 'Osnovna šola Tržišče',
    NASLOV: 'Tržišče 35',
    'POŠTNA ŠTEVILKA': 8295,
    POŠTA: 'Tržišče',
    EMAIL: 'o-trzisce.nm@guest.arnes.si',
    URL: 'http://www2.arnes.si/~otrziscenm/'
  },
  {
    ZAVSIF: 459,
    PRSMSS: 5087546000,
    NAZIV: 'Osnovna šola Dutovlje',
    NASLOV: 'Dutovlje 135',
    'POŠTNA ŠTEVILKA': 6221,
    POŠTA: 'Dutovlje',
    EMAIL: 'os-dutovlje@guest.arnes.si',
    URL: 'http://www.os-dutovlje.si/'
  },
  {
    ZAVSIF: 456,
    PRSMSS: 5210429000,
    NAZIV: 'Osnovna šola Srečka Kosovela Sežana',
    NASLOV: 'Kosovelova ulica 6',
    'POŠTNA ŠTEVILKA': 6210,
    POŠTA: 'Sežana',
    EMAIL: 'os@sezana.net',
    URL: 'http://os.sezana.net'
  },
  {
    ZAVSIF: 969,
    PRSMSS: 5635772000,
    NAZIV: 'Druga osnovna šola Slovenj Gradec',
    NASLOV: 'Kopališka ulica 29',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'group1.ossgii@guest.arnes.si',
    URL: 'http://www.druga-os.si'
  },
  {
    ZAVSIF: 466,
    PRSMSS: 5087597000,
    NAZIV: 'Osnovna šola Podgorje pri Slovenj Gradcu',
    NASLOV: 'Podgorje 172',
    'POŠTNA ŠTEVILKA': 2381,
    POŠTA: 'Podgorje pri Slovenj Gradcu',
    EMAIL: 'projekt3.ossgpo@guest.arnes.si',
    URL: 'http://www.ospodgorje.si/'
  },
  {
    ZAVSIF: 462,
    PRSMSS: 5089409000,
    NAZIV: 'Osnovna šola Šmartno pri Slovenj Gradcu',
    NASLOV: 'Šmartno pri Slovenj Gradcu 69',
    'POŠTNA ŠTEVILKA': 2383,
    POŠTA: 'Šmartno pri Slovenj Gradcu',
    EMAIL: 'os.smartno-sg@guest.arnes.si',
    URL: 'http://os-smartnosg.mojasola.si/'
  },
  {
    ZAVSIF: 463,
    PRSMSS: 5089395000,
    NAZIV: 'Prva osnovna šola Slovenj Gradec',
    NASLOV: 'Šercerjeva ulica 7',
    'POŠTNA ŠTEVILKA': 2380,
    POŠTA: 'Slovenj Gradec',
    EMAIL: 'tajnistvo.ossgprv@guest.arnes.si',
    URL: 'http://www.prva-os-sg.si'
  },
  {
    ZAVSIF: 477,
    PRSMSS: 5090032000,
    NAZIV: 'Osnovna šola Antona Ingoliča Spodnja Polskava',
    NASLOV: 'Spodnja Polskava 240',
    'POŠTNA ŠTEVILKA': 2331,
    POŠTA: 'Pragersko',
    EMAIL: 'o-sppolskava.mb@guest.arnes.si',
    URL: 'http://www.os-antona-ingolica.si'
  },
  {
    ZAVSIF: 474,
    PRSMSS: 5087635000,
    NAZIV: 'Osnovna šola dr. Jožeta Pučnika Črešnjevec',
    NASLOV: 'Črešnjevec 47',
    'POŠTNA ŠTEVILKA': 2310,
    POŠTA: 'Slovenska Bistrica',
    EMAIL: 'o-cresnjevec.mb@guest.arnes.si',
    URL: 'http://www.cresnjevec.si'
  },
  {
    ZAVSIF: 473,
    PRSMSS: 5087643000,
    NAZIV: 'Osnovna šola Gustava Šiliha Laporje',
    NASLOV: 'Laporje 31',
    'POŠTNA ŠTEVILKA': 2318,
    POŠTA: 'Laporje',
    EMAIL: 'group1.osmbgs@guest.arnes.si',
    URL: 'http://www.os-laporje.si'
  },
  {
    ZAVSIF: 471,
    PRSMSS: 5012554000,
    NAZIV: 'Osnovna šola Partizanska bolnišnica Jesen Tinje',
    NASLOV: 'Veliko Tinje 29',
    'POŠTNA ŠTEVILKA': 2316,
    POŠTA: 'Zgornja Ložnica',
    EMAIL: 'ravnatelj@o-tinje.mb.mss.edus.si',
    URL: 'http://684.gvs.arnes.si/cms/'
  },
  {
    ZAVSIF: 468,
    PRSMSS: 5087686000,
    NAZIV: 'Osnovna šola Pohorskega odreda Slovenska Bistrica',
    NASLOV: 'Kopališka ulica 1',
    'POŠTNA ŠTEVILKA': 2310,
    POŠTA: 'Slovenska Bistrica',
    EMAIL: 'group2.osmbpo@guest.arnes.si',
    URL: 'http://www.ospo-slb.si/'
  },
  {
    ZAVSIF: 470,
    PRSMSS: 5089425000,
    NAZIV: 'Osnovna šola Šmartno na Pohorju',
    NASLOV: 'Šmartno na Pohorju 24 A',
    'POŠTNA ŠTEVILKA': 2315,
    POŠTA: 'Šmartno na Pohorju',
    EMAIL: 'project1.osmbsp@guest.arnes.si',
    URL: 'http://www.smartno-poh.si/cms/'
  },
  {
    ZAVSIF: 14849,
    PRSMSS: 3348008000,
    NAZIV: '2. osnovna šola Slovenska Bistrica',
    NASLOV: 'Šolska ulica 5',
    'POŠTNA ŠTEVILKA': 2310,
    POŠTA: 'Slovenska Bistrica',
    EMAIL: 'info@2os-slb.si',
    URL: ''
  },
  {
    ZAVSIF: 609,
    PRSMSS: 5089433000,
    NAZIV: 'Osnovna šola Loče',
    NASLOV: 'Šolska ulica 5',
    'POŠTNA ŠTEVILKA': 3215,
    POŠTA: 'Loče',
    EMAIL: 'info@osloce.si',
    URL: 'http://www.osloce.si/'
  },
  {
    ZAVSIF: 607,
    PRSMSS: 5089441000,
    NAZIV: 'Osnovna šola Ob Dravinji Slovenske Konjice',
    NASLOV: 'Ulica Dušana Jereba 1',
    'POŠTNA ŠTEVILKA': 3210,
    POŠTA: 'Slovenske Konjice',
    EMAIL: 'info@osobdravinji.si',
    URL: 'http://www.osobdravinji.si/'
  },
  {
    ZAVSIF: 608,
    PRSMSS: 5087716000,
    NAZIV: 'Osnovna šola Pod goro Slovenske Konjice',
    NASLOV: 'Šolska ulica 3',
    'POŠTNA ŠTEVILKA': 3210,
    POŠTA: 'Slovenske Konjice',
    EMAIL: 'os.pod-goro@guest.arnes.si',
    URL: 'http://www.konjice.com/'
  },
  {
    ZAVSIF: 447,
    PRSMSS: 5087465000,
    NAZIV: 'Osnovna šola dr. Ivana Prijatelja Sodražica',
    NASLOV: 'Cesta Notranjskega odreda 10',
    'POŠTNA ŠTEVILKA': 1317,
    POŠTA: 'Sodražica',
    EMAIL: 'os-sodrazica@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osljip2s/index.htm'
  },
  {
    ZAVSIF: 395,
    PRSMSS: 5086426000,
    NAZIV: 'Osnovna šola Središče ob Dravi',
    NASLOV: 'Slovenska cesta 22',
    'POŠTNA ŠTEVILKA': 2277,
    POŠTA: 'Središče ob Dravi',
    EMAIL: 'os.sredisce-ob-dravi@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osmbsd2s/'
  },
  {
    ZAVSIF: 572,
    PRSMSS: 5085314000,
    NAZIV: 'Osnovna šola Starše',
    NASLOV: 'Starše 5',
    'POŠTNA ŠTEVILKA': 2205,
    POŠTA: 'Starše',
    EMAIL: 'os-starse@guest.arnes.si',
    URL: 'http://www.os-starse.si'
  },
  {
    ZAVSIF: 386,
    PRSMSS: 5086329000,
    NAZIV: 'Osnovna šola Vavta vas',
    NASLOV: 'Vavta vas 1',
    'POŠTNA ŠTEVILKA': 8351,
    POŠTA: 'Straža pri Novem mestu',
    EMAIL: 'os.vavta-vas@guest.arnes.si',
    URL: 'http://os-vavta-vas.si/'
  },
  {
    ZAVSIF: 248,
    PRSMSS: 5084865000,
    NAZIV: 'Osnovna šola Sveta Ana',
    NASLOV: 'Sv. Ana v Slov. goricah 14',
    'POŠTNA ŠTEVILKA': 2233,
    POŠTA: 'Sv. Ana v Slov. goricah',
    EMAIL: 'info@sveta-ana.org',
    URL: 'http://www.sveta-ana.org/'
  },
  {
    ZAVSIF: 250,
    PRSMSS: 5084024000,
    NAZIV: 'Osnovna šola in vrtec Sveta Trojica',
    NASLOV: 'Meznaričeva ulica 1',
    'POŠTNA ŠTEVILKA': 2235,
    POŠTA: 'Sv. Trojica v Slov. goricah',
    EMAIL: 'o-st.mb@guest.arnes.si',
    URL: 'http://www.ostrojica.si'
  },
  {
    ZAVSIF: 169,
    PRSMSS: 5083753000,
    NAZIV: 'Osnovna šola Sveti Jurij ob Ščavnici',
    NASLOV: 'Ulica Edvarda Kocbeka 4',
    'POŠTNA ŠTEVILKA': 9244,
    POŠTA: 'Sveti Jurij ob Ščavnici',
    EMAIL: '',
    URL: 'http://www.os-svjurij.si'
  },
  {
    ZAVSIF: 245,
    PRSMSS: 5090105000,
    NAZIV: 'Osnovna šola Jožeta Hudalesa Jurovski dol',
    NASLOV: 'Jurovski Dol 13',
    'POŠTNA ŠTEVILKA': 2223,
    POŠTA: 'Jurovski Dol',
    EMAIL: 'os.jurovskidol@guest.arnes.si',
    URL: 'http://www.os-jd.si'
  },
  {
    ZAVSIF: 389,
    PRSMSS: 5089166000,
    NAZIV: 'Osnovna šola Sveti Tomaž',
    NASLOV: 'Sveti Tomaž 11',
    'POŠTNA ŠTEVILKA': 2258,
    POŠTA: 'Sv.Tomaž',
    EMAIL: 'os.tomaz-ormoz@guest.arnes.si',
    URL: 'http://www.ostomaz.si'
  },
  {
    ZAVSIF: 347,
    PRSMSS: 5085713000,
    NAZIV: 'Osnovna šola Šalovci',
    NASLOV: 'Šalovci 172',
    'POŠTNA ŠTEVILKA': 9204,
    POŠTA: 'Šalovci',
    EMAIL: 'o-salovci.ms@guest.arnes.si',
    URL: 'http://www.os-salovci.si/'
  },
  {
    ZAVSIF: 366,
    PRSMSS: 5089069000,
    NAZIV: 'Osnovna šola Ivana Roba Šempeter pri Gorici',
    NASLOV: 'Ulica Andreja Gabrščka 1',
    'POŠTNA ŠTEVILKA': 5290,
    POŠTA: 'Šempeter pri Gorici',
    EMAIL: 'o-irsempeter.ng@guest.arnes.si',
    URL: 'http://www.os-iroba.si/'
  },
  {
    ZAVSIF: 233,
    PRSMSS: 5083249000,
    NAZIV: 'Osnovna šola Šenčur',
    NASLOV: 'Pipanova cesta 43',
    'POŠTNA ŠTEVILKA': 4208,
    POŠTA: 'Šenčur',
    EMAIL: 'group1.oskrsen@guest.arnes.si',
    URL: 'http://www.os-sencur.si/'
  },
  {
    ZAVSIF: 584,
    PRSMSS: 5086167000,
    NAZIV: 'Osnovna šola Rudolfa Maistra Šentilj',
    NASLOV: 'Mladinska ulica 13',
    'POŠTNA ŠTEVILKA': 2212,
    POŠTA: 'Šentilj v Slov. goricah',
    EMAIL: 'os.sentilj@guest.arnes.si',
    URL: 'http://www.ossentilj.si/'
  },
  {
    ZAVSIF: 585,
    PRSMSS: 5085144000,
    NAZIV: 'Osnovna šola Sladki Vrh',
    NASLOV: 'Sladki Vrh 8 A',
    'POŠTNA ŠTEVILKA': 2214,
    POŠTA: 'Sladki Vrh',
    EMAIL: 'info@os-sladki-vrh.com',
    URL: 'http://www.os-sladki-vrh.com'
  },
  {
    ZAVSIF: 382,
    PRSMSS: 5086299000,
    NAZIV: 'Osnovna šola Šentjernej',
    NASLOV: 'Prvomajska cesta 9',
    'POŠTNA ŠTEVILKA': 8310,
    POŠTA: 'Šentjernej',
    EMAIL: 'os.sentjernej@guest.arnes.si',
    URL: 'http://www.os-sentjernej.si'
  },
  {
    ZAVSIF: 1352,
    PRSMSS: 5087783000,
    NAZIV: 'Osnovna šola Blaža Kocena Ponikva',
    NASLOV: 'Ponikva 29 A',
    'POŠTNA ŠTEVILKA': 3232,
    POŠTA: 'Ponikva',
    EMAIL: 'tajnistvo@os-ponikva.si',
    URL: ''
  },
  {
    ZAVSIF: 478,
    PRSMSS: 5087775000,
    NAZIV: 'Osnovna šola Dramlje',
    NASLOV: 'Dramlje 7 A',
    'POŠTNA ŠTEVILKA': 3222,
    POŠTA: 'Dramlje',
    EMAIL: 'info@osdramlje.si',
    URL: ''
  },
  {
    ZAVSIF: 480,
    PRSMSS: 5087805000,
    NAZIV: 'Osnovna šola Franja Malgaja Šentjur',
    NASLOV: 'Ulica skladateljev Ipavcev 2',
    'POŠTNA ŠTEVILKA': 3230,
    POŠTA: 'Šentjur',
    EMAIL: 'tajnistvo@sem.fmalgaja.si',
    URL: 'http://sharepoint.os-fmalgaja.si/aktualno/default.aspx'
  },
  {
    ZAVSIF: 1241,
    PRSMSS: 5914914000,
    NAZIV: 'Osnovna šola Hruševec Šentjur',
    NASLOV: 'Gajstova pot 2 A',
    'POŠTNA ŠTEVILKA': 3230,
    POŠTA: 'Šentjur',
    EMAIL: 'os.hrusevec-sentjur@guest.arnes.si',
    URL: 'http://www.hrusevec.si'
  },
  {
    ZAVSIF: 479,
    PRSMSS: 5089450000,
    NAZIV: 'Osnovna šola Planina pri Sevnici',
    NASLOV: 'Planina pri Sevnici 69',
    'POŠTNA ŠTEVILKA': 3225,
    POŠTA: 'Planina pri Sevnici',
    EMAIL: 'o-planina.ce@guest.arnes.si',
    URL: 'http://www.os-planina.si/'
  },
  {
    ZAVSIF: 482,
    PRSMSS: 5087791000,
    NAZIV: 'Osnovna šola Slivnica pri Celju',
    NASLOV: 'Gorica pri Slivnici 61',
    'POŠTNA ŠTEVILKA': 3263,
    POŠTA: 'Gorica pri Slivnici',
    EMAIL: 'tajnistvo@os-slivnica.si',
    URL: 'http://www.os-slivnica.si'
  },
  {
    ZAVSIF: 516,
    PRSMSS: 5088089000,
    NAZIV: 'Osnovna šola dr. Pavla Lunačka Šentrupert',
    NASLOV: 'Šentrupert 57',
    'POŠTNA ŠTEVILKA': 8232,
    POŠTA: 'Šentrupert',
    EMAIL: 'info@os-sentrupert.si',
    URL: 'http://www.os-sentrupert.si'
  },
  {
    ZAVSIF: 373,
    PRSMSS: 5086388000,
    NAZIV: 'Osnovna šola Frana Metelka Škocjan',
    NASLOV: 'Škocjan 51',
    'POŠTNA ŠTEVILKA': 8275,
    POŠTA: 'Škocjan',
    EMAIL: 'os-skocjan@guest.arnes.si',
    URL: 'http://www.os-skocjan.si'
  },
  {
    ZAVSIF: 485,
    PRSMSS: 5087821000,
    NAZIV: 'Osnovna šola Cvetka Golarja Škofja Loka',
    NASLOV: 'Frankovo naselje 51',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: 'info.c-golar@guest.arnes.si',
    URL: 'http://www.oscg-info.si/'
  },
  {
    ZAVSIF: 483,
    PRSMSS: 5263620000,
    NAZIV: 'Osnovna šola Ivana Groharja',
    NASLOV: 'Podlubnik 1',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: 'os.ivanagroharja@guest.arnes.si',
    URL: 'http://www.groharca.si/'
  },
  {
    ZAVSIF: 484,
    PRSMSS: 5089468000,
    NAZIV: 'Osnovna šola Škofja Loka - Mesto',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 4220,
    POŠTA: 'Škofja Loka',
    EMAIL: '',
    URL: 'http://www.os-sl-mesto.si'
  },
  {
    ZAVSIF: 319,
    PRSMSS: 5084482000,
    NAZIV: 'Osnovna šola Škofljica',
    NASLOV: 'Klanec 5',
    'POŠTNA ŠTEVILKA': 1291,
    POŠTA: 'Škofljica',
    EMAIL: 'o-skofljica.lj@guest.arnes.si',
    URL: 'http://www.os-skofljica.si/'
  },
  {
    ZAVSIF: 495,
    PRSMSS: 5087988000,
    NAZIV: 'Osnovna šola Šmarje pri Jelšah',
    NASLOV: 'Vegova ulica 26',
    'POŠTNA ŠTEVILKA': 3240,
    POŠTA: 'Šmarje pri Jelšah',
    EMAIL: 'info@os-smarje.si',
    URL: 'http://www.os-smarje.si'
  },
  {
    ZAVSIF: 381,
    PRSMSS: 5086302000,
    NAZIV: 'Osnovna šola Šmarjeta',
    NASLOV: 'Šmarjeta 1',
    'POŠTNA ŠTEVILKA': 8220,
    POŠTA: 'Šmarješke Toplice',
    EMAIL: 'info@os-smarjeta.si',
    URL: ''
  },
  {
    ZAVSIF: 533,
    PRSMSS: 5088178000,
    NAZIV: 'Osnovna šola bratov Letonja Šmartno ob Paki',
    NASLOV: 'Šmartno ob Paki 117',
    'POŠTNA ŠTEVILKA': 3327,
    POŠTA: 'Šmartno ob Paki',
    EMAIL: 'os-bl-smartno@guest.arnes.si',
    URL: 'http://www.ossmartno.si'
  },
  {
    ZAVSIF: 263,
    PRSMSS: 5084083000,
    NAZIV: 'Osnovna šola Šmartno',
    NASLOV: 'Pungrt 9',
    'POŠTNA ŠTEVILKA': 1275,
    POŠTA: 'Šmartno pri Litiji',
    EMAIL: 'os.smartno-litija@guest.arnes.si',
    URL: 'http://www.os-smartnolitija.si'
  },
  {
    ZAVSIF: 10167,
    PRSMSS: 2136147000,
    NAZIV: 'Osnovna šola Karla Destovnika-Kajuha Šoštanj',
    NASLOV: 'Koroška cesta 7',
    'POŠTNA ŠTEVILKA': 3325,
    POŠTA: 'Šoštanj',
    EMAIL: 'os-sostanj@guest.arnes.si',
    URL: 'http://www.ossostanj.si/'
  },
  {
    ZAVSIF: 143,
    PRSMSS: 5082676000,
    NAZIV: 'Osnovna šola Štore',
    NASLOV: 'Ulica Cvetke Jerin 5',
    'POŠTNA ŠTEVILKA': 3220,
    POŠTA: 'Štore',
    EMAIL: 'os.store@siol.net',
    URL: 'http://www.os-store.si/'
  },
  {
    ZAVSIF: 352,
    PRSMSS: 5085721000,
    NAZIV: 'Osnovna šola Tišina',
    NASLOV: 'Tišina 4 B',
    'POŠTNA ŠTEVILKA': 9251,
    POŠTA: 'Tišina',
    EMAIL: 'tajnistvo@os-tisina.si',
    URL: 'http://www.os-tisina.si'
  },
  {
    ZAVSIF: 505,
    PRSMSS: 5089506000,
    NAZIV: 'Osnovna šola Dušana Muniha Most na Soči',
    NASLOV: 'Most na Soči 18 A',
    'POŠTNA ŠTEVILKA': 5216,
    POŠTA: 'Most na Soči',
    EMAIL: 'Projekt3.osngdm@guest.arnes.si',
    URL: 'http://www.os-mostnasoci.si'
  },
  {
    ZAVSIF: 506,
    PRSMSS: 5272653000,
    NAZIV: 'Osnovna šola Franceta Bevka Tolmin',
    NASLOV: 'Dijaška ulica 12 B',
    'POŠTNA ŠTEVILKA': 5220,
    POŠTA: 'Tolmin',
    EMAIL: 'os.tolmin@guest.arnes.si',
    URL: 'http://www.os-tolmin.si'
  },
  {
    ZAVSIF: 511,
    PRSMSS: 5088011000,
    NAZIV: 'Osnovna šola Simona Kosa Podbrdo',
    NASLOV: 'Podbrdo 32',
    'POŠTNA ŠTEVILKA': 5243,
    POŠTA: 'Podbrdo',
    EMAIL: 'os.podbrdo@guest.arnes.si',
    URL: 'http://www.o-podbrdo.ng.edus.si/'
  },
  {
    ZAVSIF: 1217,
    PRSMSS: 5889286000,
    NAZIV: 'Osnovna šola Ivana Cankarja Trbovlje',
    NASLOV: 'Trg Franca Fakina 8',
    'POŠTNA ŠTEVILKA': 1420,
    POŠTA: 'Trbovlje',
    EMAIL: 'os-ic.trbovlje@guest.arnes.si',
    URL: 'http://www.osic.si'
  },
  {
    ZAVSIF: 1218,
    PRSMSS: 5899508000,
    NAZIV: 'Osnovna šola Tončke Čeč Trbovlje',
    NASLOV: 'Keršičeva cesta 50',
    'POŠTNA ŠTEVILKA': 1420,
    POŠTA: 'Trbovlje',
    EMAIL: 'os-toncke-cec@os-toncke-cec.si',
    URL: 'http://www.os-toncke-cec.si/'
  },
  {
    ZAVSIF: 1216,
    PRSMSS: 5889235000,
    NAZIV: 'Osnovna šola Trbovlje',
    NASLOV: 'Mestni trg 6',
    'POŠTNA ŠTEVILKA': 1420,
    POŠTA: 'Trbovlje',
    EMAIL: 'info@ostrbovlje.si',
    URL: 'http://www.ostrbovlje.si'
  },
  {
    ZAVSIF: 513,
    PRSMSS: 5088097000,
    NAZIV: 'Osnovna šola Trebnje',
    NASLOV: 'Kidričeva ulica 11',
    'POŠTNA ŠTEVILKA': 8210,
    POŠTA: 'Trebnje',
    EMAIL: 'group1.osnmtre@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osnmtre1s/'
  },
  {
    ZAVSIF: 514,
    PRSMSS: 5088119000,
    NAZIV: 'Osnovna šola Veliki Gaber',
    NASLOV: 'Veliki Gaber 41',
    'POŠTNA ŠTEVILKA': 8213,
    POŠTA: 'Veliki Gaber',
    EMAIL: 'os.velikigaber-nm@guest.arnes.si',
    URL: 'http://www.os-velikigaber.si'
  },
  {
    ZAVSIF: 165,
    PRSMSS: 5255287000,
    NAZIV: 'Osnovna šola Trzin',
    NASLOV: 'Mengeška cesta 7 B',
    'POŠTNA ŠTEVILKA': 1236,
    POŠTA: 'Trzin',
    EMAIL: 'os-trzin@guest.arnes.si',
    URL: 'http://www.os-trzin.si'
  },
  {
    ZAVSIF: 520,
    PRSMSS: 5088135000,
    NAZIV: 'Osnovna šola Bistrica',
    NASLOV: 'Begunjska cesta 2',
    'POŠTNA ŠTEVILKA': 4290,
    POŠTA: 'Tržič',
    EMAIL: 'o-bistrica.kr@guest.arnes.si',
    URL: 'http://www.os-bistrica.si/'
  },
  {
    ZAVSIF: 519,
    PRSMSS: 5088127000,
    NAZIV: 'Osnovna šola Križe',
    NASLOV: 'Cesta Kokrškega odreda 16',
    'POŠTNA ŠTEVILKA': 4294,
    POŠTA: 'Križe',
    EMAIL: 'o-krize.kr@guest.arnes.si',
    URL: 'http://www.oskrize.si/'
  },
  {
    ZAVSIF: 521,
    PRSMSS: 5088143000,
    NAZIV: 'Osnovna šola Tržič',
    NASLOV: 'Šolska ulica 7',
    'POŠTNA ŠTEVILKA': 4290,
    POŠTA: 'Tržič',
    EMAIL: 'tajnistvo-os.trzic@guest.arnes.si',
    URL: 'http://www.ostrzic.si/'
  },
  {
    ZAVSIF: 259,
    PRSMSS: 5084059000,
    NAZIV: 'Osnovna šola Turnišče',
    NASLOV: 'Prešernova ulica 2',
    'POŠTNA ŠTEVILKA': 9224,
    POŠTA: 'Turnišče',
    EMAIL: 'o-turnisce.ms@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oturniscems/'
  },
  {
    ZAVSIF: 525,
    PRSMSS: 5088224000,
    NAZIV: 'Osnovna šola Antona Aškerca Velenje',
    NASLOV: 'Jenkova cesta 2',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'o-aavelenje.ce@guest.arnes.si',
    URL: 'http://www.o-aavelenje.ce.edus.si/'
  },
  {
    ZAVSIF: 526,
    PRSMSS: 5221340000,
    NAZIV: 'Osnovna šola Gorica Velenje',
    NASLOV: 'Goriška cesta 48',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'ivan.planinc@guest.arnes.si',
    URL: 'http://www.osgorica-velenje.si'
  },
  {
    ZAVSIF: 527,
    PRSMSS: 5088208000,
    NAZIV: 'Osnovna šola Gustava Šiliha Velenje',
    NASLOV: 'Vodnikova cesta 3',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'info.osgsv@gmail.com',
    URL: 'http://www.os-gustavasilihave.com/'
  },
  {
    ZAVSIF: 524,
    PRSMSS: 5081939000,
    NAZIV: 'Osnovna šola Livada Velenje',
    NASLOV: 'Efenkova cesta 60',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'o-livada.ce@guest.arnes.si',
    URL: 'http://www.os-livada.si'
  },
  {
    ZAVSIF: 528,
    PRSMSS: 5088216000,
    NAZIV: 'Osnovna šola Mihe Pintarja - Toleda Velenje',
    NASLOV: 'Kidričeva cesta 21',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'os.mpt-velenje@guest.arnes.si',
    URL: 'http://www.mpt-velenje.si/'
  },
  {
    ZAVSIF: 523,
    PRSMSS: 5278902000,
    NAZIV: 'Osnovna šola Šalek Velenje',
    NASLOV: 'Šalek 87',
    'POŠTNA ŠTEVILKA': 3320,
    POŠTA: 'Velenje',
    EMAIL: 'os-salek.velenje@guest.arnes.si',
    URL: 'http://www2.arnes.si/~oscesa6s'
  },
  {
    ZAVSIF: 252,
    PRSMSS: 5089760000,
    NAZIV: 'Osnovna šola Miška Kranjca Velika Polana',
    NASLOV: 'Velika Polana 215 B',
    'POŠTNA ŠTEVILKA': 9225,
    POŠTA: 'Velika Polana',
    EMAIL: 'o-mkvpolana.ms@guest.arnes.si',
    URL: 'http://www2.arnes.si/~omkvpolanams/'
  },
  {
    ZAVSIF: 321,
    PRSMSS: 5084539000,
    NAZIV: 'Osnovna šola Primoža Trubarja Velike Lašče',
    NASLOV: 'Šolska ulica 11',
    'POŠTNA ŠTEVILKA': 1315,
    POŠTA: 'Velike Lašče',
    EMAIL: 'irena.budic@gues.arnes.si',
    URL: 'http://www2.arnes.si/~osljptvl1s'
  },
  {
    ZAVSIF: 3709,
    PRSMSS: 5051215000,
    NAZIV: 'Osnovna šola Veržej',
    NASLOV: 'Puščenjakova ulica 7',
    'POŠTNA ŠTEVILKA': 9241,
    POŠTA: 'Veržej',
    EMAIL: 'os-verzej.ms@guest.arnes.si',
    URL: 'http://www.os-verzej.si'
  },
  {
    ZAVSIF: 419,
    PRSMSS: 5087171000,
    NAZIV: 'Osnovna šola Videm',
    NASLOV: 'Videm pri Ptuju 47',
    'POŠTNA ŠTEVILKA': 2284,
    POŠTA: 'Videm pri Ptuju',
    EMAIL: 'info@solavidem.si',
    URL: 'http://solavidem.si/'
  },
  {
    ZAVSIF: 120,
    PRSMSS: 5083532000,
    NAZIV: 'Osnovna šola Draga Bajca Vipava',
    NASLOV: 'Vinarska cesta 4',
    'POŠTNA ŠTEVILKA': 5271,
    POŠTA: 'Vipava',
    EMAIL: 'group2.osngdb@guest.arnes.si',
    URL: 'http://www2.arnes.si/~osngdb2s'
  },
  {
    ZAVSIF: 610,
    PRSMSS: 5087724000,
    NAZIV: 'Osnovna šola Vitanje',
    NASLOV: 'Doliška cesta 1',
    'POŠTNA ŠTEVILKA': 3205,
    POŠTA: 'Vitanje',
    EMAIL: 'osvitanje@guest.arnes.si',
    URL: ''
  },
  {
    ZAVSIF: 311,
    PRSMSS: 5084377000,
    NAZIV: 'Osnovna šola Vodice',
    NASLOV: 'Ob šoli 2',
    'POŠTNA ŠTEVILKA': 1217,
    POŠTA: 'Vodice',
    EMAIL: 'projekt2.osljvo@guest.arnes.si',
    URL: 'http://www.o-vodice.lj.edus.si'
  },
  {
    ZAVSIF: 142,
    PRSMSS: 5084709000,
    NAZIV: 'Osnovna šola Antona Bezenška Frankolovo',
    NASLOV: 'Frankolovo 11',
    'POŠTNA ŠTEVILKA': 3213,
    POŠTA: 'Frankolovo',
    EMAIL: 'group1.oscef@guest.arnes.si',
    URL: 'http://www.os-frankolovo.si/'
  },
  {
    ZAVSIF: 141,
    PRSMSS: 5082684000,
    NAZIV: 'Osnovna šola Vojnik',
    NASLOV: 'Prušnikova ulica 14',
    'POŠTNA ŠTEVILKA': 3212,
    POŠTA: 'Vojnik',
    EMAIL: 'o-vojnik.ce@guest.arnes.si',
    URL: 'http://www2.arnes.si/~ovojnikce/'
  },
  {
    ZAVSIF: 545,
    PRSMSS: 5088526000,
    NAZIV: 'Osnovna šola Vransko - Tabor',
    NASLOV: 'Vransko 23',
    'POŠTNA ŠTEVILKA': 3305,
    POŠTA: 'Vransko',
    EMAIL: 'os.vransko@guest.arnes.si',
    URL: 'http://www.os-vransko.si/'
  },
  {
    ZAVSIF: 6687,
    PRSMSS: 1534980000,
    NAZIV: 'Osnovna šola Antona Martina Slomška Vrhnika',
    NASLOV: 'Pod Hruševco 33',
    'POŠTNA ŠTEVILKA': 1360,
    POŠTA: 'Vrhnika',
    EMAIL: 'osams-vrhnika@guest.arnes.si',
    URL: 'http://www.osams.si'
  },
  {
    ZAVSIF: 536,
    PRSMSS: 5088330000,
    NAZIV: 'Osnovna šola Ivana Cankarja Vrhnika',
    NASLOV: 'Lošca 1',
    'POŠTNA ŠTEVILKA': 1360,
    POŠTA: 'Vrhnika',
    EMAIL: 'group1.osljic@guest.arnes.si',
    URL: 'http://www.osivanacankarja.si/'
  },
  {
    ZAVSIF: 430,
    PRSMSS: 5087279000,
    NAZIV: 'Osnovna šola Vuzenica',
    NASLOV: 'Mladinska ulica 3',
    'POŠTNA ŠTEVILKA': 2367,
    POŠTA: 'Vuzenica',
    EMAIL: 'o-vuzenica.mb@guest.arnes.si',
    URL: 'http://osvuzenica.si/'
  },
  {
    ZAVSIF: 541,
    PRSMSS: 5088372000,
    NAZIV: 'Osnovna šola Ivana Kavčiča Izlake',
    NASLOV: 'Izlake 4',
    'POŠTNA ŠTEVILKA': 1411,
    POŠTA: 'Izlake',
    EMAIL: 'tajnistvo.ikavcica@guest.arnes.si',
    URL: 'http://www.o-izlake.tb.edus.si'
  },
  {
    ZAVSIF: 539,
    PRSMSS: 5088402000,
    NAZIV: 'Osnovna šola Ivana Skvarče',
    NASLOV: 'Cesta 9. avgusta 44',
    'POŠTNA ŠTEVILKA': 1410,
    POŠTA: 'Zagorje ob Savi',
    EMAIL: 'tajnistvo.iskvarce@guest.arnes.si',
    URL: 'http://www.o-iskvarce.tb.edus.si'
  },
  {
    ZAVSIF: 540,
    PRSMSS: 5088399000,
    NAZIV: 'Osnovna šola Toneta Okrogarja',
    NASLOV: 'Šolska ulica 1',
    'POŠTNA ŠTEVILKA': 1410,
    POŠTA: 'Zagorje ob Savi',
    EMAIL: 'tajnistvo@okrogar.si',
    URL: 'http://www.okrogar.si'
  },
  {
    ZAVSIF: 611,
    PRSMSS: 5087732000,
    NAZIV: 'Osnovna šola Zreče',
    NASLOV: 'Šolska cesta 3',
    'POŠTNA ŠTEVILKA': 3214,
    POŠTA: 'Zreče',
    EMAIL: 'os.zrece@guest.arnes.si',
    URL: 'http://www.oszrece.net/'
  },
  {
    ZAVSIF: 546,
    PRSMSS: 5088534000,
    NAZIV: 'I. osnovna šola Žalec',
    NASLOV: 'Šilihova ulica 1',
    'POŠTNA ŠTEVILKA': 3310,
    POŠTA: 'Žalec',
    EMAIL: 'o-zalec.ce@guest.arnes.si',
    URL: 'http://www.1os-zalec.si/'
  },
  {
    ZAVSIF: 544,
    PRSMSS: 5090059000,
    NAZIV: 'Osnovna šola Griže',
    NASLOV: 'Griže 1 A',
    'POŠTNA ŠTEVILKA': 3302,
    POŠTA: 'Griže',
    EMAIL: 'osce-grize@guest.arnes.si',
    URL: 'http://www.os-grize.si/'
  },
  {
    ZAVSIF: 543,
    PRSMSS: 5088569000,
    NAZIV: 'Osnovna šola Petrovče',
    NASLOV: 'Petrovče 32',
    'POŠTNA ŠTEVILKA': 3301,
    POŠTA: 'Petrovče',
    EMAIL: 'omspetrovcece@guest.arnes.si',
    URL: 'http://www.os-petrovce.si/'
  },
  {
    ZAVSIF: 549,
    PRSMSS: 5088577000,
    NAZIV: 'Osnovna šola Šempeter v Savinjski dolini',
    NASLOV: 'Šolska ulica 2',
    'POŠTNA ŠTEVILKA': 3311,
    POŠTA: 'Šempeter v Savinjski dolini',
    EMAIL: 'o-bjsempeter.ce@guest.arnes.si',
    URL: 'http://www.os-sempeter.com/prva.gi'
  },
  {
    ZAVSIF: 490,
    PRSMSS: 5087830000,
    NAZIV: 'Osnovna šola Železniki',
    NASLOV: 'Otoki 13',
    'POŠTNA ŠTEVILKA': 4228,
    POŠTA: 'Železniki',
    EMAIL: 'Uprava@OS-Zelezniki.si',
    URL: 'http://www.os-zelezniki.si'
  },
  {
    ZAVSIF: 1260,
    PRSMSS: 5968330000,
    NAZIV: 'Osnovna šola Žetale',
    NASLOV: 'Čermožiše 45 B',
    'POŠTNA ŠTEVILKA': 2287,
    POŠTA: 'Žetale',
    EMAIL: 'stefanija.ropic@sola-zetale.si',
    URL: 'http://www.sola-zetale.si/'
  },
  {
    ZAVSIF: 489,
    PRSMSS: 5089476000,
    NAZIV: 'Osnovna šola Žiri',
    NASLOV: 'Jobstova cesta 22',
    'POŠTNA ŠTEVILKA': 4226,
    POŠTA: 'Žiri',
    EMAIL: 'osziri@osziri.si',
    URL: 'http://www.osziri.si'
  },
  {
    ZAVSIF: 1229,
    PRSMSS: 5719062000,
    NAZIV: 'Osnovna šola Žirovnica',
    NASLOV: 'Zabreznica 4',
    'POŠTNA ŠTEVILKA': 4274,
    POŠTA: 'Žirovnica',
    EMAIL: 'valentin.sodja@os-zirovnica.org',
    URL: 'http://www.os-zirovnica.org'
  },
  {
    ZAVSIF: 388,
    PRSMSS: 5086272000,
    NAZIV: 'Osnovna šola Prevole',
    NASLOV: 'Prevole 32',
    'POŠTNA ŠTEVILKA': 8362,
    POŠTA: 'Hinje',
    EMAIL: 'o-prevole.nm@guest.arnes.si',
    URL: 'http://www.osprevole.si/'
  },
  {
    ZAVSIF: 387,
    PRSMSS: 5086337000,
    NAZIV: 'Osnovna šola Žužemberk',
    NASLOV: 'Baragova cesta 1',
    'POŠTNA ŠTEVILKA': 8360,
    POŠTA: 'Žužemberk',
    EMAIL: 'tajnistvo-os.zuzemberk@guest.arnes.si',
    URL: 'http://www.oszuzemberk.si'
  }
];
